import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { interval, Subscription } from "rxjs";
import { CloudProvider } from "../../../../core/models/cloudProvider";
import { Deployment } from "../../../../core/models/deployment";
import { UserRoleNames, UserRolesInt } from "../../../../core/models/users";
import { DeploymentService } from "../../../../core/services/deployment.service";
import { NavigationService } from "../../../../core/services/navigation.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HeaderService } from "../../../../core/services/header.service";
import { SyncConfigService } from "../../../../core/services/sync-config.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import {
  CloudTypes,
  Entities,
  Granularity,
  Graphs,
} from "../../../../core/models/globals";
import { QuickAccessControl } from "../../../../core/models/quickAccessControl";
import {
  ChartConfiguration,
  ChartData,
  ChartEvent,
  ChartOptions,
  ChartType,
} from "chart.js";
import { ChartsService } from "../../../../core/services/charts.service";
import {
  ActiveSessionsByProfile,
  CoreHoursByGroups,
  CoreHoursByUsers,
  CoresByApplicationI,
  CoreUsage,
  Dictionary,
  JobByApplicationGraphDataI,
  JobByApplicationI,
  JobByApplicationsPerDayI,
  JobByGroupI,
  JobByNodesI,
  JobByTagsI,
  JobByTagsPerDayI,
  JobByUserI,
  JobWaitTimeI,
  LicenseUsage,
  NodeAvailabilityI,
  NodeUsage,
  PrimeNonPrimCoresDataI,
  PrimeNonPrimeHoursJobs,
  RunningQueuedJobsPerNodeGroup,
  StorageUsage,
} from "../../../../core/models/charts";
import { DatePipe, formatDate } from "@angular/common";
import { BaseChartDirective } from "ng2-charts";
import { NodeService } from "../../../../core/services/node.service";
import { UserService } from "../../../../core/services/user.service";
import {
  NodeStartStopStatus,
  Session,
  SessionInfo,
  SessionLogPerUser,
} from "../../../../core/models/session";
import { SessionService } from "../../../../core/services/session.service";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { MakeUpperPipe } from "../../../../core/pipes/make-upper.pipe";
import { saveAs } from "file-saver";
import DatalabelsPlugin from "chartjs-plugin-datalabels";
import { Job, JobCountData, JobCountPerDay } from "../../../../core/models/job";
import { JobsService } from "../../../../core/services/jobs.service";
import { JobInfoDownloadComponent } from "../../modals/job-info-download/job-info-download.component";
import { NodeDescription } from "../../../../core/models/node";
import { MatDateRangePicker } from "@angular/material/datepicker";
@Component({
  selector: "app-reports-deployment-list",
  templateUrl: "./reports-deployment-list.component.html",
  styleUrls: ["./reports-deployment-list.component.scss"],
})
export class ReportsDeploymentListComponent implements OnInit {
  //dateFilterValue: string = '';
  showDateRangePicker: boolean = false;
  universalSub: Subscription;
  deploymentsList: Deployment[];

  depName =
    this.route.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"];
  isVdi: boolean = false;
  redirectSortVal: string | null;
  deployments: string[] = [];
  quickAccessControls: QuickAccessControl = {
    deployments: null,
    licenseServerNames: null,
  };

  userFilterValue = "none";
  wsValue = "none";
  selectedMetric = "all";
  dateFilterValue = "7 days";
  granularityValue = "One Day";
  selectedUser = "all";
  selectedDepMetric: string = "";
  selectedDepMetricFromDashboard: string = ""; // This deployment filter is used when we redirect from dashboard to see reports like cpu,ram,gpu on cliking guages.
  fromDashboard: boolean = false;
  disableApplyFilter: boolean = false;
  nodeUtilization: NodeUsage[];
  jobCountPerDay: JobCountPerDay[];
  isChecked: boolean = false;
  wsNames: string[] = [];
  hostWsNames: string[] = [];
  userNamesForSessionGraph: string[] = [];
  graphStartEnd: any[] = [];
  graphOption: any[] = [];
  graphConnDiscon: any = [];
  chartData: any = [];
  nodeGraphType: string = ""; // like cpu, gpu, ram, gpuMemory
  singleNodeSelectedMetric: string = "";
  myForm: FormGroup;
  colNames: Array<any> = ["Date", "Node", "Start", "End"];

  type = "Timeline";
  chartHeight = String(window.innerHeight * 0.21);
  chartWidth = String(window.innerWidth * 0.38);
  getRealTimeGraph: boolean = false;
  disableGranularity: boolean = false;
  nodeNames: { item_id: string; item_text: string }[] = [];
  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: "item_id",
    textField: "item_text",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  allChartsData: any = [];
  daysValue: string = "";
  loggedInUser: string;
  succeededJobs: number = 0;
  failedJobs: number = 0;
  cancelledJobs: number = 0;
  totalJobsCompleted: number = 0;
  queuedJobs: number = 0;
  runningJobs: number = 0;
  completedJobs: number = 0;
  submittedJobs: number = 0;
  totalJobSummary: number = 0;

  jobs: Job[];
  storageData: StorageUsage[] = [];
  coresData: CoreUsage[] = [];
  licenseUsage: LicenseUsage[] = [];
  availableGranularity = ["One Hour", "One Day", "One Week", "One Month"];
  availableGranularityCopy = [];
  userFilterFlag: boolean = true;

  currentDay = this.headerService.getUserNewDate();
  metric: string = this.selectedMetric;

  appNames: string[] = [];
  SingleNodeUtilizationValue: boolean = false;
  width: string = "80%";
  //chartHeight: string;
  showFilters: boolean = false;
  metricValue: string = "All Charts";
  userValue: string = "";
  wsNameValue: string = "";
  date: Date = this.headerService.getUserNewDate();
  currentDate: string = this.headerService.getUserNewDate().toISOString();
  //daysValue: string = '';
  downloadingPdf: boolean = false;
  graphRequests = {};
  public cpuGaugeValue = 95;
  gpuMemoryGaugeLabel = "GPU Memory";
  dataReloadSubscription: Subscription; // subscription for reloading/ refreshing data every 10seconds
  userSelected: string = "all";
  appSelected: string = "all";
  showJobData: boolean = false;
  MonthShort: string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  lineChartLegend = true;
  realRunningCores = [];
  realQueuedCores = [];
  realActiveCores = [];
  userNames: { item_id: string; item_text: string }[] = [];

  userGroupNames: { item_id: string; item_text: string }[] = [];
  jobTags: { item_id: string; item_text: string }[] = [];
  allVdi: boolean = true;
  allHpc: boolean = false;
  mixedDep: boolean = false;
  showError: boolean = false;
  errorMessage: string = "";
  activeSessionsPerDep: boolean = false;
  activeSessionsPerDepData: ActiveSessionsByProfile[];
  predefinedDatasets = [
    {
      data: [],
      label: "",
      backgroundColor: "rgba(255, 161, 181,0.2)",
      borderColor: "red",
      pointBackgroundColor: "rgba(77,83,96,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
      pointHoverBorderColor: "#fff",
      fill: "origin",
    },
    {
      data: [],
      label: "",
      backgroundColor: "rgba(0, 255, 0, 0.2)",
      borderColor: "green",
      pointBackgroundColor: "rgba(77,83,96,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(77,83,96,1)",
      fill: "origin",
    },
    {
      data: [],
      label: "",
      backgroundColor: "rgba(255,225,153,0.2)",
      borderColor: "gold",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)",
      fill: "origin",
    },
    {
      data: [],
      label: "",
      backgroundColor: "rgba(134,199,243,0.2)",
      borderColor: "blue",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)",
      fill: "origin",
    },
    {
      data: [],
      label: "",
      backgroundColor: "rgba(255, 127, 80, 0.2)",
      borderColor: "rgba(255, 127, 80, 1)",
      pointBackgroundColor: "rgba(255, 127, 80, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "rgba(255, 127, 80, 0.3)",
      pointHoverBorderColor: "#fff",
      fill: "origin",
    },
    {
      data: [],
      label: "",
      backgroundColor: "rgba(0, 128, 128, 0.2)",
      borderColor: "rgba(0, 128, 128, 1)",
      pointBackgroundColor: "rgba(0, 128, 128, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "rgba(0, 128, 128, 0.3)",
      pointHoverBorderColor: "#fff",
      fill: "origin",
    },
    {
      data: [],
      label: "",
      backgroundColor: "rgba(128, 128, 128, 0.2)",
      borderColor: "rgba(128, 128, 128, 1)",
      pointBackgroundColor: "rgba(128, 128, 128, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "rgba(128, 128, 128, 0.3)",
      pointHoverBorderColor: "#fff",
      fill: "origin",
    },
    {
      data: [],
      label: "",
      backgroundColor: "rgba(153, 102, 255, 0.2)",
      borderColor: "rgba(153, 102, 255, 1)",
      pointBackgroundColor: "rgba(153, 102, 255, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "rgba(153, 102, 255, 0.3)",
      pointHoverBorderColor: "#fff",
      fill: "origin",
    },
  ];
  nodeDescription: NodeDescription[] = [];
  showCheck: boolean = true;
  sessinfoPerUser: SessionLogPerUser[] = [];
  prevDate = new Date(
    new Date().setFullYear(this.currentDay.getFullYear() - 1)
  );
  todayDate = new Date();
  dateTimePeriod = new FormControl();
  differenceInDays;
  showOnlyMachineName = false;
  showOnlyDuration = false;
  showBothMachineAndTime = true;
  showUserNameAndTotalHours = true;
  nodeStatusList: NodeStartStopStatus[] = [];
  activeChartType = "bar";
  availableChartTypes = [];
  nodeGroupValue = "none";
  nodeGroups: string[] = [];
  nodeUtilizationByNodeGroup: NodeUsage[] = [];
  coreHoursDropdownSettings = {
    singleSelection: false,
    idField: "item_id",
    textField: "item_text",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 1,
    allowSearchFilter: true,
    limitSelection: -1,
  };
  coreHourUserNames: { item_id: string; item_text: string }[] = [];
  selectedJobTags: { item_id: string; item_text: string }[] = [];
  selectedJobTag: string = null;
  graphDataLabelsForm: FormGroup;
  chartNameLegend: string = null;
  applicationNames = [];
  selectedNodeGroups: string[] = this.nodeGroups;

  //#region [Chart declarations]
  //#region [Node Utilization]
  cpuUtilizationData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "CPU",
        backgroundColor: "rgba(255, 161, 181,0.3)",
        borderColor: "red",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
        pointHoverBorderColor: "#fff",
        fill: "origin",
      },
    ],
    labels: [],
  };
  cpuUtilizationOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        ticks: {
          font: {
            size: 10,
          },
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        max: 100,
        min: 0,
        ticks: {
          font: {
            size: 10,
          },
        },
        title: {
          display: true,
          text: "Usage in %",
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 5,
          boxHeight: 5,
          font: {
            size: 10,
          },
        },
      },
      datalabels: {
        display: false,
      },
    },
  };
  ramUtilizationOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        ticks: {
          font: {
            size: 10,
          },
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        max: 100,
        min: 0,
        ticks: {
          font: {
            size: 10,
          },
        },
        title: {
          display: true,
          text: "Usage in %",
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 5,
          boxHeight: 5,
          font: {
            size: 10,
          },
        },
      },
      subtitle: {
        display: true,
        text: "",
        padding: 5,
      },
      datalabels: {
        display: false,
      },
    },
  };
  gpuUtilizationOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        ticks: {
          font: {
            size: 10,
          },
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        max: 100,
        min: 0,
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 5,
          boxHeight: 5,
          font: {
            size: 10,
          },
        },
      },
      datalabels: {
        display: false,
      },
    },
  };
  nodeUtilizationType: ChartType = "line";
  specificUtilizationData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: "rgba(255,225,153,0.3)",
        borderColor: "gold",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
    ],
    labels: [],
  };
  specificUtilizationOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        max: 100,
        min: 0,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: "",
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };

  // node utilization
  nodeUtilizationOptionsTotal: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        max: 100,
        min: 0,
        title: {
          display: true,
          text: "Usage (%)"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: "Node Utilization (24 Hours)",
        position: "top",
      },
      subtitle: {
        display: true,
        text: "",
        padding: 5,
      },
      datalabels: {
        display: false,
      },
    },
  };
  nodeUtilizationOptionsTotalOffice: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        max: 100,
        min: 0,
        title: {
          display: true,
          text: "Usage (%)"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        // text: `Node Utilization (Office Hours) - ${this.dateFilterValue.replace("to", " to ")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        text: `Node Utilization (Office Hours)`,
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };
  nodeUtilizationOptionsNonOffice: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        max: 100,
        min: 0,
        title: {
          display: true,
          text: "Usage (%)"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        //        text: `Node Utilization (Non-Office Hours) - ${this.dateFilterValue.replace("to", " to ")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        text: `Node Utilization (Non-Office Hours)`,
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };
  nodeUtilizationDataTotal: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "CPU",
        backgroundColor: "rgba(255, 161, 181,0.3)",
        borderColor: "red",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
        pointHoverBorderColor: "#fff",
        fill: "origin",
      },
      {
        data: [],
        label: "RAM",
        backgroundColor: "rgba(0, 255, 0, 0.3)",
        borderColor: "green",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(77,83,96,1)",
        fill: "origin",
      },
      {
        data: [],
        label: "GPU",
        backgroundColor: "rgba(255,225,153,0.3)",
        borderColor: "gold",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
      {
        data: [],
        label: "GPU RAM",
        backgroundColor: "rgba(134,199,243,0.3)",
        borderColor: "blue",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
    ],
    labels: [],
  };
  nodeUtilizationDataOffice: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "CPU",
        backgroundColor: "rgba(255, 161, 181,0.3)",
        borderColor: "red",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
        pointHoverBorderColor: "#fff",
        fill: "origin",
      },
      {
        data: [],
        label: "RAM",
        backgroundColor: "rgba(0, 255, 0, 0.3)",
        borderColor: "green",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(77,83,96,1)",
        fill: "origin",
      },
      {
        data: [],
        label: "GPU",
        backgroundColor: "rgba(255,225,153,0.3)",
        borderColor: "gold",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
      {
        data: [],
        label: "GPU RAM",
        backgroundColor: "rgba(134,199,243,0.3)",
        borderColor: "blue",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
    ],
    labels: [],
  };
  nodeUtilizationDataNonOffice: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "CPU",
        backgroundColor: "rgba(255, 161, 181,0.3)",
        borderColor: "red",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
        pointHoverBorderColor: "#fff",
        fill: "origin",
      },
      {
        data: [],
        label: "RAM",
        backgroundColor: "rgba(0, 255, 0, 0.3)",
        borderColor: "green",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(77,83,96,1)",
        fill: "origin",
      },
      {
        data: [],
        label: "GPU",
        backgroundColor: "rgba(255,225,153,0.3)",
        borderColor: "gold",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
      {
        data: [],
        label: "GPU RAM",
        backgroundColor: "rgba(134,199,243,0.3)",
        borderColor: "blue",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
    ],
    labels: [],
  };

  activeSessionsByProfileData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "Active Sessions",
        backgroundColor: "rgba(255, 161, 181,0.3)",
        borderColor: "red",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
        pointHoverBorderColor: "#fff",
        fill: "origin",
      },
    ],
    labels: [],
  };
  activeSessionsByProfileOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        min: 0,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Active Sessions By Deployments - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };
  //#endregion

  //#region [jobs summary]
  allJobsOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job Status Summary - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "end",
        align: "end",
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
  };
  allJobsData: ChartData<"pie", number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  allJobsType: ChartType = "pie";
  allJobsLegend = true;
  allJobsPlugins = [DatalabelsPlugin]; //ChartDataLabels
  allJobsColors = [
    {
      backgroundColor: [
        "rgb(255, 161, 161)",
        "rgb(252, 180, 65)",
        "rgb(255, 255, 184)",
      ],
    },
  ];
  //#endregion

  //#region [Job Completed]
  jobsSummaryOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text:
          "Jobs Completed : " +
          this.completedJobs +
          ` Jobs - ${this.dateFilterValue
            .replace("to", " to ")
            .replace(" days", "")} ${
            this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
        position: "top",
      },
      datalabels: {
        anchor: "end",
        align: "end",
        display: (context) => {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
  };
  jobsSummaryData: ChartData<"pie", number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  jobsSummaryType: ChartType = "pie";
  jobsSummaryLegend = true;
  jobsSummaryPlugins = [DatalabelsPlugin];
  jobsSummaryColors = [
    {
      backgroundColor: [
        "rgb(255, 161, 161)",
        "rgb(252, 180, 65)",
        "rgb(255, 255, 184)",
      ],
    },
  ];
  //#endregion

  //#region [storage chart]
  storageChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        title: {
          display: true,
          text: "Date"
          }
        },
      'y-axis-0': {
        position: 'left',
        grid: {
          color: 'rgba(255,0,0,0.1)',
          borderColor: 'black',
        },
        min: 0,
        title: {
          display: true,
          text: 'Usage in GB'
        }
        },
      },
    plugins: {
      datalabels: {
        align: 'bottom',
        font: {
          weight: 'bold'
        },
        clamp: true, // Prevent labels from overflowing outside the chart area
        display: (context) => {
          if(this.selectedMetric == "Overview") return false;
          if(this.graphDataLabelsForm.get('storageUsage').value === false) {
            return false;
          }
          return true
        }
      },
    }
  };
  storageChartType: ChartType = 'line';
  storageChartLegend = false;
  storageChartPlugins = [DatalabelsPlugin];
  storageChartData: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'Storage',
        backgroundColor: 'rgba(255,0,0,0.3)',
        borderColor: 'red',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
      },
    ],
  };
  //#endregion

  //#region [cores per day]
  coresPerDayOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title:{
          display: true,
          text: "Applications"
        }
      },
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },

      title: {
        display: true,
        text: `Average Core Usage - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "end",
        align: "end",
        display: (context) => {
          return (
            +context.dataset.data[context.dataIndex] >
            this.getDataLabelUsableValue(this.coresPerDayData.datasets[0].data)
          );
        },
      },
    },
  };
  coresPerDayType: ChartType = "line";
  coresPerDayLegend = true;
  coresPerDayPlugins = [DatalabelsPlugin];
  coresPerDayData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Queued",
        backgroundColor: "#3498db",
        borderColor: "transparent",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        order: 1,
      },
      {
        data: [],
        label: "Running",
        backgroundColor: "#2ecc71",
        borderColor: "transparent",
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        fill: "origin",
      },
      {
        data: [],
        label: "Average Running Cores",
        fill: false,
        borderColor: "grey",
        backgroundColor: "grey",
        pointBackgroundColor: "grey",
        pointBorderColor: "grey",
        pointHoverBackgroundColor: "grey",
        pointHoverBorderColor: "grey",
        borderDash: [24, 12],
        radius: 0,
      },
      {
        data: [],
        label: "Active Cores",
        fill: false,
        backgroundColor: "red",
        borderColor: "red",
        pointBackgroundColor: "red",
        pointBorderColor: "red",
        pointHoverBackgroundColor: "red",
        pointHoverBorderColor: "red",
        radius: 0,
        tension: 0,
      },
      {
        data: [],
        label: "Median",
        fill: false,
        borderColor: "#7A9D54",
        borderDash: [8, 10],
        radius: 0,
      },
    ],
  };
  //#endregion

  //#region [JobCount chart]
  jobCountChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        ticks: {},
        title: {
          display: true,
          text: "Number Of Jobs"
        }
      }
      },
    plugins: {
      datalabels: {
        align: 'top',
        font: {
          weight: 'bold'
        },
        clamp: true, // Prevent labels from overflowing outside the chart area
        display: (context) => {
          if(this.selectedMetric == "Overview") return false;
          if(context.dataset.label === "Average Job Count" || context.dataset.label === "Median Job Count") {
            return false;
          }
          else if(context.dataset.label === "Job Submitted" && this.graphDataLabelsForm.get('jobCountSubmitted').value === false) {
            return false;
          }
          else if(context.dataset.label === "Succeeded" && this.graphDataLabelsForm.get('jobCountSucceeded').value === false) {
            return false;
          }
          else if(context.dataset.label === "Failed" && this.graphDataLabelsForm.get('jobCountFailed').value === false) {
            return false;
          }
          else if(context.dataset.label === "Cancelled" && this.graphDataLabelsForm.get('jobCountCancelled').value === false) {
            return false;
          }
          return +context.dataset.data[context.dataIndex] > 0
      },
        formatter: Math.round
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: `Job Submit count - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
    },
  };
  jobCountChartType: ChartType = "line";
  jobCountChartLegend = false;
  jobCountChartPlugins = [DatalabelsPlugin];
  jobCountChartData: ChartConfiguration['data'] = {
    datasets: [
      { data: [], label: "Job Submitted", order: 1, pointBackgroundColor: "#1f77b4", pointBorderColor: "#1f77b4", fill: false, borderColor: "#bcd7e8", radius: 3 },
      { data: [], label: "Succeeded", order: 1, pointBackgroundColor: "#FFB84C", pointBorderColor: "#FFB84C", fill: false, borderColor: "#FFB84C", radius: 3 },
      { data: [], label: "Failed", order: 1, pointBackgroundColor: "#F16767", pointBorderColor: "#F16767", fill: false, borderColor: "#F16767", radius: 3 },
      { data: [], label: "Cancelled", order: 1, pointBackgroundColor: "#A459D1", pointBorderColor: "#A459D1", fill: false, borderColor: "#A459D1", radius: 3 },
      { data: [], label: "Average Job Count", fill: false, pointBackgroundColor: '#557A46', borderColor: "#557A46", borderDash: [8,10], radius: 0 },
      { data: [], label: "Median Job Count", fill: false, pointBackgroundColor: '#7A9D54', borderColor: "#7A9D54", borderDash: [8,10], radius: 0 },
    ], labels: [] };
  //#endregion

  //#region [JOb By Application]
  jobByApplicationOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title:{
          display: true,
          text: "Applications"
        }
      },
      y: {
        beginAtZero: true,
        title:{
          display: true,
          text: "Number Of Jobs"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: `Job By Application - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobByApplicationType: ChartType = "bar";
  jobByApplicationData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Succeeded",
        backgroundColor: "#95cd41",
        borderColor: "#95cd41",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: "#95cd41",
        order: 1,
        stack: "a",
      },
      {
        data: [],
        label: "Cancelled",
        backgroundColor: "#f6d860",
        borderColor: "#f6d860",
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        hoverBackgroundColor: "#f6d860",
        fill: "origin",
        stack: "a",
      },
      {
        data: [],
        label: "Failed",
        fill: false,
        borderColor: "#ff4646",
        backgroundColor: "#ff4646",
        hoverBackgroundColor: "#ff4646",
        borderDash: [5, 3],
        radius: 0,
        stack: "a",
      },
    ],
  };
  jobByApplicationPlugins = [DatalabelsPlugin];

  jobByApplicationsPerDayChartData: ChartConfiguration["data"] = {
    datasets: [],
    labels: [],
  };
  jobByApplicationDataTemp: ChartConfiguration["data"] = {
    datasets: [],
    labels: [],
  };

  //#endregion

  //#region [Cores By Application]
  coresByApplicationChartOptions: ChartOptions = {
    responsive: false,
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        title: {
          display: true,
          text: "Applications",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        min: 0,
        title: {
          display: true,
          text: "Core Usage",
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Cores By Application - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        align: "end",
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 0;
        },
      },
    },
  };
  coresByApplicationChartType: ChartType = "bar";
  coresByApplicationChartData: ChartData<"bar"> = {
    datasets: [
      {
        data: [],
        label: "Cores",
        borderColor: "#95cd41",
        backgroundColor: "#95cd41",
        hoverBackgroundColor: "#95cd41",
        stack: "a",
      },
    ],
    labels: [],
  };
  coresByApplicationChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Job By wait time]
  jobWaitTimeChartOptions: ChartOptions = {
    responsive: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job Avg Wait Time ( In Mins ) - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
  };
  jobWaitTimeChartType: ChartType = "doughnut";
  jobWaitTimeChartData: ChartData<"doughnut"> = {
    labels: [],
    datasets: [{ data: [] }],
  };
  jobWaitTimeChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Job by nodes]
  jobByNodesOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {},
      y: {
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: `Job By Nodes - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobByNodesType: ChartType = "bar";
  jobByNodesData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Succeeded",
        backgroundColor: "#95cd41",
        borderColor: "#95cd41",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: "#95cd41",
        order: 1,
        stack: "a",
      },
      {
        data: [],
        label: "Cancelled",
        backgroundColor: "#f6d860",
        borderColor: "#f6d860",
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        hoverBackgroundColor: "#f6d860",
        fill: "origin",
        stack: "a",
      },
      {
        data: [],
        label: "Failed",
        fill: false,
        borderColor: "#ff4646",
        backgroundColor: "#ff4646",
        hoverBackgroundColor: "#ff4646",
        borderDash: [5, 3],
        radius: 0,
        stack: "a",
      },
    ],
  };
  jobByNodesPlugins = [DatalabelsPlugin];
  //  #endregion

  //#region [Job chart by tags]
  jobByTagsOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Tags"
        }
      },
      y: {
        beginAtZero: true,
        title:{
          display: true,
          text: "Number of Jobs"
        }
      },
    },
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: `Job By Tags - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobByTagsType: ChartType = "bar";
  jobByTagsData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Succeeded",
        backgroundColor: "#95cd41",
        borderColor: "#95cd41",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: "#95cd41",
        order: 1,
        stack: "a",
      },
      {
        data: [],
        label: "Cancelled",
        backgroundColor: "#f6d860",
        borderColor: "#f6d860",
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        hoverBackgroundColor: "#f6d860",
        fill: "origin",
        stack: "a",
      },
      {
        data: [],
        label: "Failed",
        fill: false,
        borderColor: "#ff4646",
        backgroundColor: "#ff4646",
        hoverBackgroundColor: "#ff4646",
        borderDash: [5, 3],
        radius: 0,
        stack: "a",
      },
    ],
  };
  jobByTagsPlugins = [DatalabelsPlugin];
  //#endregion

  // #region [Core Hours By Users]
  coreHoursByUsersChartOptions: ChartOptions = {
    responsive: false,
    scales: {
      x : {
        title: {
          display: true,
          text: "Users"
        }
      },
      y: {
        title: {
          display: true,
          text: "Core Hours"
        }
      }
    },
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Core Hours By Users - ${this.dateFilterValue.replace(
          "to",
          " to "
        )} ${this.dateFilterValue.includes("to") ? "" : ""}`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
  };
  coreHoursByUsersChartType: ChartType = "bar";
  coreHoursByUsersChartData: ChartData<"bar"> = {
    datasets: [
      {
        data: [],
        label: "Cores",
        backgroundColor: [],
        hoverBackgroundColor: [],
        borderColor: [],
      },
    ],
    labels: [],
  };
  coreHoursByUsersChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Core Hours BY Users Pie]
  coreHoursByUsersPieOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job Status Summary - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
        position: 'top',
        padding: 30
      },
      datalabels: {
        color: "black",
        display: true,
        //anchor: 'end', // Position of the data labels. 'start', 'center', or 'end'
        //align: 'end', // Alignment of the data labels. 'start', 'center', or 'end'
        //offset: 0, // Adjust the position of the data labels from the chart
        font: {
          weight: 'bold' // Optional, change the font weight of the data labels
        },
      },
    },
  };
  coreHoursByUsersPieData: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  coreHoursByUsersPieType: ChartType = 'pie';
  coreHoursByUsersPieLegend = true;
  coreHoursByUsersPiePlugins = [DatalabelsPlugin]; //ChartDataLabels
  coreHoursByUsersPieColors = [
    {
      backgroundColor: [],
    },
  ];
  //#endregion

  //#region [JOb by Users]
  jobByUserChartOptions: ChartOptions = {
    responsive: false,
    scales:{
      x: {
        title: {
          display: true,
          text: "Users"
        }
      },
      y: {
        title: {
          display: true,
          text: "Number of Jobs"
        }
      }
    },
    plugins: {
      legend: {
        display: false,
        position: "right",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job By Users - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
  };
  jobByUserChartType: ChartType = "bar";
  jobByUserChartData: ChartData<"bar"> = {
    datasets: [
      {
        data: [],
        label: "Succeeded",
        borderColor: "#95cd41",
        backgroundColor: "#95cd41",
        hoverBackgroundColor: "#95cd41",
        stack: "a",
      },
      {
        data: [],
        label: "Cancelled",
        borderColor: "#f6d860",
        backgroundColor: "#f6d860",
        hoverBackgroundColor: "#f6d860",
        stack: "a",
      },
      {
        data: [],
        label: "Failed",
        borderColor: "#ff4646",
        backgroundColor: "#ff4646",
        hoverBackgroundColor: "#ff4646",
        stack: "a",
      },
    ],
    labels: [],
  };
  jobByUserChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Job by groups]
  jobByGroupChartOptions: ChartOptions = {
    responsive: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Job By Groups - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
  };
  jobByGroupChartType: ChartType = "doughnut";
  jobByGroupChartData: ChartData<"doughnut"> = {
    datasets: [{ data: [] }],
    labels: [],
  };
  jobByGroupChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Node Availability]
  nodeAvailabilityChartOptions: ChartOptions = {
    responsive: false,
    scales: {
      x : {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        title: {
          display: true,
          text: "Number Of Nodes"
        }
      }
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: `Node Availability - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        align: "top",
        anchor: "end",
        font: {
          weight: "bold",
        },
        formatter: Math.round,
        display: function (context) {
          return +context.dataset.data[context.dataIndex] > 10;
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  nodeAvailabilityType: ChartType = "line";
  nodeAvailabilityLegend = true;
  nodeAvailabilityData: ChartData<"line"> = {
    datasets: [
      {
        data: [],
        label: "Busy",
        order: 1,
        backgroundColor: "#E8751A",
        borderColor: "orange",
        pointBackgroundColor: "#E8751A",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#E8751A",
        pointHoverBorderColor: "#fff",
        fill: false,
      },
      {
        data: [],
        label: "Available",
        order: 1,
        backgroundColor: "#76885B",
        borderColor: "#76885B",
        pointBackgroundColor: "#76885B",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#76885B",
        pointHoverBorderColor: "#fff",
        fill: false,
      },
      {
        data: [],
        label: "Unavailable",
        order: 1,
        backgroundColor: "#E72929",
        borderColor: "red",
        pointBackgroundColor: "#E72929",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#E72929",
        pointHoverBorderColor: "#fff",
        fill: false,
      },
      //       { data: [], label: "Nodes Average", fill: false, borderColor: "grey", borderDash: [10,4], radius: 0 },
    ],
    labels: [],
  };
  nodeAvailabilityPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Prime core usage]
  primeCoreUsageChartOptions: ChartOptions = {
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      x : {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        title: {
          display: true,
          text: "Average Cores"
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          boxWidth: 10,
        },
      },
      title: {
        display: true,
        text: `Prime - Avg Used and Queued Cores - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "end",
        align: "end",
        display: (context) => {
          return (
            +context.dataset.data[context.dataIndex] >
            this.getDataLabelUsableValue(
              this.primeCoreUsageChartData.datasets[0].data
            )
          );
        },
        font: {
          size: 10,
        },
      },
    },
    responsive: false,
  };
  primeCoreUsageChartType: ChartType = "bar";
  primeCoreUsageChartLegend = true;
  primeCoreUsageChartData: ChartData<"bar"> = {
    datasets: [
      {
        data: [],
        label: "Used",
        backgroundColor: [],
        hoverBackgroundColor: [],
        borderColor: [],
        hoverBorderColor: [],
        stack: "a",
      },
      {
        data: [],
        label: "Queued",
        backgroundColor: [],
        hoverBackgroundColor: [],
        borderColor: [],
        hoverBorderColor: [],
        stack: "a",
      },
    ],
    labels: [],
  };
  primeCoreUsageChartPlugins = [DatalabelsPlugin];
  //#endregion

  //#region [Non-Prime core usage]
  nonPrimeCoreUsageChartOptions: ChartOptions = {
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      x : {
        title: {
          display: true,
          text: "Date"
        }
      },
      y: {
        title: {
          display: true,
          text: "Average Cores"
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          boxWidth: 10,
        },
      },
      title: {
        display: true,
        text: `Non Prime - Avg Used and Queued Cores - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "end",
        align: "end",
        display: (context) => {
          return (
            +context.dataset.data[context.dataIndex] >
            this.getDataLabelUsableValue(
              this.nonPrimeCoreUsageChartData.datasets[0].data
            )
          );
        },
        font: {
          size: 10,
        },
      },
    },
    responsive: false,
  };
  nonPrimeCoreUsageChartType: ChartType = "bar";
  nonPrimeCoreUsageChartLegend = true;
  nonPrimeCoreUsageChartData: ChartData<"bar"> = {
    datasets: [
      { data: [], label: "Used", backgroundColor: [], stack: "a" },
      { data: [], label: "Queued", backgroundColor: [], stack: "a" },
    ],
    labels: [],
  };
  nonPrimeCoreUsageChartPlugins = [DatalabelsPlugin];
  //  #endregion

  // #region [Job Count by Day]
  jobCountByDayOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        min: 0,
        ticks: {
          stepSize: 10, // set the step size to 1 to show only integer values
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Total Jobs - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };
  jobCountByDayData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "Total Jobs Submit",
        backgroundColor: "rgba(255,225,153,0.3)",
        borderColor: "gold",
        pointBackgroundColor: "rgba(148,159,177,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(148,159,177,0.8)",
        fill: "origin",
      },
    ],
    labels: [],
  };
  // #endregion

  //#region [Individual Node Network Utilization]
  individualNodeNetworkUtilizationChartData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "Send",
        backgroundColor: "rgba(183, 244, 216,0.3)",
        borderColor: "lightgreen",
        pointBackgroundColor: "#e9fce9",
        pointBorderColor: "lightgreen",
        pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
        pointHoverBorderColor: "red",
        fill: "origin",
      },
      {
        data: [],
        label: "Receive",
        backgroundColor: "rgba(255,215,0,0.3)",
        borderColor: "gold",
        pointBackgroundColor: " #fffbe6",
        pointBorderColor: "gold",
        pointHoverBackgroundColor: "rgba(255,225,153,0.3)",
        pointHoverBorderColor: "red",
        fill: "origin",
      },
    ],
  };
  individualNodeNetworkUtilizationChartOptions: ChartConfiguration["options"] =
    {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0.5,
        },
      },
      scales: {
        x: {
          grid: {
            color: "rgba(255,0,0,0.1)",
            borderColor: "black",
          },
          ticks: {
            font: {
              size: 12,
            },
          },
        },
        "y-axis-0": {
          position: "left",
          grid: {
            color: "rgba(255,0,0,0.1)",
            borderColor: "black",
          },
          min: 0,
          ticks: {
            font: {
              size: 12,
            },
            //            callback: (value) => value + ' MB'
          },
          title: {
            display: true,
            text: "Network Usage (MB/Sec)",
          },
        },
      },
      plugins: {
        legend: {
          position: "top",
          labels: {
            boxWidth: 10,
            boxHeight: 10,
            font: {
              size: 12,
            },
          },
        },
        title: {
          display: true,
          text: `Network utilization - ${this.dateFilterValue
            .replace("to", " to ")
            .replace(" days", "")} ${
            this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
          position: "bottom",
        },
        subtitle: {
          display: true,
          text: "",
          padding: 5,
        },
        datalabels: {
          display: false,
        },
      },
    };
  individualNodeNetworkUtilizationChartType: ChartType = "line";
  individualNodeNetworkUtilizationChartPlugins = [DatalabelsPlugin];
  //  #endregion

  // #region [core hours bar chart]
  coreHoursByGroupsChartOptions: ChartConfiguration["options"] = {
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Core Hours By Groups - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        color: "white",
        display: (context) => {
          const threshold = this.getDataLabelUsableValue(
            this.coreHoursByGroupsChartData[0].data
          );
          return +context.dataset.data[context.dataIndex] > threshold;
        },
        formatter: Math.round,
      },
    },
    responsive: false,
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        title: {
          display: true,
          text: "User Groups",
        }
      },
      y: {
        ticks: {},
        title: {
          display: true,
          text: "Core Hours",
        },
      },
    },
  };
  coreHoursByGroupsChartType: ChartType = "bar";
  coreHoursByGroupsChartLegend = true;
  coreHoursByGroupsChartPlugins = [DatalabelsPlugin];
  coreHoursByGroupsChartData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Cores",
        backgroundColor: "#95cd41",
        borderColor: "#95cd41",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: "#95cd41",
        order: 1,
        stack: "a",
      },
    ],
  };
  //  #endregion

  //  #region [core hours pie chart]
  coreHoursByGroupsPieOptions: ChartConfiguration["options"] = {
    responsive: false,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Core Hour By Groups - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
        padding: 30,
      },
      datalabels: {
        color: "black",
        display: true,
        //         anchor: 'end', // Position of the data labels. 'start', 'center', or 'end'
        //       align: 'end', // Alignment of the data labels. 'start', 'center', or 'end'
        //     offset: 0, // Adjust the position of the data labels from the chart
        font: {
          weight: "bold", // Optional, change the font weight of the data labels
        },
      },
    },
  };
  coreHoursByGroupsPieData: ChartData<"pie", number[]> = {
    labels: [],
    datasets: [
      {
        data: [],
      },
    ],
  };
  coreHoursByGroupsPieType: ChartType = "pie";
  coreHoursByGroupsPieLegend = true;
  coreHoursByGroupsPiePlugins = [DatalabelsPlugin];
  coreHoursByGroupsPieColors = [
    {
      backgroundColor: [],
    },
  ];
  // #endregion

  //#region [HPC Units Consumed]
  hpcUnitsConsumedDataTotal: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: "rgba(255, 161, 181,0.2)",
        borderColor: "red",
        pointBackgroundColor: "rgba(77,83,96,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "rgba(255, 161, 181,0.2)",
        pointHoverBorderColor: "#fff",
        fill: "origin",
      },
    ],
    labels: [],
  };

  hpcUnitsConsumedOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        title: {
          text: "Date",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        title: {
          display: true,
          text: "HPC Units",
        },
        min: 0,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `HPC Units Consumed - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };
  //  #endregion

  //#region [CPU Usage by nodes chart]
  cpuUsageByNodesChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Node",
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "CPU Usage (%)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `CPU Usage By Nodes - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: (context) => {
          return (
            +context.dataset.data[context.dataIndex] >
            this.getDataLabelUsableValue(
              this.cpuUsageByNodesChartData.datasets[0].data
            )
          );
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  cpuUsageByNodesChartType: ChartType = "bar";
  cpuUsageByNodesChartData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: "#0072c6",
        borderColor: "#0072c6",
        pointBackgroundColor: "#0072c6",
        pointBorderColor: "#0072c6",
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a",
      },
    ],
  };
  cpuUsageByNodesChartPlugins = [DatalabelsPlugin];
  //  #endregion

  // #region [CPU Usage by node groups chart]
  cpuUsageByNodeGroupsChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Node Group",
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "CPU Usage (%)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `CPU Usage By Node Groups - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: (context) => {
          return (
            +context.dataset.data[context.dataIndex] >
            this.getDataLabelUsableValue(
              this.cpuUsageByNodeGroupsChartData.datasets[0].data
            )
          );
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  cpuUsageByNodeGroupsChartType: ChartType = "bar";
  cpuUsageByNodeGroupsChartData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: "#0072c6",
        borderColor: "#0072c6",
        pointBackgroundColor: "#0072c6",
        pointBorderColor: "#0072c6",
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a",
      },
    ],
  };
  cpuUsageByNodeGroupsChartPlugins = [DatalabelsPlugin];
  //  #endregion

  //#region [Core Usage by nodes chart]
  coreUsageByNodesChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Node",
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "Core Usage (%)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `Core Usage By Nodes - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: (context) => {
          return (
            +context.dataset.data[context.dataIndex] >
            this.getDataLabelUsableValue(
              this.coreUsageByNodesChartData.datasets[0].data
            )
          );
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  coreUsageByNodesChartType: ChartType = "bar";
  coreUsageByNodesChartData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: "#0072c6",
        borderColor: "#0072c6",
        pointBackgroundColor: "#0072c6",
        pointBorderColor: "#0072c6",
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a",
      },
    ],
  };
  coreUsageByNodesChartPlugins = [DatalabelsPlugin];
  //  #endregion

  //  #region [Core Usage by node groups chart]
  coreUsageByNodeGroupsChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Node Groups",
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "Core Usage (%)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        text: `Core Usage By Node Groups - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
        display: (context) => {
          return (
            +context.dataset.data[context.dataIndex] >
            this.getDataLabelUsableValue(
              this.coreUsageByNodeGroupsChartData.datasets[0].data
            )
          );
        },
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  coreUsageByNodeGroupsChartType: ChartType = "bar";
  coreUsageByNodeGroupsChartData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "",
        backgroundColor: "#0072c6",
        borderColor: "#0072c6",
        pointBackgroundColor: "#0072c6",
        pointBorderColor: "#0072c6",
        hoverBackgroundColor: "#0072c6",
        order: 1,
        stack: "a",
      },
    ],
  };
  coreUsageByNodeGroupsChartPlugins = [DatalabelsPlugin];
  //  #endregion

  //#region [JobDurationsByDay]
  jobDurationsByDayOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {},
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Timespan in minutes",
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          filter: (legendItem, chartData) => {
            //  Only show legend items for datasets that don't include 'Mean' in their label
            return !legendItem.text.includes("Mean");
          },
        },
      },
      title: {
        display: true,
        text: `Job Duration By Day - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        anchor: "center",
        align: "center",
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
  };
  jobDurationsByDayType: ChartType = "bar";
  jobDurationsByDayData: ChartConfiguration["data"] = {
    labels: [],
    datasets: [
      {
        data: [],
        label: "Run Time (Sum)",
        backgroundColor: "#95cd41",
        borderColor: "#95cd41",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: "#95cd41",
        order: 1,
      },
      {
        data: [],
        label: "Wait Time (Sum)",
        backgroundColor: "#f6d860",
        borderColor: "#f6d860",
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        hoverBackgroundColor: "#f6d860",
        fill: "origin",
      },
      {
        data: [],
        label: "Run Time (Avg)",
        backgroundColor: "#ED7D31",
        borderColor: "#ED7D31",
        pointBackgroundColor: "#3498db",
        pointBorderColor: "#3498db",
        hoverBackgroundColor: "#ED7D31",
        order: 1,
      },
      {
        data: [],
        label: "Wait Time (Avg)",
        backgroundColor: "#3876BF",
        borderColor: "#3876BF",
        pointBackgroundColor: "#2ecc71",
        pointBorderColor: "#2ecc71",
        hoverBackgroundColor: "#3876BF",
        fill: "origin",
      },
    ],
  };
  jobDurationsByDayPlugins = [DatalabelsPlugin];
  jobDurationsByDayBarColors = ["#95cd41", "#f6d860", "#ED7D31", "#3876BF"];
  //  #endregion

  // #region [JobByTagsPerDay]
  jobByTagsPerDayChartOptions: ChartConfiguration["options"] = {
    responsive: false,
    scales: {
      x: {
        title: {
          display: true,
          text : "Tags"
        }
      },
      y: {
        min: 0,
        ticks: {},
        title: {
          display: true,
          text: "Number Of Jobs"
        }
      },
    },
    plugins: {
      datalabels: {
        align: "top",
        font: {
          weight: "bold",
        },
        clamp: true, // Prevent labels from overflowing outside the chart area
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        text: `Job By Tags By Interval - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
    },
  };
  jobByTagsPerDayChartType: ChartType = "line";
  jobByTagsPerDayChartLegend = false;
  jobByTagsPerDayChartPlugins = [DatalabelsPlugin];
  jobByTagsPerDayChartData: ChartConfiguration["data"] = {
    datasets: [
      // {
      //  data: [],
      //   label: "NA",
      // order: 1,
      //  pointBackgroundColor: "#1f77b4",
      //  pointBorderColor: "#1f77b4",
      // fill: false,
      // borderColor: "#bcd7e8",
      //radius: 3,
      //}
    ],
    labels: [],
  };
  jobByTagsPerDayChartDataTemp: ChartConfiguration["data"] = {
    datasets: [],
    labels: [],
  };
  //#endregion

  //#region [Running and Queued Jobs Per Node Group]
runningQueuedJobsPerNodeGroupChartOptions: ChartConfiguration["options"] = {
  responsive: false,
  scales: {
    x: {},
    y: {
      min: 0,
      ticks: {},
      title: {
        display: true,
        text: "Average Number Of Jobs",
    },
  },
  },
  plugins: {
    datalabels: {
      align: "top",
      font: {
        weight: "bold",
      },
      clamp: true, // Prevent labels from overflowing outside the chart area

    },
    legend: {
      position: "bottom",
      labels: {
        boxWidth: 15,
        usePointStyle: true,
      },
    },
    title: {
      display: true,
      text: `Job By Node Group By Interval - ${this.dateFilterValue
        .replace("to", " to ")
        .replace(" days", "")} ${
        this.dateFilterValue.includes("to") ? "" : "Days"
      }`,
      position: "top",
    },
  },
};
runningQueuedJobsPerNodeGroupChartType: ChartType = "line";
runningQueuedJobsPerNodeGroupChartLegend = false;
runningQueuedJobsPerNodeGroupChartPlugins = [DatalabelsPlugin];
runningQueuedJobsPerNodeGroupChartData: ChartConfiguration["data"] = {
  datasets: [
  ],
  labels: [],
};
runningQueuedJobsPerNodeGroupDataTemp: ChartConfiguration["data"] = {
  datasets: [
  ],
  labels: [],
};
//#endregion

  //#region [Prime - Non Prime Hours Jobs Submission]
  primeNonPrimeHoursJobsSubmissionOptions: ChartConfiguration["options"] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      x: {
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
      },
      "y-axis-0": {
        position: "left",
        grid: {
          color: "rgba(255,0,0,0.1)",
          borderColor: "black",
        },
        min: 0,
        title: {
          display: true,
          text: "Number Of Jobs",
        },
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 20,
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Job Submit Count By Working Hours - ${this.dateFilterValue
          .replace("to", " to ")
          .replace(" days", "")} ${
          this.dateFilterValue.includes("to") ? "" : "Days"
        }`,
        position: "top",
      },
      datalabels: {
        display: false,
      },
    },
  };
  primeNonPrimeHoursJobsSubmissionType: ChartType = "line";
  primeNonPrimeHoursJobsSubmissionData: ChartConfiguration["data"] = {
    datasets: [
      {
        data: [],
        label: "Office Hours",
        backgroundColor: "#0072c6",
        borderColor: "#0072c6",
        pointBackgroundColor: "#0072c6",
        pointBorderColor: "#0072c6",
        hoverBackgroundColor: "#0072c6",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(77,83,96,1)",
        fill: false,
      },
      {
        data: [],
        label: "Non-Office Hours",
        backgroundColor: "black",
        borderColor: "black",
        pointBackgroundColor: "black",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "black",
        pointHoverBorderColor: "#fff",
        fill: false,
      }
    ],
    labels: [],
  };
  //#endregion

  //#endregion

  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;
  @ViewChild("pdfContent") pdfContent!: ElementRef;
  @ViewChild("pdfContentSessionEndStart")
  pdfContentSessionEndStart!: ElementRef;
  @ViewChild("pdfContentSessionConDisConnect")
  pdfContentSessionConDisConnect!: ElementRef;
  @ViewChild("chart") chart: any;
  @ViewChild('picker') picker!: MatDateRangePicker<Date>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private headerService: HeaderService,
    private deploymentService: DeploymentService,
    private spinner: NgxSpinnerService,
    private chartService: ChartsService,
    private nodeService: NodeService,
    private userService: UserService,
    private sessionService: SessionService,
    private fb: FormBuilder,
    private jobService: JobsService,
    private authenticationService: AuthenticationService,
    private elementRef: ElementRef,
    private datePipe: DatePipe,
  ) {
    this.onOptionClick = this.onOptionClick.bind(this);
  }



  async ngOnInit() {
    this.spinner.show("loadingGraphs");
    this.getAllWorkstationList(this.depName);
    if (this.depName.toLowerCase() == "all") {
      this.selectedDepMetric = "all";
      this.selectedDepMetricFromDashboard = "all";
    }
    this.checkDashboardRedirectSort();
    this.deploymentsList = this.deploymentService
      .getProfileInfoesFromSubject()
      ?.filter((x) => x.status == "Active");
    if (this.deployments) {
      this.spinner.hide("loadingGraphs");
    }
    this.headerService.QuickAccessDep.subscribe((deps) => {
      this.quickAccessControls.deployments = deps;
    });
    this.deployments = this.quickAccessControls.deployments.map(function (
      item
    ) {
      if (item.userRole != UserRolesInt.JobOperator) return item["name"];
    });
    this.deployments = this.deployments?.filter(function (item) {
      return typeof item === "string";
    });
    this.myForm = this.fb.group({
      userNames: [this.selectedItems],
      userGroupNames: [this.selectedItems],
      jobTags: [this.selectedItems],
      nodeNames: this.wsNames,
      coreHourUserNames: [this.selectedItems],
    });
    this.createGraphDataLabelForm();
    this.navService.subNavData(Entities.Reports);
    //    this.fromDashboard = true;
    this.spinner.hide("loadingGraphs");
  }

  applyFilters(metric, date, granularity, wsValue, user, toDownload?) {
    this.dateFilterValue = date;
    //this.selectedMetric = metric;
    this.wsValue = wsValue;
    this.selectedUser = user;
    this.spinner.show("loadingGraphs");
    this.disableButton();

    if (date?.indexOf("hr") != -1) {
      let days = date.trim().slice(0, -2);
      if (parseInt(days) <= 0 || parseInt(days) > 24) {
        this.snackbar.open("Hour value should be between 1 to 24", "Ok", {
          duration: 5000,
        });
        this.spinner.hide("loadingGraphs");
        return;
      }
    }

    if (date == "custom") {
      let startDate = formatDate(
        new Date(this.dateTimePeriod.value[0]),
        "dd/MM/yy",
        "en-US"
      )
        .split("/")
        .join("-");
      let endDate = formatDate(
        new Date(this.dateTimePeriod.value[1]),
        "dd/MM/yy",
        "en-US"
      )
        .split("/")
        .join("-");
      this.dateFilterValue = startDate + "to" + endDate;
      
      let newStartDate = new Date(this.dateTimePeriod.value[0]);
      let newEndDate = new Date(this.dateTimePeriod.value[0]);

      const differenceInMilliseconds = newEndDate.getTime() - newStartDate.getTime();
      this.differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

      if (this.differenceInDays == 0 || this.differenceInDays == 1) {
        this.granularityValue = Granularity.OneHour;
      } else {
        this.granularityValue = Granularity.OneDay;
      }
    } else {
      this.dateFilterValue = date;
    }

    //    #region [Check to get real time graph]
    //if (date == "2") {
    //  this.granularityValue = "One Hour";
    //  this.getRealTimeGraph = true;
    //}
    //else {
    //  this.getRealTimeGraph = false;
    //}
    //#endregion

    //if (this.activeSessionsPerDep) {
    //  this.getActiveSessionsPerDeployment(this.selectedDepMetric, toDownload);
    //  return;
    //}

    //Check to single node graphs on a page.
    //if (this.isChecked) {
    //  if (this.singleNodeSelectedMetric != 'all') {
    //    this.getSingleNodeSpecificChart(this.nodeGraphType, date, granularity, toDownload);
    //    return;
    //  }
    //  else {
    //    this.getAllSingleNodeSpecificChart(this.nodeGraphType, date, granularity, toDownload);
    //    return;
    //  }
    //}
    //if (this.selectedMetric == 'all') {
    //  if (this.fromDashboard) {
    //    this.wsValue = 'none';
    //    this.getSpecificGraphs(this.nodeGraphType, toDownload);
    //    //return;
    //  }
    //  else {
    //    //this.getAllVdiGraphs(this.wsValue, date, granularity);
    //    //this.spinner.hide("loadingGraphs");
    //  }
    //}

    if (this.selectedDepMetric == "all" && this.selectedMetric == "all") {
      this.loadAllCharts(toDownload);
      return;
    }
    // else if (this.depName.toLowerCase() != 'all') {
    else if (this.selectedDepMetric != "all" && this.selectedMetric == "all") {
      if (this.isVdi) {
        this.loadNodeUtilization(null, toDownload);
        //this.getActiveSessionsPerDeployment(this.depName, toDownload);
        //if (this.wsNames.length == 0) {
        //  this.snackbar.open(
        //    'No Workstation Attached To This Deployment...',
        //    'Ok',
        //    {
        //      duration: 5000,
        //    }
        //  );
        //  this.spinner.hide("loadingGraphs")
        //  return;
        //} else {
        //  this.loadNodeUtilization(toDownload);
        //}
      } else {
        this.loadOverviewChartsOfHpcDep();
      }
    } else {
      this.manageActiveChartType();
      switch (this.selectedMetric) {
        case Graphs.NodeUtilization:
          if (this.wsNames.length == 0) {
            this.snackbar.open(
              "No Workstation Attached To This Deployment...",
              "Ok",
              {
                duration: 5000,
              }
            );
            this.spinner.hide("loadingGraphs");
            return;
          } else {
            this.loadNodeUtilization(null, toDownload);
          }
          break;

        case Graphs.SessionGraph:
          if (this.selectedUser === "none") {
            this.snackbar.open("Please select the User.", "Ok", {
              duration: 5000,
            });
            this.spinner.hide("loadingGraphs");
            return;
          }
          this.getSessionData("Connect-Disconnect", true);
          this.getSessionData("Start-End", true);
          break;

        case Graphs.SingleNodeUtilization:
          if (wsValue != "none") {
            this.loadSingleNodeUtilization(wsValue, toDownload);
          } else {
            this.snackbar.open("Please Select Workstation...", "Ok", {
              duration: 5000,
            });
            this.spinner.hide("loadingGraphs");
            return;
          }
          break;

        case Graphs.JobSummary:
          this.loadCompletedJobs(toDownload);
          break;

        case Graphs.JobCompleted:
          this.loadJobSummary(toDownload);
          break;

        case Graphs.StorageUsage:
          this.loadStorageCharts(toDownload);
          break;

        case Graphs.CoreUsage:
          this.loadCoresPerDay(toDownload);
          break;

        case Graphs.JobDataCount:
          this.loadJobDataCount(toDownload);
          break;

        case Graphs.CoresByApplication:
          this.loadCoresByApplication(toDownload);
          break;

        case Graphs.JobByApplication:
          this.loadJobByApplicationData(toDownload);
          break;

        case Graphs.JobWaitTime:
          this.loadJobWaitTimeData(toDownload);
          break;

        case Graphs.NodeAvailability:
          this.loadNodeAvailabilityDataCount(toDownload);
          break;

        case Graphs.JobByUser:
          this.loadJobByUserData(toDownload);
          break;

        case Graphs.JobByGroup:
          this.loadJobByGroupsData(toDownload);
          break;

        case Graphs.JobByNodes:
          this.loadJobByNodesData(toDownload);
          break;

        case Graphs.JobByNodeGroup:
          this.loadJobByNodeGroup(toDownload);
          break;

        case Graphs.JobByTags:
          this.loadJobByTagsData(toDownload);
          break;

        case Graphs.CoreHoursByUsers:
          this.loadCoreHoursByUsers(toDownload);
          break;

        case Graphs.PrimeNonPrimeCoreUsage:
          this.getPrimeNonPrimeCoreHours(toDownload);
          break;

        case Graphs.ActiveSessions:
          this.getActiveSessionsPerDeployment(
            this.selectedDepMetric,
            toDownload
          );
          break;

        case Graphs.RAMUtilization:
          this.nodeGraphType = "ram";
          if (this.isChecked) {
            if (this.singleNodeSelectedMetric != "all") {
              this.getSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            } else {
              this.getAllSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            }
          } else {
            this.getSpecificGraphs(this.nodeGraphType, toDownload);
          }
          break;

        case Graphs.CPUUtilization:
          this.nodeGraphType = "cpu";
          if (this.isChecked) {
            if (this.singleNodeSelectedMetric != "all") {
              this.getSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            } else {
              this.getAllSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            }
          } else {
            this.getSpecificGraphs(this.nodeGraphType, toDownload);
          }
          break;

        case Graphs.GpuMemoryUtilization:
          this.nodeGraphType = "gpu";
          if (this.isChecked) {
            if (this.singleNodeSelectedMetric != "all") {
              this.getSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            } else {
              this.getAllSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            }
          } else {
            this.getSpecificGraphs(this.nodeGraphType, toDownload);
          }
          break;

        case Graphs.NetworkUtilization:
          this.nodeGraphType = "network";
          this.getHostMachines();
          if (this.isChecked) {
            if (this.singleNodeSelectedMetric != "all") {
              this.getSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            } else {
              this.getAllSingleNodeSpecificChart(
                this.nodeGraphType,
                date,
                granularity,
                toDownload
              );
              return;
            }
          } else {
            this.getSpecificGraphs(this.nodeGraphType, toDownload);
          }
          break;

        case Graphs.AllUserSessions:
          this.getSessionDataPerUser();
          break;

        case Graphs.AllUserSessionsPerHost:
          this.getSessionDataPerUserByHost();
          break;

        case Graphs.NodeStartStopStatus:
          this.getNodeStatusGraph();
          break;

        case Graphs.IndividualNodeNetworkUtilization:
          if (wsValue != "none" && wsValue != "") {
            this.loadSingleNodeUtilization(wsValue, toDownload);
          } else {
            this.snackbar.open("Please Select Workstation...", "Ok", {
              duration: 5000,
            });
            this.spinner.hide("loadingGraphs");
            return;
          }
          break;

        case Graphs.CoreHoursByGroups:
          this.loadCoreHoursByGroups(toDownload);
          break;

        case Graphs.NodeUtilizationByNodeGroup:
          if (this.nodeGroupValue == "none") {
            this.snackbar.open("Please Select Node Group...", "Ok", {
              duration: 5000,
            });
            this.spinner.hide("loadingGraphs");
            return;
          } else {
            this.loadNodeUtilization(this.nodeGroupValue, toDownload);
          }
          break;

        case Graphs.HpcUnitsConsumed:
          this.getHpcUnitsConsumedGraph(toDownload);
          break;

        case Graphs.CpuUsageByNodes:
          this.cpuUsageByNodes(toDownload);
          break;

        case Graphs.CpuUsageByNodeGroups:
          this.cpuUsageByNodeGroups(toDownload);
          break;

        case Graphs.CoreUsageByNodes:
          this.coreUsageByNodes(toDownload);
          break;

        case Graphs.CoreUsageByNodeGroups:
          this.coreUsageByNodeGroups(toDownload);
          break;

        case Graphs.JobDurationsByDay:
          this.loadAvgJobDurationsByDayData(toDownload);
          break;

        case Graphs.JobByTagsPerDay:
          this.loadJobByTagsPerDayData(toDownload);
          break;

        case Graphs.RunningQueuedJobsPerNodeGroup:
          this.loadRunningQueuedJobsPerNodeGroupsData(toDownload);
          break;

        case Graphs.PrimeNonPrimeJobSubmission:
          this.getPrimeNonPrimeHoursJobSubmissions(toDownload);
          break;

        default:
          this.snackbar.open(
            "Please select filter And click on appy filter...",
            "Ok",
            {
              duration: 5000,
            }
          );
          break;
      }
    }
//  }
    this.spinner.hide("loadingGraphs");
  }

  async checkDashboardRedirectSort() {
    this.redirectSortVal = this.deploymentService.dashboardReportRedirect;
    this.spinner.show("loadingGraphs");
    await this.deploymentService.getAllDeploymentsForUser().subscribe({
      next: async (data: any) => {
        this.spinner.hide("loadingGraphs");
        if (!data || data.length == 0) {
          if (
            this.authenticationService.currentUserValue.role ==
            UserRoleNames.GlobalAdmin
          ) {
            this.snackbar.open(
              "No Deployment Available to show reports.",
              "Ok",
              {
                duration: 2000,
              }
            );
            setTimeout(() => {
              this.router.navigate(["/Deployment List"]);
            }, 3000);
          }
        } else {
          if (this.redirectSortVal) {
            switch (this.redirectSortVal?.toLowerCase()) {
              case "ram":
                this.selectedMetric = Graphs.RAMUtilization;
                this.nodeGraphType = "ram";
                this.singleNodeSelectedMetric = "ram";
                this.getSpecificGraphs("ram", false);
                break;

              case "cpu":
                this.selectedMetric = Graphs.CPUUtilization;
                this.nodeGraphType = "cpu";
                this.singleNodeSelectedMetric = "cpu";
                this.getSpecificGraphs("cpu", false);
                break;

              case "gpu":
                this.selectedMetric = Graphs.GpuMemoryUtilization;
                this.nodeGraphType = "gpu";
                this.singleNodeSelectedMetric = "gpu";
                this.getSpecificGraphs("gpu", false);
                break;

              case "network":
                this.selectedMetric = Graphs.NetworkUtilization;
                this.getHostMachines();
                this.nodeGraphType = "network";
                this.singleNodeSelectedMetric = "network";
                this.getSpecificGraphs("network", false);
                break;

              case "sessionbydep":
                this.selectedMetric = Graphs.ActiveSessions;
                this.nodeGraphType = "activeSessionsByProfile";
                this.showCheck = false;
                this.activeSessionsPerDep = true;
                this.getActiveSessionsPerDeployment("all", false);
                break;

              default:
                this.selectedMetric = "all";
                break;
            }
          } else {
            this.showCheck = false;
            this.deploymentsList = <Deployment[]>(
              JSON.parse(JSON.stringify(data))
            );
            this.deploymentsList = this.deploymentsList.filter(
              (x) => x.status == "Active"
            );
            this.allVdi = this.deploymentsList.every((d) => {
              if (d.cloud == CloudTypes.KVM) {
                return true; // Ignore this entry
              }
              return d.numOfComputeNodes == -1;
            });
            if (this.allVdi) {
              this.getAllVdiGraphs(
                "none",
                this.dateFilterValue,
                this.granularityValue
              );
              return;
            }
            this.allHpc = this.deploymentsList.every(
              (d) => d.numOfComputeNodes != -1
            );
            if (this.allHpc) {
              this.getMixedDepGraphs();
              return;
            }
            this.mixedDep =
              this.deploymentsList.some((d) => {
                if (d.cloud == CloudTypes.KVM) {
                  return true; // Ignore this entry
                }
                return d.numOfComputeNodes == -1;
              }) &&
              this.deploymentsList.some((d) => {
                if (d.cloud == CloudTypes.KVM) {
                  return true; // Ignore this entry
                }
                return d.numOfComputeNodes != -1;
              });
            if (this.mixedDep) {
              this.getMixedDepGraphs();
              return;
            }
          }
        }
      },
      error: (error) => {
        this.spinner.hide("loadingGraphs");
        if (
          this.authenticationService.currentUserValue.role ==
          UserRoleNames.GlobalAdmin
        ) {
          this.router.navigate(["/Deployment List"]);
        }
      },
    });
  }

  checkIsVdiDeployment() {
    if (this.depName.toLowerCase() != "all") {
      this.spinner.show("loadingGraphs");
      this.deploymentService.checkIsVdi(this.depName).subscribe({
        next: (data) => {
          this.isVdi = Boolean(data);
          this.spinner.hide("loadingGraphs");
          this.applyFilters(
            "all",
            this.dateFilterValue,
            this.granularityValue,
            "",
            "",
            false
          );
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
    }
  }

  deploymentFilterApplied() {
    this.depName = this.selectedDepMetric;
    let dep = this.selectedDepMetric;
    if (dep.toLowerCase() == "all") {
      this.selectedMetric = "all";
      this.wsValue = "none";
      return;
    }
    if (
      ![
        Graphs.RAMUtilization.valueOf(),
        Graphs.CPUUtilization.valueOf(),
        Graphs.GpuMemoryUtilization.valueOf(),
        Graphs.NetworkUtilization.valueOf(),
      ].includes(this.selectedMetric)
    ) {
      this.isChecked = false;
    }
    this.checkIsVdiDeployment();
    this.getAllWorkstationList(dep);
    this.loadUsers();
    this.getUserName();
    this.getUserGroupNames();
    this.getJobTags();
  }

  disableButton() {
    this.disableApplyFilter = true;
    setTimeout(() => {
      this.disableApplyFilter = false;
    }, 3000);
  }

  downloadCsv(infos, headers, fileName) {
    let makeUpper = new MakeUpperPipe();
    headers
      .map((head) => (head = head.charAt(0).toUpperCase() + head.slice(1)))
      .forEach((head, index) => {
        headers[index] = makeUpper.transform(head);
      });

    const header = headers;
    let csv = infos.map((action) =>
      Object.keys(action)
        .map((key) => action[key])
        .join(",")
    );
    if (csv.every((c) => c == "")) {
      csv = [infos.join(",")];
    }
    csv.unshift(header.join(","));
    let csvArray = csv.join(" \r\n ");

    var blob = new Blob([csvArray], { type: "text/csv" });
    saveAs(blob, fileName);
  }

  downloadNodeUtilization() {
    this.snackbar.open("Preparing download. Please wait...", "Ok", {
      duration: 3000,
    });
    this.deploymentService
      .getCsvGraphData(this.depName)
      .subscribe((res: any) => {
        if (res?.data == "" || res?.data == null) {
          this.snackbar.open(
            "No Data available for the selected deployment",
            "Ok",
            {
              duration: 5000,
            }
          );
        } else {
          this.snackbar.open("Download is in progress", "Ok", {
            duration: 3000,
          });
          let x = res?.data;
          var blob = new Blob([x], { type: "text/csv" });
          saveAs(blob, `${this.depName}_Node_Utilization.csv`);
        }
      });
  }

  downloadSessionInfo() {
    this.snackbar.open("Preparing download. Please wait...", "Ok", {
      duration: 3000,
    });
    this.sessionService.downloadSessionInfo().subscribe({
      next: (data: any) => {
        try {
          let infoes = <Session[]>JSON.parse(JSON.stringify(data));
          let keys = Object.keys(infoes[0]);
          let newInfoes = infoes?.map((sess) => {
            return {
              ...sess,
              apps: sess.apps?.join(" | "),
            };
          });
          this.snackbar.open("Download is in progress", "Ok", {
            duration: 3000,
          });
          this.downloadCsv(
            newInfoes,
            keys,
            "sessionInfo_" +
              new DatePipe("en-US").transform(this.date, "yyyy-MM-dd_HH:mm:ss")
          );
        } catch (error) {}
      },
      error: (err) => {
        if (err.error.actionMessage) {
          this.snackbar.open(err.error.actionMessage, "Ok", {
            duration: 5000,
          });
        }
      },
    });
  }

  downloadJobData() {
    let dialog = this.dialog.open(JobInfoDownloadComponent, {
      width: "40%",
      autoFocus: true,
      disableClose: true,
      data: { depName: this.depName },
    });
    dialog.afterClosed().subscribe((res: string[]) => {
      if (res) {
        this.jobService
          .getJobDownloadInfo(this.depName, this.dateFilterValue)
          .subscribe({
            next: (data: any) => {
              try {
                this.snackbar.open("Job info will be downloaded soon...");
                let infoes: Job[] = JSON.parse(JSON.stringify(data));
                const redux = this.filterOutJobInfo(infoes, res);
                const ids = redux.map((o) => o.jobName);
                const filtered = redux.filter(
                  ({ jobName }, index) => !ids.includes(jobName, index + 1)
                );
                this.downloadCsv(filtered, res, `jobInfo_${this.depName}.csv`);
                this.snackbar.dismiss();
              } catch (error) {
                this.snackbar.dismiss();
              }
            },
            error: (err) => {
              if (err.error.actionMessage) {
                this.snackbar.open(err.error.actionMessage, "Ok", {
                  duration: 5000,
                });
              }
            },
          });
      }
    });
  }

  filterOutJobInfo(array: any, keys_to_keep) {
    let tempArr = [];
    array.map((o) =>
      keys_to_keep.reduce((acc, curr) => {
        let resWord = curr.charAt(0).toLowerCase() + curr.slice(1);
        acc[resWord] = o[resWord];
        tempArr.push(acc);
        return acc;
      }, {})
    );
    return tempArr;
  }

  getGranularityForMetric(activeChart, period: string) {
    if (
      [
        Graphs.JobSummary,
        Graphs.JobCompleted,
        Graphs.JobByUser,
        Graphs.JobByGroup,
        Graphs.JobWaitTime,
        Graphs.JobByApplication,
        Graphs.JobByNodes,
        Graphs.CoresByApplication,
        Graphs.CoreHoursByUsers,
        Graphs.JobDurationsByDay,
        Graphs.JobByTagsPerDay,
      ].includes(activeChart)
    ) {
      setTimeout(() => {
        this.granularityValue = Granularity.OneDay;
      }, 1);
      return [];
    }
    return this.sortGranularityAsPerPeriod(period, activeChart);
  }

  getAllHpcGraphs() {}

  getAllVdiGraphs(wsName, duration, granularity, toDownload?: boolean) {
    this.resetAllData();
    if (!this.isChecked && wsName == "none") {
      wsName = "";
    }
    this.spinner.show("loadingGraphs");
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.NodeUtilization,
        duration,
        granularity,
        "",
        "",
        false,
        ""
      )
      .subscribe({
        next: (data) => {
          if (data) {
            this.nodeUtilization = <NodeUsage[]>(
              JSON.parse(JSON.stringify(data))
            );
            this.spinner.hide("loadingGraphs");

            let dateFilter = this.dateFilterValue;
            let localthisDateFilterValue = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            if (this.dateFilterValue.toLowerCase().indexOf("to") != -1) {
              if (this.differenceInDays == 0 || this.differenceInDays == 1) {
                dateFilter = "1";
              } else {
                dateFilter = "-1";
                localthisDateFilterValue = dateFilter + " days";
              }
            }

            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(data, headers, `${Graphs.NodeUtilization}.csv`);
              return;
            }

            let uniqueDates;
            //            if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
            if (
              dateFilter != "1" &&
              (this.dateFilterValue.indexOf("days") != -1 ||
                this.dateFilterValue.indexOf("to") != -1)
            ) {
              uniqueDates = [
                ...new Set(
                  this.nodeUtilization.map(
                    (item) =>
                      formatDate(
                        new Date(item.timeStamp),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0]
                  )
                ),
              ];
            } else {
              uniqueDates = [
                ...new Set(this.nodeUtilization.map((item) => item.timeStamp)),
              ];
            }
            this.nodeUtilization.forEach((x) => {
              if (x.officeHours == 1) {
                this.nodeUtilizationDataOffice.datasets[0].data.push(
                  x.cpuPercent
                );
                this.nodeUtilizationDataOffice.datasets[1].data.push(
                  x.ramPercent
                );
                this.nodeUtilizationDataOffice.datasets[2].data.push(
                  x.gpuPercent
                );
                this.nodeUtilizationDataOffice.datasets[3].data.push(
                  x.gpuMemoryUsage
                );
                let date;
                //                if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                if (
                  dateFilter != "1" &&
                  (this.dateFilterValue.indexOf("days") != -1 ||
                    this.dateFilterValue.indexOf("to") != -1)
                ) {
                  date = formatDate(
                    new Date(x.timeStamp),
                    "mediumDate",
                    "en-US"
                  ).split(",")[0];
                } else {
                  date = formatDate(
                    new Date(x.timeStamp),
                    "h:mm aa",
                    "en-US"
                  ).split(")")[0];
                }
                this.nodeUtilizationDataOffice.labels.push(date);
              } else if (x.officeHours == 0) {
                this.nodeUtilizationDataNonOffice.datasets[0].data.push(
                  x.cpuPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[1].data.push(
                  x.ramPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[2].data.push(
                  x.gpuPercent
                );
                this.nodeUtilizationDataNonOffice.datasets[3].data.push(
                  x.gpuMemoryUsage
                );
                let date;
                //                if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                if (
                  dateFilter != "1" &&
                  (this.dateFilterValue.indexOf("days") != -1 ||
                    this.dateFilterValue.indexOf("to") != -1)
                ) {
                  date = formatDate(
                    new Date(x.timeStamp),
                    "mediumDate",
                    "en-US"
                  ).split(",")[0];
                } else {
                  date = formatDate(
                    new Date(x.timeStamp),
                    "h:mm aa",
                    "en-US"
                  ).split(")")[0];
                }
                this.nodeUtilizationDataNonOffice.labels.push(date);
              }
            });
            uniqueDates.forEach((unq) => {
              let count = 0;
              let ramUsage = 0;
              let cpuUsage = 0;
              let gpuUsage = 0;
              let gpuMemoryUsage = 0;
              this.nodeUtilization.forEach((n) => {
                //                if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                if (
                  dateFilter != "1" &&
                  (this.dateFilterValue.indexOf("days") != -1 ||
                    this.dateFilterValue.indexOf("to") != -1)
                ) {
                  if (
                    formatDate(
                      new Date(n.timeStamp),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0] === unq
                  ) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                } else {
                  if (n.timeStamp === unq) {
                    ramUsage = ramUsage + n.ramPercent;
                    cpuUsage = cpuUsage + n.cpuPercent;
                    gpuUsage = gpuUsage + n.gpuPercent;
                    gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                    count = count + 1;
                  }
                }
              });
              this.nodeUtilizationDataTotal.datasets[0].data.push(
                cpuUsage / count
              );
              this.nodeUtilizationDataTotal.datasets[1].data.push(
                ramUsage / count
              );
              this.nodeUtilizationDataTotal.datasets[2].data.push(
                gpuUsage / count
              );
              this.nodeUtilizationDataTotal.datasets[3].data.push(
                gpuMemoryUsage / count
              );
              let date;
              //              if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
              if (
                dateFilter != "1" &&
                (this.dateFilterValue.indexOf("days") != -1 ||
                  this.dateFilterValue.indexOf("to") != -1)
              ) {
                date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                  ","
                )[0];
              } else {
                date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                  ")"
                )[0];
              }
              this.nodeUtilizationDataTotal.labels.push(date);
            });
            this.charts.forEach((child) => {
              child.chart.update();
            });
          } else {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  getAllWorkstationList(dep) {
    this.nodeService.getAllWSNames(dep, "all").subscribe((data) => {
      if (data) {
        this.wsNames = JSON.parse(JSON.stringify(data))?.wsSelected;
        this.nodeGroups = JSON.parse(JSON.stringify(data))?.nodeGroups;
      }
    });
  }

  getDynamicColor() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  }

  getSpecificGraphs(type, toDownload) {
    let wsName;
    if (!this.isChecked && this.wsValue == "none") {
      wsName = "";
    } else {
      wsName = this.wsValue;
    }

    this.resetAllData();
    this.spinner.show("loadingGraphs");
    if (type.toLowerCase() == "network") {
      this.specificUtilizationData = {
        datasets: [
          {
            data: [],
            label: "Sent",
            backgroundColor: "rgba(183, 244, 216,0.3)",
            borderColor: "lightgreen",
            pointBackgroundColor: "#e9fce9",
            pointBorderColor: "lightgreen",
            pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
            pointHoverBorderColor: "red",
            fill: "origin",
          },
          {
            data: [],
            label: "Received",
            backgroundColor: "rgba(255,215,0,0.3)",
            borderColor: "gold",
            pointBackgroundColor: " #fffbe6",
            pointBorderColor: "gold",
            pointHoverBackgroundColor: "rgba(255,225,153,0.3)",
            pointHoverBorderColor: "red",
            fill: "origin",
          },
        ],
      };

      this.specificUtilizationOptions = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.5,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
          },
          "y-axis-0": {
            position: "left",
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            min: 0,
            ticks: {
              //              callback: (value) =>  value + ' MB'
            },
            title: {
              display: true,
              text: "Network Usage (MB/Sec)",
            },
          },
        },
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 20,
              font: {
                size: 12,
              },
            },
          },
          title: {
            display: true,
            text: `Network utilization - ${this.dateFilterValue
              .replace("to", " to ")
              .replace(" days", "")} ${
              this.dateFilterValue.includes("to") ? "" : "Days"
            }`,
            position: "bottom",
          },
          datalabels: {
            display: false,
          },
        },
      };
    } else {
      this.specificUtilizationOptions = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.5,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
          },
          "y-axis-0": {
            position: "left",
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            max: 100,
            min: 0,
            title: {
              display: true,
              text: "Usage in %",
            },
          },
        },
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              boxWidth: 20,
              font: {
                size: 12,
              },
            },
          },
          title: {
            display: true,
            text: "",
            position: "top",
          },
          datalabels: {
            display: false,
          },
        },
      };
      this.specificUtilizationData = {
        datasets: [
          {
            data: [],
            label: "",
            backgroundColor: "rgba(255,225,153,0.3)",
            borderColor: "gold",
            pointBackgroundColor: "rgba(148,159,177,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(148,159,177,0.8)",
            fill: "origin",
          },
        ],
        labels: [],
      };
    }
    this.chartService
      .getNodeUsage(
        this.selectedDepMetric,
        Graphs.NodeUtilization,
        this.dateFilterValue,
        this.granularityValue,
        "",
        wsName,
        false,
        type
      )
      .subscribe({
        next: (data) => {
          if (data) {
            this.spinner.hide("loadingGraphs");
            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `${Graphs.NodeUtilization}-${this.selectedDepMetric}.csv`
              );
            }
            let dateFilter = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }
            this.nodeUtilization = [];
            this.specificUtilizationData.datasets[0].data = [];
            if (type.toLowerCase() == "network") {
              this.specificUtilizationData.datasets![1].data = [];
            }
            this.specificUtilizationData.labels = [];
            this.nodeUtilization = <NodeUsage[]>(
              JSON.parse(JSON.stringify(data))
            );
            if (this.getRealTimeGraph) {
              if (this.nodeUtilization) {
                let uniqueDates;
                if (!["1", "2"].includes(this.dateFilterValue)) {
                  uniqueDates = [
                    ...new Set(
                      this.nodeUtilization.map(
                        (item) =>
                          formatDate(
                            new Date(item.timeStamp),
                            "mediumDate",
                            "en-US"
                          ).split(",")[0]
                      )
                    ),
                  ];
                } else {
                  uniqueDates = [
                    ...new Set(
                      this.nodeUtilization.map((item) => item.timeStamp)
                    ),
                  ];
                }

                uniqueDates.forEach((unq, idx) => {
                  let count = 0;
                  let ramUsage = 0;
                  let cpuUsage = 0;
                  let gpuUsage = 0;
                  let gpuMemoryUsage = 0;
                  let bytesSent = 0;
                  let bytesReceived = 0;
                  this.nodeUtilization.forEach((n) => {
                    if (!["1", "2"].includes(this.dateFilterValue)) {
                      if (
                        formatDate(
                          new Date(n.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0] === unq
                      ) {
                        ramUsage = ramUsage + n.ramPercent;
                        cpuUsage = cpuUsage + n.cpuPercent;
                        gpuUsage = gpuUsage + n.gpuPercent;
                        gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                        bytesReceived = bytesReceived + n.bytesReceived;
                        bytesSent = bytesSent + n.bytesSent;
                        count = count + 1;
                      }
                    } else {
                      if (n.timeStamp === unq) {
                        ramUsage = ramUsage + n.ramPercent;
                        cpuUsage = cpuUsage + n.cpuPercent;
                        gpuUsage = gpuUsage + n.gpuPercent;
                        gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                        bytesReceived = bytesReceived + n.bytesReceived;
                        bytesSent = bytesSent + n.bytesSent;
                        count = count + 1;
                      }
                    }
                  });

                  switch (type) {
                    case "cpu":
                      this.specificUtilizationData.datasets[0].data.push(
                        cpuUsage / count
                      );
                      break;

                    case "ram":
                      this.specificUtilizationData.datasets[0].data.push(
                        ramUsage / count
                      );
                      break;

                    case "gpu":
                      this.specificUtilizationData.datasets[0].data.push(
                        gpuMemoryUsage / count
                      );
                      break;

                    case "network":
                      this.specificUtilizationData.datasets[0].data.push(
                        bytesSent
                      );
                      this.specificUtilizationData.datasets[1].data.push(
                        bytesReceived
                      );
                      break;
                  }

                  let date;
                  if (["1", "2"].includes(this.dateFilterValue)) {
                    date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                      ")"
                    )[0];
                  } else {
                    date = formatDate(
                      new Date(unq),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0];
                  }

                  switch (type) {
                    case "cpu":
                      this.specificUtilizationData.labels.push(date);
                      break;

                    case "ram":
                      this.specificUtilizationData.labels.push(date);
                      break;

                    case "gpu":
                      this.specificUtilizationData.labels.push(date);
                      break;

                    case "network":
                      this.specificUtilizationData.labels.push(date);
                      break;
                  }
                });

                this.charts.forEach((child) => {
                  child.chart.update();
                });
              } else {
                this.spinner.hide("loadingGraphs");
                this.snackbar.open("No node utilization report found.", "OK", {
                  duration: 5000,
                });
              }
            } else {
              let uniqueDates;
              if (
                dateFilter != "1" &&
                this.dateFilterValue.indexOf("days") != -1
              ) {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map(
                      (item) =>
                        formatDate(
                          new Date(item.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0]
                    )
                  ),
                ];
              } else {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map((item) => item.timeStamp)
                  ),
                ];
              }

              uniqueDates.forEach((unq) => {
                let count = 0;
                let ramUsage = 0;
                let cpuUsage = 0;
                let gpuUsage = 0;
                let gpuMemoryUsage = 0;
                let bytesSent = 0;
                let bytesReceived = 0;
                this.nodeUtilization.forEach((n) => {
                  if (
                    dateFilter != "1" &&
                    this.dateFilterValue.indexOf("days") != -1
                  ) {
                    if (
                      formatDate(
                        new Date(n.timeStamp),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0] === unq
                    ) {
                      ramUsage = ramUsage + n.ramPercent;
                      cpuUsage = cpuUsage + n.cpuPercent;
                      gpuUsage = gpuUsage + n.gpuPercent;
                      gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                      bytesReceived = bytesReceived + n.bytesReceived;
                      bytesSent = bytesSent + n.bytesSent;
                      count = count + 1;
                    }
                  } else {
                    if (n.timeStamp === unq) {
                      ramUsage = ramUsage + n.ramPercent;
                      cpuUsage = cpuUsage + n.cpuPercent;
                      gpuUsage = gpuUsage + n.gpuPercent;
                      gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                      bytesReceived = bytesReceived + n.bytesReceived;
                      bytesSent = bytesSent + n.bytesSent;
                      count = count + 1;
                    }
                  }
                });
                switch (type) {
                  case "cpu":
                    this.specificUtilizationData.datasets[0].data.push(
                      cpuUsage / count
                    );
                    break;

                  case "ram":
                    this.specificUtilizationData.datasets[0].data.push(
                      ramUsage / count
                    );
                    break;

                  case "gpu":
                    this.specificUtilizationData.datasets[0].data.push(
                      gpuMemoryUsage / count
                    );
                    break;

                  case "network":
                    this.specificUtilizationData.datasets[0].data.push(
                      bytesSent / count
                    );
                    this.specificUtilizationData.datasets[1].data.push(
                      bytesReceived / count
                    );
                    break;
                }

                let date;
                if (
                  dateFilter != "1" &&
                  this.dateFilterValue.indexOf("days") != -1
                ) {
                  date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                    ","
                  )[0];
                } else {
                  //                  date = formatDate(new Date(unq), 'MMM h:mm aa', 'en-US').split(')')[0];
                  const format = {
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                  };
                  date = new Date(unq);
                  date = date.toLocaleString("en-US", {
                    ...format,
                    day: "numeric",
                  });
                }
                this.specificUtilizationData.labels.push(date);
              });

              switch (type) {
                case "cpu":
                  this.specificUtilizationData.datasets[0].label = "CPU";
                  this.specificUtilizationOptions.plugins.title.text =
                    "CPU Utilization";
                  break;

                case "ram":
                  this.specificUtilizationData.datasets[0].label = "RAM";
                  this.specificUtilizationOptions.plugins.title.text =
                    "RAM Utilization";
                  break;

                case "gpu":
                  this.specificUtilizationData.datasets[0].label = "GPU Memory";
                  this.specificUtilizationOptions.plugins.title.text =
                    "GPU Utilization";
                  break;
              }
              this.charts.forEach((child) => {
                if (
                  child.data.labels.length != child.chart.data.labels.length
                ) {
                  child.chart.data.labels = child.data.labels;
                }
                child.chart.update();
              });
              this.spinner.hide("loadingGraphs");
            }
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  getSessionData(type, toDownload?: boolean) {
    this.resetAllData();
    this.sessionService
      .getSessionData(this.selectedUser, type, this.dateFilterValue)
      .subscribe({
        next: (data: any) => {
          let sessinfo = <SessionInfo>JSON.parse(JSON.stringify(data));
          this.spinner.hide("loadingGraphs");
          if (!sessinfo) {
            this.snackbar.open("No Data Available", "Ok", { duration: 5000 });
            return;
          }
          sessinfo.perDaySessions.forEach((e) => {
            let option = {
              hAxis: {
                minValue: new Date(e.date).setHours(0, 0, 0, 0),
                maxValue: new Date(e.date).setHours(23, 59, 59, 999),
                format: "HH:mm",
              },
              is3D: true,
            };

            let singleDatedata = [];
            e.data.forEach((data) => {
              singleDatedata.push([
                e.date.split("T")[0],
                data.node,
                new Date(data.sessionStart),
                new Date(data.sessionEnd),
              ]);
            });

            if (type === "Connect-Disconnect") {
              this.graphConnDiscon.push({
                data: singleDatedata,
                options: option,
              });
            } else {
              this.graphStartEnd.push({
                data: singleDatedata,
                options: option,
              });
            }
          });
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  async getSingleNodeSpecificChart(type, duration, granularity, toDownload) {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    //let nNames = this.myForm.value?.nodeNames;
    //if (nNames?.length == 0) {
    //  nNames = this.wsNames;
    //}
    let nNames = this.wsNames;
    if (type.toLowerCase() == "network") {
      this.cpuUtilizationData = {
        datasets: [
          {
            data: [],
            label: "Send",
            backgroundColor: "rgba(183, 244, 216,0.3)",
            borderColor: "lightgreen",
            pointBackgroundColor: "#e9fce9",
            pointBorderColor: "lightgreen",
            pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
            pointHoverBorderColor: "red",
            fill: "origin",
          },
          {
            data: [],
            label: "Receive",
            backgroundColor: "rgba(255,215,0,0.3)",
            borderColor: "gold",
            pointBackgroundColor: " #fffbe6",
            pointBorderColor: "gold",
            pointHoverBackgroundColor: "rgba(255,225,153,0.3)",
            pointHoverBorderColor: "red",
            fill: "origin",
          },
        ],
      };

      this.cpuUtilizationOptions = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.5,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            ticks: {
              font: {
                size: 10,
              },
            },
          },
          "y-axis-0": {
            position: "left",
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            min: 0,
            ticks: {
              font: {
                size: 10,
              },
              //   callback: (value) => value + ' MB'
            },
            title: {
              display: true,
              text: "Network Usage (MB/Sec)",
            },
          },
        },
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 5,
              boxHeight: 5,
              font: {
                size: 10,
              },
            },
          },
          title: {
            display: true,
            text: `Network utilization - ${this.dateFilterValue
              .replace("to", " to ")
              .replace(" days", "")} ${
              this.dateFilterValue.includes("to") ? "" : "Days"
            }`,
            position: "bottom",
          },
          subtitle: {
            display: true,
            text: "",
            padding: 5,
          },
          datalabels: {
            display: false,
          },
        },
      };
    } else {
      this.cpuUtilizationOptions = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.5,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            ticks: {
              font: {
                size: 10,
              },
            },
          },
          "y-axis-0": {
            position: "left",
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            max: 100,
            min: 0,
            ticks: {
              font: {
                size: 10,
              },
            },
            title: {
              display: true,
              text: "Usage in %",
            },
          },
        },
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 5,
              boxHeight: 5,
              font: {
                size: 10,
              },
            },
          },
          datalabels: {
            display: false,
          },
        },
      };

      this.cpuUtilizationData = {
        datasets: [
          {
            data: [],
            label: "CPU",
            backgroundColor: "rgba(255, 161, 181,0.3)",
            borderColor: "red",
            pointBackgroundColor: "rgba(77,83,96,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
            pointHoverBorderColor: "#fff",
            fill: "origin",
          },
        ],
      };
    }
    this.chartService
      .getNodeUsage(
        this.selectedDepMetric,
        Graphs.NodeUtilization,
        this.dateFilterValue,
        this.granularityValue,
        "",
        "",
        true,
        ""
      )
      .subscribe({
        next: async (data) => {
          if (data) {
            if (toDownload) {
              this.spinner.hide("loadingGraphs");
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `${Graphs.SingleNodeUtilization}-${this.selectedDepMetric}.csv`
              );
            }

            this.nodeService.getNodeDescription("all").subscribe({
              next: (data) => {
                this.nodeDescription = <NodeDescription[]>(
                  JSON.parse(JSON.stringify(data))
                );
              },
              error: (err) => {},
            });
            await new Promise((r) => setTimeout(r, 1000));
            this.nodeUtilization = [];
            this.chartData = [];
            this.nodeUtilization = [];
            this.cpuUtilizationData.datasets[0].data = [];
            this.cpuUtilizationData.labels = [];
            this.nodeUtilization = <NodeUsage[]>(
              JSON.parse(JSON.stringify(data))
            );

            let dateFilter = this.dateFilterValue;
            let localthisDateFilterValue = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            if (this.dateFilterValue.toLowerCase().indexOf("to") != -1) {
              if (this.differenceInDays == 0 || this.differenceInDays == 1) {
                dateFilter = "1";
              } else {
                dateFilter = "-1";
                localthisDateFilterValue = dateFilter + " days";
              }
            }

            if (this.getRealTimeGraph) {
              if (this.nodeUtilization) {
                let temp;
                switch (type) {
                  case "cpu":
                    temp = this.cpuUtilizationOptions;
                    break;

                  case "ram":
                    temp = this.ramUtilizationOptions;
                    break;

                  case "gpu":
                    temp = this.gpuUtilizationOptions;
                    break;

                  case "network":
                    temp = this.cpuUtilizationOptions;
                    break;
                }

                //     const uniqueDates = [...new Set(this.nodeUtilization.map(item => item.timeStamp))];
                let uniqueDates;
                if (!["1", "2"].includes(this.dateFilterValue)) {
                  uniqueDates = [
                    ...new Set(
                      this.nodeUtilization.map(
                        (item) =>
                          formatDate(
                            new Date(item.timeStamp),
                            "mediumDate",
                            "en-US"
                          ).split(",")[0]
                      )
                    ),
                  ];
                } else {
                  uniqueDates = [
                    ...new Set(
                      this.nodeUtilization.map((item) => item.timeStamp)
                    ),
                  ];
                }

                var filteredData = this.groupByNodes(
                  this.nodeUtilization,
                  "nodeName"
                );

                Object.keys(filteredData).forEach((key, idx) => {
                  this.cpuUtilizationData.datasets[0].data = [];
                  this.cpuUtilizationData.labels = [];

                  uniqueDates.forEach((unq) => {
                    let count = 0;
                    let ramUsage = 0;
                    let cpuUsage = 0;
                    let gpuUsage = 0;
                    let gpuMemoryUsage = 0;
                    let bytesSent = 0;
                    let bytesReceived = 0;
                    filteredData[key].forEach((n) => {
                      if (!["1", "2"].includes(this.dateFilterValue)) {
                        if (
                          formatDate(
                            new Date(n.timeStamp),
                            "mediumDate",
                            "en-US"
                          ).split(",")[0] === unq
                        ) {
                          ramUsage = ramUsage + n.ramPercent;
                          cpuUsage = cpuUsage + n.cpuPercent;
                          gpuUsage = gpuUsage + n.gpuPercent;
                          gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                          bytesReceived = bytesReceived + n.bytesReceived;
                          bytesSent = bytesSent + n.bytesSent;
                          count = count + 1;
                        }
                      } else {
                        if (n.timeStamp === unq) {
                          ramUsage = ramUsage + n.ramPercent;
                          cpuUsage = cpuUsage + n.cpuPercent;
                          gpuUsage = gpuUsage + n.gpuPercent;
                          gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                          bytesReceived = bytesReceived + n.bytesReceived;
                          bytesSent = bytesSent + n.bytesSent;
                          count = count + 1;
                        }
                      }
                    });
                    switch (type) {
                      case "cpu":
                        this.cpuUtilizationData.datasets[0].data.push(
                          cpuUsage / count
                        );
                        break;

                      case "ram":
                        this.cpuUtilizationData.datasets[0].data.push(
                          ramUsage / count
                        );
                        break;

                      case "gpu":
                        this.cpuUtilizationData.datasets[0].data.push(
                          gpuMemoryUsage / count
                        );
                        break;

                      case "network":
                        this.cpuUtilizationData.datasets[0].data.push(
                          bytesSent
                        );
                        this.cpuUtilizationData.datasets[1].data.push(
                          bytesReceived
                        );
                        break;
                    }

                    let date;
                    if (["1", "2"].includes(this.dateFilterValue)) {
                      date = formatDate(
                        new Date(unq),
                        "h:mm aa",
                        "en-US"
                      ).split(")")[0];
                    } else {
                      date = formatDate(
                        new Date(unq),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0];
                    }

                    this.cpuUtilizationData.labels.push(date);
                  });
                  if (type.toLowerCase() != "network") {
                    this.cpuUtilizationData.datasets[0].label = key;
                  } else {
                    this.cpuUtilizationData.datasets[0].label = "";
                    this.cpuUtilizationData.datasets[0].label = key + " : Sent";
                  }
                  this.chartData.push({
                    dt: structuredClone(this.cpuUtilizationData),
                    ot: structuredClone(temp),
                  });
                });
                this.spinner.hide("loadingGraphs");
                this.charts.forEach((child) => {
                  child.chart.update();
                });
              } else {
                this.spinner.hide("loadingGraphs");
                this.snackbar.open("No node utilization report found.", "OK", {
                  duration: 5000,
                });
              }
            } else {
              let temp;
              switch (type) {
                case "cpu":
                  temp = this.ramUtilizationOptions;
                  break;

                case "ram":
                  temp = this.ramUtilizationOptions;
                  break;

                case "gpu":
                  temp = this.ramUtilizationOptions;
                  break;

                case "network":
                  temp = this.cpuUtilizationOptions;
                  break;
              }

              if (type == "network") {
                //   this.nodeUtilization = this.nodeUtilization?.filter(item => this.hostWsNames?.includes(item.nodeName))
              }

              let uniqueDates;
              //  if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
              //  if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
              if (
                dateFilter != "1" &&
                (this.dateFilterValue.indexOf("days") != -1 ||
                  this.dateFilterValue.indexOf("to") != -1)
              ) {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map(
                      (item) =>
                        formatDate(
                          new Date(item.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0]
                    )
                  ),
                ];
              } else {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map((item) => item.timeStamp)
                  ),
                ];
              }

              var filteredData = this.groupByNodes(
                this.nodeUtilization,
                "nodeName"
              );

              Object.keys(filteredData).forEach((key, idx) => {
                //   if (nNames?.indexOf(key) != -1) {
                this.cpuUtilizationData.datasets[0].data = [];
                if (type.toLowerCase() == "network") {
                  this.cpuUtilizationData.datasets![1].data = [];
                }
                this.cpuUtilizationData.labels = [];

                uniqueDates.forEach((unq) => {
                  let count = 0;
                  let ramUsage = 0;
                  let cpuUsage = 0;
                  let gpuUsage = 0;
                  let gpuMemoryUsage = 0;
                  let bytesSent = 0;
                  let bytesReceived = 0;
                  filteredData[key].forEach((n) => {
                    //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
                    //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                    if (
                      dateFilter != "1" &&
                      (this.dateFilterValue.indexOf("days") != -1 ||
                        this.dateFilterValue.indexOf("to") != -1)
                    ) {
                      if (
                        formatDate(
                          new Date(n.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0] === unq
                      ) {
                        ramUsage = ramUsage + n.ramPercent;
                        cpuUsage = cpuUsage + n.cpuPercent;
                        gpuUsage = gpuUsage + n.gpuPercent;
                        gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                        bytesReceived = bytesReceived + n.bytesReceived;
                        bytesSent = bytesSent + n.bytesSent;
                        count = count + 1;
                      }
                    } else {
                      if (n.timeStamp === unq) {
                        ramUsage = ramUsage + n.ramPercent;
                        cpuUsage = cpuUsage + n.cpuPercent;
                        gpuUsage = gpuUsage + n.gpuPercent;
                        gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                        bytesReceived = bytesReceived + n.bytesReceived;
                        bytesSent = bytesSent + n.bytesSent;
                        count = count + 1;
                      }
                    }
                  });
                  switch (type) {
                    case "cpu":
                      this.cpuUtilizationData.datasets[0].data.push(
                        cpuUsage / count
                      );
                      break;

                    case "ram":
                      this.cpuUtilizationData.datasets[0].data.push(
                        ramUsage / count
                      );
                      break;

                    case "gpu":
                      this.cpuUtilizationData.datasets[0].data.push(
                        gpuMemoryUsage / count
                      );
                      break;

                    case "network":
                      this.cpuUtilizationData.datasets[0].data.push(bytesSent);
                      this.cpuUtilizationData.datasets[1].data.push(
                        bytesReceived
                      );
                      break;
                  }

                  let date;
                  //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
                  //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                  if (
                    dateFilter != "1" &&
                    (this.dateFilterValue.indexOf("days") != -1 ||
                      this.dateFilterValue.indexOf("to") != -1)
                  ) {
                    date = formatDate(
                      new Date(unq),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0];
                  } else {
                    date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                      ")"
                    )[0];
                  }
                  this.cpuUtilizationData.labels.push(date);
                });
                if (type.toLowerCase() != "network") {
                  this.cpuUtilizationData.datasets[0].label = key;
                } else {
                  this.cpuUtilizationData.datasets[0].label = "";
                  this.cpuUtilizationData.datasets[0].label = key + " : Sent";
                }

                temp.plugins.subtitle.text = "";
                if (this.nodeDescription.length > 0) {
                  temp.plugins.subtitle.text = this.nodeDescription?.find(
                    (nd) => nd.name === key
                  )?.description;
                }
                this.chartData.push({
                  dt: structuredClone(this.cpuUtilizationData),
                  ot: structuredClone(temp),
                });
                //}
              });
              this.spinner.hide("loadingGraphs");
              this.charts.forEach((child) => {
                child.chart.update();
              });
            }
          } else {
            this.chartData = [];
            this.showError = true;
            this.errorMessage = "No data available to visualize.";
          }
          this.spinner.hide("loadingGraphs");
        },
        error: (err) => {
          this.chartData = [];
          this.showError = true;
          this.errorMessage = "No data available to visualize.";
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  getUserName() {
    this.userService.getUserNamesForDeployment(this.depName).subscribe({
      next: (data: any) => {
        data.forEach((d) => {
          this.userNames.push({ item_id: d, item_text: d });
          this.coreHourUserNames = this.userNames;
          this.myForm.controls["userNames"]?.setValue(this.userNames);
          this.myForm.controls["coreHourUserNames"]?.setValue(
            this.coreHourUserNames
          );
        });
      },
      error: (err) => {},
    });
  }

  getUserGroupNames() {
    this.userService.getUserGroupNamesForDeployment(this.depName).subscribe({
      next: (data: any) => {
        data.forEach((d) => {
          this.userGroupNames.push({ item_id: d, item_text: d });
        });
        // this.myForm.controls["userGroups"].setValue([this.userGroupNames]);
        // this.myForm.controls["userGroups"].updateValueAndValidity();
      },
      error: (err) => {},
    });
  }

  getJobTags() {
    this.jobService.getJobTagsOfAllJobs(this.depName).subscribe({
      next: (data: any) => {
        data?.forEach((d) => {
          this.jobTags.push({ item_id: d, item_text: d });
        });
      },
      error: (err) => {},
    });
  }

  getPrimeNonPrimeCoreHours(toDownload?: boolean) {
    this.chartService
      .getPrimeNonPrimeCoresHoursData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          let primeNonPrimeHoursData = <PrimeNonPrimCoresDataI>(
            JSON.parse(JSON.stringify(data))
          );

          if (toDownload) {
            let headers = Object.keys(primeNonPrimeHoursData.primeHours[0]);
            this.downloadCsv(
              primeNonPrimeHoursData.primeHours,
              headers,
              `PrimeHourUsage-${this.depName}.csv`
            );
            headers = Object.keys(primeNonPrimeHoursData.nonPrimeHours[0]);
            this.downloadCsv(
              primeNonPrimeHoursData.nonPrimeHours,
              headers,
              `NonPrimeHourUsage-${this.depName}.csv`
            );
          }

          this.primeCoreUsageChartData["datasets"].forEach((d) => {
            d.data = [];
          });
          this.primeCoreUsageChartData["labels"] = [];

          let usedColors = [];
          let queuedColors = [];

          primeNonPrimeHoursData.primeHours?.forEach((data) => {
            this.primeCoreUsageChartData["datasets"][0].data.push(
              data.usedCores
            );
            this.primeCoreUsageChartData["datasets"][1].data.push(
              data.queuedCores
            );
            usedColors.push("#0072c6");
            queuedColors.push("#C4B0FF");
            let date;
            if (this.granularityValue == "One Hour") {
              date = formatDate(
                new Date(data.timeStamp),
                "h:mm aa",
                "en-US"
              ).split(")")[0];
            } else {
              date = formatDate(
                new Date(data.timeStamp),
                "mediumDate",
                "en-US"
              ).split(",")[0];
            }
            this.primeCoreUsageChartData["labels"].push(date);
          });
          this.primeCoreUsageChartData["datasets"][0].backgroundColor =
            usedColors;
          this.primeCoreUsageChartData["datasets"][0].hoverBackgroundColor =
            usedColors;
          this.primeCoreUsageChartData["datasets"][1].backgroundColor =
            queuedColors;
          this.primeCoreUsageChartData["datasets"][1].hoverBackgroundColor =
            queuedColors;
          this.updateGraphs();

          this.nonPrimeCoreUsageChartData["datasets"].forEach((d) => {
            d.data = [];
          });
          this.nonPrimeCoreUsageChartData["labels"] = [];

          usedColors = [];
          queuedColors = [];

          primeNonPrimeHoursData.nonPrimeHours?.forEach((data) => {
            this.nonPrimeCoreUsageChartData["datasets"][0].data.push(
              data.usedCores
            );
            this.nonPrimeCoreUsageChartData["datasets"][1].data.push(
              data.queuedCores
            );
            usedColors.push("#0072c6");
            queuedColors.push("#C4B0FF");
            let date;
            if (this.granularityValue == "One Hour") {
              date = formatDate(
                new Date(data.timeStamp),
                "h:mm aa",
                "en-US"
              ).split(")")[0];
            } else {
              date = formatDate(
                new Date(data.timeStamp),
                "mediumDate",
                "en-US"
              ).split(",")[0];
            }
            this.nonPrimeCoreUsageChartData["labels"].push(date);
          });
          this.nonPrimeCoreUsageChartData["datasets"][0].backgroundColor =
            usedColors;
          this.nonPrimeCoreUsageChartData["datasets"][0].hoverBackgroundColor =
            usedColors;
          this.nonPrimeCoreUsageChartData["datasets"][1].backgroundColor =
            queuedColors;
          this.nonPrimeCoreUsageChartData["datasets"][1].hoverBackgroundColor =
            queuedColors;

            this.primeCoreUsageChartOptions = {
              ...this.primeCoreUsageChartOptions,
              plugins:{
                ...this.primeCoreUsageChartOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Prime - Avg Used and Queued Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                },
              }
            };
            this.nonPrimeCoreUsageChartOptions = {
              ...this.nonPrimeCoreUsageChartOptions,
              plugins: {
                ...this.nonPrimeCoreUsageChartOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Non Prime - Avg Used and Queued Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
                },
              }
            };

          this.updateGraphs();
        },
        error: (err) => {},
      });
  }

  groupByApplication(obj, key) {
    return obj.reduce(function (start, current) {
      (start[current[key]] = start[current[key]] || []).push(current);
      return start;
    }, {});
  }

  groupByNodes(obj, key) {
    return obj.reduce(function (start, current) {
      if (current[key].split(",").length > 1) {
        current[key].split(",").forEach((eleKey) => {
          (start[current[eleKey]] = start[current[eleKey]] || []).push({
            ...current,
            jobAllocatedNodes: eleKey,
          });
          return start;
        });
      } else {
        (start[current[key]] = start[current[key]] || []).push(current);
      }
      return start;
    }, {});
  }

  ngOnDestroy() {
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    if (this.universalSub) {
      this.universalSub.unsubscribe();
    }
    if (this.snackbar) {
      this.snackbar.dismiss();
    }
  }

  loadUsers() {
    this.userService
      .getAllDeploymentUserForJobFilter(this.depName, true)
      .subscribe({
        next: (data: any) => {
          if (!data) return;
          if (data?.users != "") {
            this.userNamesForSessionGraph = data?.users?.split(",");
            this.userNamesForSessionGraph = this.userNamesForSessionGraph?.sort(
              (a, b) => a.localeCompare(b)
            );
          } else {
          }
        },
        error: (err) => {},
      });
  }

  loadNodeUtilization(nodeGroup?: string, toDownload?: boolean) {
    this.resetAllData();
    this.resetAllData();
    let group = "";
    if (nodeGroup) {
      group = nodeGroup;
    }
    this.spinner.show("loadingGraphs");
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.NodeUtilization,
        this.dateFilterValue,
        this.granularityValue,
        "",
        "",
        false,
        group
      )
      .subscribe((data) => {
        this.nodeUtilization = <NodeUsage[]>JSON.parse(JSON.stringify(data));
        this.spinner.hide("loadingGraphs");

        if (toDownload) {
          let headers = Object.keys(data[0]);
          this.downloadCsv(
            data,
            headers,
            `${Graphs.NodeUtilization}_${this.depName}.csv`
          );
        }

        //if (this.allChartsData?.length > 0 && this.allChartsData['coreUsage']?.length != 0) {
        //  this.daysValue =
        //    'From ' +
        //    new DatePipe('en-US').transform(
        //      this.allChartsData['coreUsage'][0]
        //        ? new Date(this.nodeUtilization['coreUsage'][0].timeStamp)
        //        : new Date(),
        //      'yyyy-MM-dd, HH:mm:ss'
        //    ) +
        //    ' To ' +
        //    new DatePipe('en-US').transform(
        //      new Date(
        //        this.nodeUtilization['coreUsage'][
        //          this.nodeUtilization['coreUsage']?.length - 1
        //        ].timeStamp
        //      ),
        //      'yyyy-MM-dd, HH:mm:ss'
        //    );
        //} else {
        //  this.daysValue = 'From - to -'
        //}

        //const uniqueDates = [...new Set(this.nodeUtilization.map(item => item.timeStamp))];

        let dateFilter = this.dateFilterValue;
        if (
          this.dateFilterValue.indexOf("hr") != -1 ||
          this.dateFilterValue.indexOf("days") != -1
        ) {
          dateFilter =
            this.dateFilterValue.indexOf("hr") != -1
              ? this.dateFilterValue.trim().slice(0, -2).trim()
              : this.dateFilterValue.trim().slice(0, -4).trim();
        }

        let uniqueDates;
        if (dateFilter != "1" && this.dateFilterValue.indexOf("days") != -1) {
          uniqueDates = [
            ...new Set(
              this.nodeUtilization.map(
                (item) =>
                  formatDate(
                    new Date(item.timeStamp),
                    "mediumDate",
                    "en-US"
                  ).split(",")[0]
              )
            ),
          ];
        } else {
          uniqueDates = [
            ...new Set(this.nodeUtilization.map((item) => item.timeStamp)),
          ];
        }
        this.nodeUtilization.forEach((x) => {
          if (x.officeHours == 1) {
            this.nodeUtilizationDataOffice.datasets[0].data.push(x.cpuPercent);
            this.nodeUtilizationDataOffice.datasets[1].data.push(x.ramPercent);
            this.nodeUtilizationDataOffice.datasets[2].data.push(x.gpuPercent);
            this.nodeUtilizationDataOffice.datasets[3].data.push(
              x.gpuMemoryUsage
            );
            let date;
            if (
              dateFilter != "1" &&
              this.dateFilterValue.indexOf("days") != -1
            ) {
              date = formatDate(
                new Date(x.timeStamp),
                "mediumDate",
                "en-US"
              ).split(",")[0];
            } else {
              date = formatDate(
                new Date(x.timeStamp),
                "h:mm aa",
                "en-US"
              ).split(")")[0];
            }
            this.nodeUtilizationDataOffice.labels.push(date);
          } else if (x.officeHours == 0) {
            this.nodeUtilizationDataNonOffice.datasets[0].data.push(
              x.cpuPercent
            );
            this.nodeUtilizationDataNonOffice.datasets[1].data.push(
              x.ramPercent
            );
            this.nodeUtilizationDataNonOffice.datasets[2].data.push(
              x.gpuPercent
            );
            this.nodeUtilizationDataNonOffice.datasets[3].data.push(
              x.gpuMemoryUsage
            );
            let date;
            if (
              dateFilter != "1" &&
              this.dateFilterValue.indexOf("days") != -1
            ) {
              date = formatDate(
                new Date(x.timeStamp),
                "mediumDate",
                "en-US"
              ).split(",")[0];
            } else {
              date = formatDate(
                new Date(x.timeStamp),
                "h:mm aa",
                "en-US"
              ).split(")")[0];
            }
            this.nodeUtilizationDataNonOffice.labels.push(date);
          }
        });
        uniqueDates.forEach((unq) => {
          let count = 0;
          let ramUsage = 0;
          let cpuUsage = 0;
          let gpuUsage = 0;
          let gpuMemoryUsage = 0;
          this.nodeUtilization.forEach((n) => {
            if (
              dateFilter != "1" &&
              this.dateFilterValue.indexOf("days") != -1
            ) {
              if (
                formatDate(new Date(n.timeStamp), "mediumDate", "en-US").split(
                  ","
                )[0] === unq
              ) {
                ramUsage = ramUsage + n.ramPercent;
                cpuUsage = cpuUsage + n.cpuPercent;
                gpuUsage = gpuUsage + n.gpuPercent;
                gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                count = count + 1;
              }
            } else {
              if (n.timeStamp === unq) {
                ramUsage = ramUsage + n.ramPercent;
                cpuUsage = cpuUsage + n.cpuPercent;
                gpuUsage = gpuUsage + n.gpuPercent;
                gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                count = count + 1;
              }
            }
          });
          this.nodeUtilizationDataTotal.datasets[0].data.push(cpuUsage / count);
          this.nodeUtilizationDataTotal.datasets[1].data.push(ramUsage / count);
          this.nodeUtilizationDataTotal.datasets[2].data.push(gpuUsage / count);
          this.nodeUtilizationDataTotal.datasets[3].data.push(
            gpuMemoryUsage / count
          );
          let date;
          if (dateFilter != "1" && this.dateFilterValue.indexOf("days") != -1) {
            date = formatDate(new Date(unq), "mediumDate", "en-US").split(
              ","
            )[0];
          } else {
            date = formatDate(new Date(unq), "h:mm aa", "en-US").split(")")[0];
          }
          this.nodeUtilizationDataTotal.labels.push(date);
        });
        this.spinner.hide("loadingGraphs");
        this.charts.forEach((child) => {
          child.chart.update();
        });
      });
  }

  loadSingleNodeUtilization(wsName, toDownload?: boolean) {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.NodeUtilization,
        this.dateFilterValue,
        this.granularityValue,
        "",
        wsName,
        false,
        ""
      )
      .subscribe({
        next: (data) => {
          this.nodeUtilization = <NodeUsage[]>JSON.parse(JSON.stringify(data));

          let dateFilter = this.dateFilterValue;
          if (
            this.dateFilterValue.indexOf("hr") != -1 ||
            this.dateFilterValue.indexOf("days") != -1
          ) {
            dateFilter =
              this.dateFilterValue.indexOf("hr") != -1
                ? this.dateFilterValue.trim().slice(0, -2).trim()
                : this.dateFilterValue.trim().slice(0, -4).trim();
          }

          //if (this.allChartsData?.length > 0 && this.allChartsData['coreUsage']?.length != 0) {
          //  this.daysValue =
          //    'From ' +
          //    new DatePipe('en-US').transform(
          //      this.allChartsData['coreUsage'][0]
          //        ? new Date(this.nodeUtilization['coreUsage'][0].timeStamp)
          //        : new Date(),
          //      'yyyy-MM-dd, HH:mm:ss'
          //    ) +
          //    ' To ' +
          //    new DatePipe('en-US').transform(
          //      new Date(
          //        this.nodeUtilization['coreUsage'][
          //          this.nodeUtilization['coreUsage']?.length - 1
          //        ].timeStamp
          //      ),
          //      'yyyy-MM-dd, HH:mm:ss'
          //    );
          //} else {
          //  this.daysValue = 'From - to -'
          //}

          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.SingleNodeUtilization}-${wsName}.csv`
            );
          }

          let uniqueDates;
          if (dateFilter != "1" && this.dateFilterValue.indexOf("days") != -1) {
            uniqueDates = [
              ...new Set(
                this.nodeUtilization.map(
                  (item) =>
                    formatDate(
                      new Date(item.timeStamp),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0]
                )
              ),
            ];
          } else {
            uniqueDates = [
              ...new Set(this.nodeUtilization.map((item) => item.timeStamp)),
            ];
          }
          this.nodeUtilization.forEach((x) => {
            if (x.officeHours == 1) {
              this.nodeUtilizationDataOffice.datasets[0].data.push(
                x.cpuPercent
              );
              this.nodeUtilizationDataOffice.datasets[1].data.push(
                x.ramPercent
              );
              this.nodeUtilizationDataOffice.datasets[2].data.push(
                x.gpuPercent
              );
              this.nodeUtilizationDataOffice.datasets[3].data.push(
                x.gpuMemoryUsage
              );
              let date;
              if (
                dateFilter != "1" &&
                this.dateFilterValue.indexOf("days") != -1
              ) {
                date = formatDate(
                  new Date(x.timeStamp),
                  "mediumDate",
                  "en-US"
                ).split(",")[0];
              } else {
                date = formatDate(
                  new Date(x.timeStamp),
                  "h:mm aa",
                  "en-US"
                ).split(")")[0];
              }
              this.nodeUtilizationDataOffice.labels.push(date);
            } else if (x.officeHours == 0) {
              this.nodeUtilizationDataNonOffice.datasets[0].data.push(
                x.cpuPercent
              );
              this.nodeUtilizationDataNonOffice.datasets[1].data.push(
                x.ramPercent
              );
              this.nodeUtilizationDataNonOffice.datasets[2].data.push(
                x.gpuPercent
              );
              this.nodeUtilizationDataNonOffice.datasets[3].data.push(
                x.gpuMemoryUsage
              );
              let date;
              if (
                dateFilter != "1" &&
                this.dateFilterValue.indexOf("days") != -1
              ) {
                date = formatDate(
                  new Date(x.timeStamp),
                  "mediumDate",
                  "en-US"
                ).split(",")[0];
              } else {
                date = formatDate(
                  new Date(x.timeStamp),
                  "h:mm aa",
                  "en-US"
                ).split(")")[0];
              }
              this.nodeUtilizationDataNonOffice.labels.push(date);
            }
          });
          uniqueDates.forEach((unq) => {
            let count = 0;
            let ramUsage = 0;
            let cpuUsage = 0;
            let gpuUsage = 0;
            let gpuMemoryUsage = 0;
            let sent = 0;
            let recieve = 0;
            this.nodeUtilization.forEach((n) => {
              if (
                dateFilter != "1" &&
                this.dateFilterValue.indexOf("days") != -1
              ) {
                if (
                  formatDate(
                    new Date(n.timeStamp),
                    "mediumDate",
                    "en-US"
                  ).split(",")[0] === unq
                ) {
                  ramUsage = ramUsage + n.ramPercent;
                  cpuUsage = cpuUsage + n.cpuPercent;
                  gpuUsage = gpuUsage + n.gpuPercent;
                  gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                  sent = sent + n.bytesSent;
                  recieve = recieve + n.bytesReceived;
                  count = count + 1;
                }
              } else {
                if (n.timeStamp === unq) {
                  ramUsage = ramUsage + n.ramPercent;
                  cpuUsage = cpuUsage + n.cpuPercent;
                  gpuUsage = gpuUsage + n.gpuPercent;
                  gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                  sent = sent + n.bytesSent;
                  recieve = recieve + n.bytesReceived;
                  count = count + 1;
                }
              }
            });
            this.nodeUtilizationDataTotal.datasets[0].data.push(
              cpuUsage / count
            );
            this.nodeUtilizationDataTotal.datasets[1].data.push(
              ramUsage / count
            );
            this.nodeUtilizationDataTotal.datasets[2].data.push(
              gpuUsage / count
            );
            this.nodeUtilizationDataTotal.datasets[3].data.push(
              gpuMemoryUsage / count
            );
            this.individualNodeNetworkUtilizationChartData.datasets[0].data.push(
              sent
            );
            this.individualNodeNetworkUtilizationChartData.datasets[1].data.push(
              recieve
            );
            let date;
            if (
              dateFilter != "1" &&
              this.dateFilterValue.indexOf("days") != -1
            ) {
              date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                ","
              )[0];
            } else {
              date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                ")"
              )[0];
            }
            this.nodeUtilizationDataTotal.labels.push(date);
            this.individualNodeNetworkUtilizationChartData.labels.push(date);
          });
          this.spinner.hide("loadingGraphs");
          this.charts.forEach((child) => {
            child.chart.update();
          });
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide("loadingGraphs");
        },
      });
    this.spinner.hide("loadingGraphs");
  }

  loadAllCharts(toDownload?: boolean) {
    if (!this.fromDashboard || this.selectedMetric == "all") {
      if (this.allVdi) {
        this.getAllVdiGraphs(
          "none",
          this.dateFilterValue,
          this.granularityValue,
          toDownload
        );
      } else if (this.allHpc) {
        this.getMixedDepGraphs();
      } else {
        this.getMixedDepGraphs();
      }
    } else {
      if (this.activeSessionsPerDep) {
        this.getActiveSessionsPerDeployment("all", false);
        return;
      }
      if (this.isChecked) {
        this.singleNodeSelectedMetric = this.nodeGraphType;
        this.getSingleNodeSpecificChart(
          this.nodeGraphType,
          this.dateFilterValue,
          this.granularityValue,
          false
        );
      } else {
        this.getSpecificGraphs(this.nodeGraphType, false);
      }
    }
  }

  loadCompletedJobs(toDownload?: boolean) {
    this.resetAllData();
    this.chartService
      .getAllCharts(this.depName, this.dateFilterValue, this.granularityValue)
      .subscribe((data) => {
        this.allChartsData = JSON.parse(JSON.stringify(data));
        this.spinner.hide("loadingGraphs");
        if (
          this.allChartsData?.length > 0 &&
          this.allChartsData["coreUsage"]?.length != 0
        ) {
          this.daysValue =
            "From " +
            new DatePipe("en-US").transform(
              this.allChartsData["coreUsage"][0]
                ? new Date(this.allChartsData["coreUsage"][0].timeStamp)
                : new Date(),
              "yyyy-MM-dd, HH:mm:ss"
            ) +
            " To " +
            new DatePipe("en-US").transform(
              new Date(
                this.allChartsData["coreUsage"][
                  this.allChartsData["coreUsage"]?.length - 1
                ].timeStamp
              ),
              "yyyy-MM-dd, HH:mm:ss"
            );
        } else {
          this.daysValue = "From - to -";
        }
        this.queuedJobs = this.allChartsData["queuedJobCount"];
        this.runningJobs = this.allChartsData["runningJobCount"];
        this.completedJobs = this.allChartsData["completedJobCount"];
        if (toDownload) {
          this.downloadCsv(
            [this.queuedJobs, this.runningJobs, this.completedJobs],
            ["Queued", "Running", "Completed"],
            `${Graphs.JobCompleted}-${this.depName}.csv`
          );
        }

        if (this.queuedJobs != 0) {
          this.allJobsData.datasets[0].data.push(this.queuedJobs);
        } else {
          this.allJobsData.datasets[0].data.push(null);
        }
        if (this.runningJobs != 0) {
          this.allJobsData.datasets[0].data.push(this.runningJobs);
        } else {
          this.allJobsData.datasets[0].data.push(null);
        }
        if (this.completedJobs != 0) {
          this.allJobsData.datasets[0].data.push(this.completedJobs);
        } else {
          this.allJobsData.datasets[0].data.push(null);
        }

        this.allJobsData.labels.push("Queued", "Running", "Completed");
        this.allJobsOptions = {
          responsive: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                boxWidth: 15,
              },
            },
            title: {
              display: true,
              text: `Job Status Summary - ${this.dateFilterValue
                .replace("to", " to ")
                .replace(" days", "")} ${
                this.dateFilterValue.includes("to") ? "" : "Days"
              }`,
              position: "top",
            },
            datalabels: {
              formatter: (value) => {
                var perc = value;
                return perc;
              },
            },
          },
        };
      });
  }

  loadJobSummary(toDownload?: boolean) {
    this.resetAllData();
    this.chartService
      .getAllCharts(
        this.depName,
        this.dateFilterValue,
        this.granularityValue,
        this.userSelected
      )
      .subscribe((data) => {
        this.allChartsData = JSON.parse(JSON.stringify(data));
        this.spinner.hide("loadingGraphs");
        if (
          this.allChartsData?.length > 0 &&
          this.allChartsData["coreUsage"]?.length != 0
        ) {
          this.daysValue =
            "From " +
            new DatePipe("en-US").transform(
              this.allChartsData["coreUsage"][0]
                ? new Date(this.allChartsData["coreUsage"][0].timeStamp)
                : new Date(),
              "yyyy-MM-dd, HH:mm:ss"
            ) +
            " To " +
            new DatePipe("en-US").transform(
              new Date(
                this.allChartsData["coreUsage"][
                  this.allChartsData["coreUsage"]?.length - 1
                ].timeStamp
              ),
              "yyyy-MM-dd, HH:mm:ss"
            );
        } else {
          this.daysValue = "From - to -";
        }
        this.failedJobs = this.allChartsData["failedJobCount"];
        this.cancelledJobs = this.allChartsData["canceledJobCount"];
        this.succeededJobs = this.allChartsData["succeedJobCount"];
        this.jobsSummaryData.datasets[0].data.push(
          this.failedJobs,
          this.cancelledJobs,
          this.succeededJobs
        );
        this.totalJobsCompleted =
          this.failedJobs + this.cancelledJobs + this.succeededJobs;
        if (toDownload) {
          this.downloadCsv(
            [this.failedJobs, this.cancelledJobs, this.succeededJobs],
            ["Failed", "Cancelled", "Succeeded"],
            `${Graphs.JobSummary}-${this.depName}.csv`
          );
        }
        this.jobsSummaryData.labels.push("Failed", "Cancelled", "Succeeded");
        this.jobsSummaryOptions = {
          responsive: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                boxWidth: 15,
              },
            },
            title: {
              display: true,
              text:
                "Jobs Completed : " +
                this.totalJobsCompleted +
                ` Jobs - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              position: "top",
            },
            datalabels: {
              formatter: (value) => {
                var perc = value;
                return perc;
              },
              display: (context) => {
                return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.coreUsageByNodeGroupsChartData.datasets[0].data, 0);
              },
            },
          },
        };
      });
  }

  loadStorageCharts(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getSpecificChart(
        this.depName,
        Graphs.StorageUsage,
        this.dateFilterValue,
        this.granularityValue,
        this.userSelected
      )
      .subscribe({
        next: (data) => {
        let storageUsage = [];
        this.storageData = [];
        this.storageData = <StorageUsage[]>JSON.parse(JSON.stringify(data));
        this.spinner.hide("loadingGraphs");
        if(this.allChartsData?.length  > 0 && this.allChartsData['coreUsage']?.length != 0){
          this.daysValue =
            'From ' +
            new DatePipe('en-US').transform(
              this.allChartsData['coreUsage'][0]
                ? new Date(this.allChartsData['coreUsage'][0].timeStamp)
                : new Date(),
              'yyyy-MM-dd, HH:mm:ss'
            ) +
            ' To ' +
            new DatePipe('en-US').transform(
              new Date(
                this.allChartsData['coreUsage'][
                  this.allChartsData['coreUsage']?.length - 1
                ].timeStamp
              ),
              'yyyy-MM-dd, HH:mm:ss'
            );
        } else {
          this.daysValue = 'From - to -'
        }
        if(toDownload){
          let headers = Object.keys(data[0]);
          this.downloadCsv(data, headers, `${Graphs.StorageUsage}-${this.depName}.csv`);
          this.spinner.hide("loadingGraphs");
        }
        this.storageData.forEach((x) => {
          storageUsage.push(x.storageUsage);
          this.storageChartData.datasets[0].data.push(x.storageUsage);
          let date;
          if (this.granularityValue == 'One Hour') {
            date = formatDate(
              new Date(x.timeStamp),
              'shortTime',
              'en-US'
            ).split(',')[0];
          } else {
            date = formatDate(new Date(x.timeStamp), 'longDate', 'en-US').split(
              ','
            )[0];
          }
          this.storageChartData.labels.push(date);
        });
        this.storageChartOptions = {
          ...this.storageChartOptions,
          scales: {
            x: {
              grid: {
                color: 'rgba(255,0,0,0.1)',
                borderColor: 'black',
              },
              title: {
                display: true,
                text: "Date"
              }
              },
            'y-axis-0': {
              position: 'left',
              grid: {
                color: 'rgba(255,0,0,0.1)',
                borderColor: 'black',
              },
              min: 0,
              max: Math.max(...storageUsage) + 10,
              title: {
                display: true,
                text: 'Usage in GB'
              }
              },
            },
          plugins: {
            ...this.storageChartOptions.plugins,
            title: {
              display: true,
              text: `Storage Usage (GB) - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              position: 'top',
            },
          },
        };
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        }
      });
  }

  loadCoresPerDay(toDownload?: boolean) {
    this.resetAllData();
    this.chartService
      .getSpecificChart(
        this.depName,
        Graphs.CoreUsage,
        this.dateFilterValue,
        this.granularityValue,
        this.userSelected
      )
      .subscribe((data) => {
        this.coresData = <CoreUsage[]>JSON.parse(JSON.stringify(data));
        let avgRunCoresData = [];
        let medRunCoresData = [];
        this.coresPerDayData["datasets"][0].data = [];
        this.coresPerDayData["datasets"][1].data = [];
        this.coresPerDayData["datasets"][2].data = [];
        this.coresPerDayData["datasets"][3].data = [];
        this.coresPerDayData.labels = [];
        let runningCores = this.coresData.map((d) => d.runningCores);
        let totalRunningCores = this.coresData
          .map((d) => d.runningCores)
          .reduce((sum, current) => sum + current, 0);
        let totalRunningCoresAverage = Math.round(
          totalRunningCores / this.coresData.length
        );
        let median = this.calculateMedian(runningCores);
        if (toDownload) {
          let headers = Object.keys(data[0]);
          this.downloadCsv(
            data,
            headers,
            `${Graphs.CoreUsage}-${this.depName}.csv`
          );
        }
        this.realQueuedCores = [];
        this.realRunningCores = [];
        this.realActiveCores = [];
        this.spinner.hide("loadingGraphs");
        if (
          this.allChartsData?.length > 0 &&
          this.allChartsData["coreUsage"]?.length != 0
        ) {
          this.daysValue =
            "From " +
            new DatePipe("en-US").transform(
              this.allChartsData["coreUsage"][0]
                ? new Date(this.allChartsData["coreUsage"][0].timeStamp)
                : new Date(),
              "yyyy-MM-dd, HH:mm:ss"
            ) +
            " To " +
            new DatePipe("en-US").transform(
              new Date(
                this.allChartsData["coreUsage"][
                  this.allChartsData["coreUsage"]?.length - 1
                ].timeStamp
              ),
              "yyyy-MM-dd, HH:mm:ss"
            );
        } else {
          this.daysValue = "From - to -";
        }
        this.coresData.forEach((x) => {
          this.coresPerDayData["datasets"][0].data.push(x.queuedCores);
          this.realQueuedCores.push(x.queuedCores);
          this.realRunningCores.push(x.runningCores);
          this.realActiveCores.push(x.activeCores);
          avgRunCoresData.push(totalRunningCoresAverage);
          this.coresPerDayData["datasets"][1].data.push(x.runningCores);
          let date;
          this.coresPerDayData["datasets"][3].data.push(x.activeCores);
          medRunCoresData.push(median);
          if (this.granularityValue == "One Hour") {
            date = formatDate(
              new Date(x.timeStamp),
              "shortTime",
              "en-US"
            ).split(" ")[0];
          } else {
            date = formatDate(new Date(x.timeStamp), "longDate", "en-US").split(
              ","
            )[0];
          }
          this.coresPerDayData["labels"].push(date);
        });
        this.coresPerDayData["datasets"][2].data = avgRunCoresData;
        this.coresPerDayData["datasets"][4].data = medRunCoresData;
        this.coresPerDayOptions = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              title: {
                display: true,
                text: "Date"
              }
            },
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: "Average Cores"
              }
            },
          },
          plugins: {
            legend: {
              position: "bottom",
            },
          title: {
            display: true,
            text: `Average Core Usage - ${totalRunningCoresAverage} Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
            position: "top",
          },
            datalabels: {
              anchor: "end",
              align: "end",
              display: (context) => {
                return (
                  +context.dataset.data[context.dataIndex] >
                  this.getDataLabelUsableValue(this.coresPerDayData.datasets[0].data)
                );
              },
            },
          },
        };
        this.spinner.hide("loadingGraphs");
        this.charts.forEach((child) => {
          child.chart.update();
        });
      });
  }

  loadJobDataCount(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.chartService.getJobCountData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data: JobCountData[]) => {
          this.spinner.hide("loadingGraphs");
        if(toDownload){
            let headers = Object.keys(data[0]);
          this.downloadCsv(data, headers, `${Graphs.JobDataCount}-${this.depName}.csv`);
          }
          let totalJobData = [];
          let succeededJobData = [];
          let failedJobData = [];
          let cancelledJobData = [];
        let totalJobsArr = data.map(d => d.totalJobCount);
        let totalJobs = totalJobsArr.reduce((sum, current) => sum + current, 0);
        let average = Math.round(totalJobs / data.length);
        let median = this.calculateMedian(totalJobsArr);
          if (data == null) return;
          let jobAvgData = [];
          let jobLabel = [];
        let jobAvgMedian = [];
        data = data.sort((a, b) => Date.parse(a.timeStamp) - Date.parse(b.timeStamp));
        data.forEach(e => {
            totalJobData.push(e.totalJobCount);
            succeededJobData.push(e.succeededCount);
            failedJobData.push(e.failedCount);
            cancelledJobData.push(e.cancelledCount);
            jobAvgData.push(average);
          jobAvgMedian.push(median);
            let date;
            if (this.granularityValue == "One Hour") {
            date = formatDate(new Date(e.timeStamp), "h:mm aa", "en-US").split(")")[0];
            } else {
            date = formatDate(new Date(e.timeStamp), "mediumDate", "en-US").split(",")[0];
            }
            jobLabel.push(date);
          });
        this.jobCountChartData['datasets'][0].data = totalJobData;
        this.jobCountChartData['datasets'][1].data = succeededJobData;
        this.jobCountChartData['datasets'][2].data = failedJobData;
        this.jobCountChartData['datasets'][3].data = cancelledJobData;
        this.jobCountChartData['datasets'][4].data = jobAvgData;
        this.jobCountChartData['datasets'][5].data = jobAvgMedian;
        this.jobCountChartData['labels'] = jobLabel;
        this.jobCountChartOptions = {
          ...this.jobCountChartOptions,
          plugins: {
              ...this.jobCountChartOptions.plugins,
              title: {
              display: true,
              position: "top",
              text: `Job Submit Count - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
            },
          }
        };
          this.updateGraphs();
        },
      error: (err => {
        this.spinner.hide("loadingGraphs");
      })
      });
  }

  loadCoresByApplication(toDownload?: boolean) {
    this.chartService
      .getCoresByApplicationData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          this.coresByApplicationChartData["datasets"].forEach(
            (d) => (d.data = [])
          );
          let coresByApplicationData: CoresByApplicationI[] = JSON.parse(
            JSON.stringify(data)
          );
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              coresByApplicationData,
              headers,
              `${Graphs.CoresByApplication}-${this.depName}.csv`
            );
          }
          let coresData = [];
          let coresLabels = [];
          coresByApplicationData.forEach((data) => {
            coresData.push(data.totalCores);
            coresLabels.push(data.jobApplication);
          });
          this.coresByApplicationChartData["datasets"][0].data = coresData;
          this.coresByApplicationChartData["labels"] = coresLabels;
          this.coresByApplicationChartOptions = {
            ...this.coresByApplicationChartOptions,
            plugins: {
              ...this.coresByApplicationChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Cores By Application - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {},
      });
  }

  loadJobByApplicationData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.chartService
      .getJobByApplicationData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          this.jobByApplicationData.datasets.forEach((d) => (d.data = []));
          this.jobByApplicationData["labels"] = [];
          let jobByApplicationCompleteData: JobByApplicationGraphDataI =
            JSON.parse(JSON.stringify(data));
          let jobByApplicationData: JobByApplicationI[] = JSON.parse(
            JSON.stringify(jobByApplicationCompleteData?.jobByApplication)
          );
          let jobByApplicationPerDayData: JobByApplicationsPerDayI[] =
            JSON.parse(
              JSON.stringify(
                jobByApplicationCompleteData?.jobByApplicationsPerDay
              )
            );

          //this.loadTabularData(JSON.parse(JSON.stringify(jobByApplicationData)));

          var filteredData = this.groupByApplication(
            jobByApplicationData,
            "jobApplication"
          );

          var filteredDataPerDay = this.groupByNodes(
            jobByApplicationPerDayData,
            "timeStamp"
          );

          if (toDownload) {
            let headers = Object.keys(data[0]);
            let jobAppData = JSON.parse(JSON.stringify(jobByApplicationData));
            jobAppData.forEach((e) => {
              if (e.jobStageStatus == 1) {
                e.jobStageStatus = "Cancelled";
              } else if (e.jobStageStatus == 5) {
                e.jobStageStatus = "Failed";
              } else if (e.jobStageStatus == 11) {
                e.jobStageStatus = "Succeeded";
              }
            });
            this.downloadCsv(
              jobAppData,
              headers,
              `${Graphs.JobByApplication}-${this.depName}.csv`
            );
          }
          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobs = 0;
            this.jobByApplicationData["datasets"][0].data[idx] = 0;
            this.jobByApplicationData["datasets"][1].data[idx] = 0;
            this.jobByApplicationData["datasets"][2].data[idx] = 0;
            filteredData[key].forEach((e) => {
              if (e.jobStageStatus == 1) {
                this.jobByApplicationData["datasets"][1].data[idx] +=
                  e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 5) {
                this.jobByApplicationData["datasets"][2].data[idx] +=
                  e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 11) {
                this.jobByApplicationData["datasets"][0].data[idx] +=
                  e.totalCount;
                  totalJobs = totalJobs + e.totalCount;
              }
            });
            this.jobByApplicationData['labels'].push(key + " : " + totalJobs);  
          });
          this.jobByApplicationOptions = {
            ...this.jobByApplicationOptions,
            plugins: {
              ...this.jobByApplicationOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Application - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              },
            },
          };

          this.applicationNames = [];
          this.appsArray?.clear();
          this.applicationNames =
            jobByApplicationCompleteData?.applicationNames?.split(",");
          this.applicationNames.forEach(() =>
            this.appsArray.push(new FormControl(false))
          );

          this.jobByApplicationsPerDayChartData["datasets"] = [];
          this.jobByApplicationsPerDayChartData["labels"] = [];

          this.applicationNames.forEach((name, index) => {
            this.jobByApplicationsPerDayChartData["datasets"].push({
              data: [],
              type: "line",
              label: name,
              order: 1,
              fill: false,
            });
          });

          if (filteredDataPerDay) {
            Object.keys(filteredDataPerDay).forEach((key, idx) => {
              if (filteredDataPerDay[key]) {
                this.applicationNames.forEach((name, index) => {
                  const count = filteredDataPerDay[key]
                    .filter(
                      (tag) =>
                        tag.application.toLowerCase() == name.toLowerCase()
                    )
                    .map((x) => x.totalCount)[0];
                  if (count) {
                    this.jobByApplicationsPerDayChartData["datasets"][
                      index
                    ].data[idx] = count;
                  } else {
                    this.jobByApplicationsPerDayChartData["datasets"][
                      index
                    ].data[idx] = 0;
                  }
                });
              }

              if (key) {
                let date;
                let dateFilter = this.dateFilterValue;
                if (
                  dateFilter != "1" &&
                  (this.dateFilterValue.indexOf("days") != -1 ||
                    this.dateFilterValue.indexOf("to") != -1)
                ) {
                  date = formatDate(new Date(key), "mediumDate", "en-US").split(
                    ","
                  )[0];
                } else {
                  date = formatDate(new Date(key), "h:mm aa", "en-US").split(
                    ")"
                  )[0];
                }
                if (date) {
                  this.jobByApplicationsPerDayChartData["labels"].push(date);
                } else {
                  this.jobByApplicationsPerDayChartData["labels"].push(key);
                }
              }
            });
          }

          this.jobByApplicationOptions = {
            ...this.jobByApplicationOptions,
            plugins: {
              ...this.jobByApplicationOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Application - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              },
            },
          };

          this.jobByApplicationDataTemp = JSON.parse(
            JSON.stringify(this.jobByApplicationData)
          );

          this.updateGraphs();
          this.spinner.hide("loadingGraphs");
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  loadJobWaitTimeData(toDownload?: boolean) {
    this.chartService
      .getJobWaitTimeData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          let jobWaitData = <JobWaitTimeI[]>JSON.parse(JSON.stringify(data));
          let avgJobInitDuration = jobWaitData
            .map((j) => j.jobInitDuration)
            .reduce((sum, current) => sum + current, 0);
          let avgCopyDataDuration = jobWaitData
            .map((j) => j.jobDataCopyDuration)
            .reduce((sum, current) => sum + current, 0);
          let avgJobSubmitDuration = jobWaitData
            .map((j) => j.jobSubmitDuration)
            .reduce((sum, current) => sum + current, 0);
          let avgResourceDuration = jobWaitData
            .map((j) => j.jobResourceWaitDuration)
            .reduce((sum, current) => sum + current, 0);
          let avgLicenseWaitDuration = jobWaitData
            .map((j) => j.jobLicenseWaitDuration)
            .reduce((sum, current) => sum + current, 0);
          let avgExtraDuration = jobWaitData
            .map((j) => j.jobExtraWaitDuration)
            .reduce((sum, current) => sum + current, 0);
          if (toDownload) {
            this.downloadCsv(
              [
                avgJobInitDuration,
                avgCopyDataDuration,
                avgJobSubmitDuration,
                avgResourceDuration,
                avgLicenseWaitDuration,
                avgExtraDuration,
              ],
              [
                "JobInitAvg",
                "JobDataCopyAvg",
                "JobSubmitAvg",
                "NoResourceAvg",
                "NoLicenseAvg",
                "OtherAvg",
              ],
              `${Graphs.JobWaitTime}-${this.depName}.csv`
            );
          }
          this.jobWaitTimeChartData["datasets"][0].data = [
            Number(avgJobInitDuration),
            Number(avgCopyDataDuration),
            Number(avgJobSubmitDuration),
            Number(avgResourceDuration),
            Number(avgLicenseWaitDuration),
            Number(avgExtraDuration),
          ];
          this.jobWaitTimeChartData["labels"] = [
            `JobInit : Avg ${avgJobInitDuration}`,
            `JobDataCopy : Avg ${avgCopyDataDuration}`,
            `JobSubmit : Avg ${avgJobSubmitDuration}`,
            `NoResource : Avg ${avgResourceDuration}`,
            `NoLicense : Avg ${avgLicenseWaitDuration}`,
            `Others : Avg ${avgExtraDuration}`,
          ];
          //this.jobWaitTimeChartData['datasets'][0].backgroundColor, this.jobWaitTimeChartData['datasets'][0].hoverBackgroundColor, this.jobWaitTimeChartData['datasets'][0].borderColor = [this.getDynamicColor(), this.getDynamicColor(), this.getDynamicColor(), this.getDynamicColor(), this.getDynamicColor()]
          this.jobWaitTimeChartOptions = {
            ...this.jobWaitTimeChartOptions,
            plugins: {
              ...this.jobWaitTimeChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job Avg Wait Time ( In Mins ) - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.spinner.hide("loadingGraphs");
          this.updateGraphs();
        },
        error: (err) => {},
      });
  }

  loadNodeAvailabilityDataCount(toDownload?: boolean) {
    this.chartService.getNodeAvailabilityData(this.depName, this.dateFilterValue, this.granularityValue).subscribe({
        next: (data: NodeAvailabilityI[]) => {
          if (data == null) return;
          let availableNodeData = [];
          let unAvailableNodeData = [];
          let busyNodeData = [];
        let totalBusy = data.map(d => d.busyNodes).reduce((sum, current) => sum + current, 0);
        let average = +parseFloat((totalBusy / data.length).toString()).toFixed(2);
        if(toDownload){
            let headers = Object.keys(data[0]);
          this.downloadCsv(data, headers, `${Graphs.NodeAvailability}-${this.depName}.csv`);
          }
        this.nodeAvailabilityChartOptions = {
          ...this.nodeAvailabilityChartOptions,
          plugins:{
            ...this.nodeAvailabilityChartOptions.plugins,
            title: {
              display: true,
              position: "top",
              text: `Nodes Utilization - Average ${average} Busy Nodes - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
            },
          }
        }
          let nodesAvgData = [];
          let nodesLabel = [];
        data = data.sort((a, b) => Date.parse(a.timeStamp) - Date.parse(b.timeStamp));
        data.forEach(e => {
            availableNodeData.push(e.availableNodes + e.busyNodes);
            unAvailableNodeData.push(e.unAvailableNodes);
            busyNodeData.push(e.busyNodes);
            nodesAvgData.push(average);
            let date;
            if (this.granularityValue == "One Hour") {
            date = formatDate(new Date(e.timeStamp), "h:mm aa", "en-US").split(")")[0];
            } else {
            date = formatDate(new Date(e.timeStamp), "mediumDate", "en-US").split(",")[0];
            }
            nodesLabel.push(date);
          });
        this.nodeAvailabilityData['datasets'][0].data = availableNodeData;
        this.nodeAvailabilityData['datasets'][1].data = unAvailableNodeData;
        this.nodeAvailabilityData['datasets'][2].data = busyNodeData;
          // this.nodeAvailabilityChartData[3].data = nodesAvgData;
        this.nodeAvailabilityData['labels']= nodesLabel;
          this.spinner.hide("loadingGraphs");
          this.updateGraphs();
        },
      });
  }

  loadJobByUserData(toDownload?: boolean) {
    let uNames = this.myForm.value?.userNames?.map((un) => un.item_text);
    if (uNames.length == 0) {
      this.snackbar.open("Please select minimum 1 user to proceed.", "Ok", {
        duration: 4000,
      });
      this.spinner.hide("loadingGraphs");
      return;
    }
    this.chartService
      .getByUserData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue,
        uNames
      )
      .subscribe({
        next: (data) => {
          let jobByUsers = <JobByUserI[]>JSON.parse(JSON.stringify(data));
          this.jobByUserChartData["datasets"].forEach((d) => (d.data = []));
          this.jobByUserChartData["labels"] = [];
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.JobByUser}-${this.depName}.csv`
            );
          }
          //jobByUsers.length = jobByUsers.length >= 15 ? 15 : jobByUsers.length;
          let colors = [];
          jobByUsers.forEach((job, i) => {
            this.jobByUserChartData["datasets"][0].data.push(job.totalJobs);
          });
          let filteredData = this.groupByApplication(
            jobByUsers,
            "userProfileId"
          );

          if (filteredData) {
            const myDictionary: Dictionary = Object.keys(filteredData).reduce(
              (acc, key) => {
                let totalJobsPerUser = 0;
                totalJobsPerUser = filteredData[key].reduce(
                  (accumulator, currentValue) =>
                    accumulator + currentValue.totalJobs,
                  0
                );
                acc[key] = totalJobsPerUser;
                return acc;
              },
              {} as Dictionary
            );

            if (myDictionary) {
              const entries: [string, number][] = Object.entries(myDictionary);
              if (entries) {
                entries?.sort((a, b) => b[1] - a[1]);
              }
              let keys = entries?.map((x) => x[0]);

              if (keys) {
                keys.forEach((key, idx) => {
                  //if (idx <= 14) {
                  let totalJobsPerUser = filteredData[key].reduce(
                    (accumulator, currentValue) =>
                      accumulator + currentValue.totalJobs,
                    0
                  );

                  this.jobByUserChartData["datasets"][0].data[idx] = 0;
                  this.jobByUserChartData["datasets"][1].data[idx] = 0;
                  this.jobByUserChartData["datasets"][2].data[idx] = 0;
                  filteredData[key].forEach((e: any) => {
                    if (e.jobStageStatus == 1) {
                      this.jobByUserChartData["datasets"][1].data[idx] +=
                        e.totalJobs;
                    } else if (e.jobStageStatus == 5) {
                      this.jobByUserChartData["datasets"][2].data[idx] +=
                        e.totalJobs;
                    } else if (e.jobStageStatus == 11) {
                      this.jobByUserChartData["datasets"][0].data[idx] +=
                        e.totalJobs;
                    }
                  });
                  this.jobByUserChartData.labels.push(
                    key + " : " + totalJobsPerUser + " Jobs"
                  );
                  //}
                });
              }
            }
          }

          this.jobByUserChartOptions = {
            ...this.jobByUserChartOptions,
            plugins: {
              ...this.jobByUserChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Users - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              },
            },
          };
          this.spinner.hide("loadingGraphs");
          this.updateGraphs();
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  loadJobByGroupsData(toDownload?: boolean) {
    let gNames = this.myForm.value?.userGroupNames?.map((gn) => gn.item_text);
    if (gNames?.length == 0) {
      this.snackbar.open("Please select minimum 1 group to proceed.", "Ok", {
        duration: 4000,
      });
      this.spinner.hide("loadingGraphs");
      return;
    }
    this.chartService
      .getByGroupData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue,
        gNames.toString()
      )
      .subscribe({
        next: (data: any) => {
          this.spinner.hide("loadingGraphs");
          data = data.reduce((ob, curr) => {
            const avl = ob.find((o) => o.groupName == curr.groupName);
            if (avl) {
              avl.totalJobs += curr.totalJobs;
              return ob;
            }
            ob.push(curr);
            return ob;
          }, []);
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.JobByGroup}-${this.depName}.csv`
            );
          }
          let jobByGroups = <JobByGroupI[]>JSON.parse(JSON.stringify(data));
          this.jobByGroupChartData["datasets"][0].data = [];
          this.jobByGroupChartData["labels"] = [];
          let colors = [];
          jobByGroups.forEach((job, i) => {
            this.jobByGroupChartData["datasets"][0].data.push(job.totalJobs);
            this.jobByGroupChartData["labels"].push(
              `${job.groupName} : ${job.totalJobs}`
            );
            colors.push(this.getDynamicColor());
          });
          //this.jobByGroupChartData['datasets'][0].backgroundColor, this.jobByGroupChartData['datasets'][0].hoverBackgroundColor, this.jobByGroupChartData['datasets'][0].borderColor = colors;
          this.updateGraphs();
        },
        error: (err) => {},
      });
  }

  loadCoreHoursByUsers(toDownload?: boolean) {
    let uNames = this.myForm.value?.coreHourUserNames?.map(
      (un) => un.item_text
    );
    if (uNames.length == 0) {
      this.snackbar.open("Please select minimum 1 user to proceed.", "Ok", {
        duration: 4000,
      });
      this.spinner.hide("loadingGraphs");
    }
    this.chartService
      .getCoreHoursByUsersData(
        this.depName,
        this.dateFilterValue,
        uNames.join(",")
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.CoreHoursByUsers}-${this.depName}.csv`
            );
          }
          this.coreHoursByUsersPieData['datasets'][0].data = [];
          this.coreHoursByUsersPieData['labels'] = [];
          let coreHourByUsers = <CoreHoursByUsers[]>(
            JSON.parse(JSON.stringify(data))
          );
          coreHourByUsers = coreHourByUsers.sort(
            (a, b) => b.jobCores - a.jobCores
          );
          let limit = 15;
          this.coreHoursByUsersChartData["datasets"][0].data = [];
          this.coreHoursByUsersChartData["labels"] = [];
          let colors = [];
          coreHourByUsers.forEach((job, i) => {
            if (i < limit) {
              this.coreHoursByUsersPieData['datasets'][0].data.push(job.jobCores);
              this.coreHoursByUsersPieData['labels'].push(`${job.userProfileId}`);
              this.coreHoursByUsersChartData["datasets"][0].data.push(
                job.jobCores
              );
              this.coreHoursByUsersChartData["labels"].push(
                `${job.userProfileId}`
              );
              colors.push(this.getDynamicColor());
            }
          });
          if (coreHourByUsers.length > limit) {
            this.coreHoursByUsersPieData['datasets'][0].data.push(coreHourByUsers.slice(limit).reduce((a, b) => a + b.jobCores, 0));
            this.coreHoursByUsersPieData['labels'].push(`Others`);
            this.coreHoursByUsersChartData["datasets"][0].data.push(
              coreHourByUsers.slice(limit).reduce((a, b) => a + b.jobCores, 0)
            );
            this.coreHoursByUsersChartData["labels"].push(`Others`);
            colors.push(this.getDynamicColor());
          }
          this.coreHoursByUsersChartData["datasets"][0].backgroundColor =
            "#0072c6";
          this.coreHoursByUsersChartData["datasets"][0].borderColor = "#0072c6";
          this.coreHoursByUsersChartData["datasets"][0].hoverBorderColor =
            "#0072c6";
          this.coreHoursByUsersChartData["datasets"][0].hoverBackgroundColor =
            "#0072c6";

          this.coreHoursByUsersPieColors = [{
            backgroundColor: colors
          }];
          this.coreHoursByUsersChartOptions = {
            ...this.coreHoursByUsersChartOptions,
            plugins: {
              ...this.coreHoursByUsersChartOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Users - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              },
            },
          };
          this.coreHoursByUsersPieOptions = {
            ...this.coreHoursByUsersPieOptions,
            plugins: {
              ...this.coreHoursByUsersPieOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Users - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
        },
        error: (err) => {},
      });
  }

  loadJobByNodesData(toDownload?: boolean) {
    this.chartService
      .getJobByNodesData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          this.jobByNodesData["datasets"].forEach((d) => (d.data = []));
          let jobByNodesData: JobByNodesI[] = JSON.parse(JSON.stringify(data));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.JobByNodes}-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }
          this.spinner.hide("loadingGraphs");
          let soloNodes: JobByNodesI[] = jobByNodesData.filter(
            (n) => !n.jobAllocatedNodes.includes(",")
          );
          let multiNodes: JobByNodesI[] = jobByNodesData.filter((n) =>
            n.jobAllocatedNodes.includes(",")
          );
          multiNodes.forEach((element) => {
            element.jobAllocatedNodes.split(",").forEach((node) => {
              soloNodes.push({ ...element, jobAllocatedNodes: node });
            });
          });
          jobByNodesData = soloNodes;

          var filteredData = this.groupByNodes(
            jobByNodesData,
            "jobAllocatedNodes"
          );
          this.jobByNodesData["labels"] = [];
          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobs = 0;
            this.jobByNodesData["datasets"][0].data[idx] = 0;
            this.jobByNodesData["datasets"][1].data[idx] = 0;
            this.jobByNodesData["datasets"][2].data[idx] = 0;
            filteredData[key].forEach((e) => {
              if (e.jobStageStatus == 1) {
                this.jobByNodesData["datasets"][1].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 5) {
                this.jobByNodesData["datasets"][2].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 11) {
                this.jobByNodesData["datasets"][0].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              }
            });
            this.jobByNodesData["labels"].push(key + " : " + totalJobs);
          });
          this.jobByNodesOptions = {
            ...this.jobByNodesOptions,
            plugins: {
              ...this.jobByNodesOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Nodes - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };
          this.updateGraphs();
          this.spinner.hide("loadingGraphs");
        },
        error: (err) => {},
      });
  }

  loadJobByTagsData(toDownload?: boolean) {
    this.resetAllData();
    let tNames = this.myForm.value?.jobTags?.map((gn) => gn.item_text);
    if (tNames?.length == 0) {
      this.snackbar.open("Please select minimum 1 tag to proceed.", "Ok", {
        duration: 4000,
      });
      this.spinner.hide("loadingGraphs");
      return;
    }
    this.chartService
      .getJobTagData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue,
        tNames?.toString()
      )
      .subscribe({
        next: (data) => {
          this.jobByTagsData["datasets"].forEach((d) => (d.data = []));
          this.jobByTagsData["labels"] = [];
          let jobByTagsData: JobByTagsI[] = JSON.parse(JSON.stringify(data));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.JobByTags}-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }
          this.spinner.hide("loadingGraphs");
          let soloNodes: JobByTagsI[] = jobByTagsData.filter(
            (n) => !n.jobTag?.includes(",")
          );
          let multiNodes: JobByTagsI[] = jobByTagsData.filter((n) =>
            n.jobTag?.includes(",")
          );
          multiNodes.forEach((element) => {
            element.jobTag?.split(",").forEach((node) => {
              if (tNames != null && tNames?.indexOf(node) != -1) {
                soloNodes.push({ ...element, jobTag: node });
              }
            });
          });
          jobByTagsData = soloNodes;

          var filteredData = this.groupByNodes(jobByTagsData, "jobTag");

          if (filteredData) {
            const myDictionary: Dictionary = Object.keys(filteredData).reduce(
              (acc, key) => {
                let totalJobsPeTag = 0;
                totalJobsPeTag = filteredData[key].reduce(
                  (accumulator, currentValue) =>
                    accumulator + currentValue.totalCount,
                  0
                );
                acc[key] = totalJobsPeTag;
                return acc;
              },
              {} as Dictionary
            );

            if (myDictionary) {
              const entries: [string, number][] = Object.entries(myDictionary);
              entries?.sort((a, b) => b[1] - a[1]);
              let keys = entries?.map((x) => x[0]);

              if (keys) {
                keys.forEach((key, idx) => {
                  let totalJobsPerTag = filteredData[key].reduce(
                    (accumulator, currentValue) =>
                      accumulator + currentValue.totalCount,
                    0
                  );

                  this.jobByTagsData["datasets"][0].data[idx] = 0;
                  this.jobByTagsData["datasets"][1].data[idx] = 0;
                  this.jobByTagsData["datasets"][2].data[idx] = 0;

                  filteredData[key].forEach((e: any) => {
                    if (e.jobStageStatus == 1) {
                      this.jobByTagsData["datasets"][1].data[idx] +=
                        e.totalCount;
                    } else if (e.jobStageStatus == 5) {
                      this.jobByTagsData["datasets"][2].data[idx] +=
                        e.totalCount;
                    } else if (e.jobStageStatus == 11) {
                      this.jobByTagsData["datasets"][0].data[idx] +=
                        e.totalCount;
                    }
                  });
                  this.jobByTagsData["labels"].push(
                    key + " : " + totalJobsPerTag + " Jobs"
                  );
                });
              }
            }
          }

          this.jobByTagsOptions = {
            ...this.jobByTagsOptions,
            plugins: {
              ...this.jobByTagsOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Tags - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              },
            },
          };

          this.updateGraphs();
          this.spinner.hide("loadingGraphs");
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  loadOverviewChartsOfHpcDep() {
    this.resetAllData();
    this.chartService
      .getAllCharts(
        this.depName,
        this.dateFilterValue,
        this.granularityValue,
        this.userSelected
      )
      // .pipe(takeUntil(this.graphRequests[this.selectedMetric]))
      .subscribe((data) => {
        this.allChartsData = JSON.parse(JSON.stringify(data));
        let storageUsage = [];

        this.spinner.hide("loadingGraphs");
        if (
          this.allChartsData?.length > 0 &&
          this.allChartsData["coreUsage"]?.length != 0
        ) {
          this.daysValue =
            "From " +
            new DatePipe("en-US").transform(
              this.allChartsData["coreUsage"][0]
                ? new Date(this.allChartsData["coreUsage"][0].timeStamp)
                : new Date(),
              "yyyy-MM-dd, HH:mm:ss"
            ) +
            " To " +
            new DatePipe("en-US").transform(
              new Date(
                this.allChartsData["coreUsage"][
                  this.allChartsData["coreUsage"]?.length - 1
                ].timeStamp
              ),
              "yyyy-MM-dd, HH:mm:ss"
            );
        } else {
          this.daysValue = "From - to -";
        }
        let medRunCoresData = [];
        let avgRunCoresData = [];
        this.coresPerDayData["datasets"][0].data = [];
        this.coresPerDayData["datasets"][1].data = [];
        this.coresPerDayData["datasets"][2].data = [];
        this.coresPerDayData["datasets"][3].data = [];
        this.coresPerDayData.labels = [];

        let runningCores = this.allChartsData["coreUsage"].map(
          (d) => d.runningCores
        );
        let totalRunningCores =
          runningCores
            ?.map((d) => d.runningCores)
            .reduce((sum, current) => sum + current, 0) || 0;
        let totalRunningCoresAverage =
          Math.round(
            totalRunningCores / this.allChartsData["coreUsage"].length
          ) || 0;
        let median = this.calculateMedian(runningCores);
        this.allChartsData["coreUsage"].forEach((data) => {
          this.coresPerDayData.datasets[0].data.push(data.queuedcores);
          runningCores.push(data.runningCores);
          this.coresPerDayData.datasets[1].data.push(data.runningCores);
          this.coresPerDayData.datasets[3].data.push(data.activeCores);
          this.realActiveCores.push(data.activeCores);
          avgRunCoresData.push(totalRunningCoresAverage);
          medRunCoresData.push(median);
          let date;
          if (this.granularityValue == "One Hour") {
            date = formatDate(
              new Date(data.timeStamp),
              "shortTime",
              "en-US"
            ).split(",")[0];
          } else {
            date = formatDate(
              new Date(data.timeStamp),
              "longDate",
              "en-US"
            ).split(",")[0];
          }
          this.coresPerDayData.labels.push(date);
        });
        this.coresPerDayData.datasets[2].data = avgRunCoresData;
        this.coresPerDayData.datasets[4].data = medRunCoresData;
        this.coresPerDayOptions = {
          ...this.coresPerDayOptions,
          plugins: {
            legend: {
              position: "bottom",
            },
              
          title: {
              display: true,
              text: `Average Core Usage - ${totalRunningCoresAverage} Cores - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              position: "top",
            },
            datalabels: {
              anchor: "end",
              align: "end",
              display: false
            },
          },
        };

        //storageusage
        this.allChartsData["storageUsage"].forEach((data) => {
          storageUsage.push(data.storageUsage);
          this.storageChartData.datasets[0].data.push(data.storageUsage);
          let date;
          if (this.granularityValue == "One Hour") {
            date = formatDate(
              new Date(data.timeStamp),
              "shortTime",
              "en-US"
            ).split(",")[0];
          } else {
            date = formatDate(
              new Date(data.timeStamp),
              "longDate",
              "en-US"
            ).split(",")[0];
          }
          this.storageChartData.labels.push(date);
        });
        this.storageChartOptions = {
          responsive: false,
          scales: {
            x: {},
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              position: "bottom",
              labels: {
                boxWidth: 15,
              },
            },
            title: {
              display: true,
              text: `Storage Usage (GB) - ${this.dateFilterValue
                .replace("to", " to ")
                .replace(" days", "")} ${
                this.dateFilterValue.includes("to") ? "" : "Days"
              }`,
              position: "top",
            },
          },
        };
        this.queuedJobs = this.allChartsData["queuedJobCount"];
        this.runningJobs = this.allChartsData["runningJobCount"];
        this.completedJobs = this.allChartsData["completedJobCount"];

        if (this.queuedJobs != 0) {
          this.allJobsData.datasets[0].data.push(this.queuedJobs);
        } else {
          this.allJobsData.datasets[0].data.push(null);
        }
        if (this.runningJobs != 0) {
          this.allJobsData.datasets[0].data.push(this.runningJobs);
        } else {
          this.allJobsData.datasets[0].data.push(null);
        }
        if (this.completedJobs != 0) {
          this.allJobsData.datasets[0].data.push(this.completedJobs);
        } else {
          this.allJobsData.datasets[0].data.push(null);
        }

        this.allJobsData.labels.push("Queued", "Running", "Completed");
        this.allJobsOptions = {
          responsive: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                boxWidth: 15,
              },
            },
            title: {
              display: true,
              text: `Job Status Summary - ${this.dateFilterValue
                .replace("to", " to ")
                .replace(" days", "")} ${
                this.dateFilterValue.includes("to") ? "" : "Days"
              }`,
              position: "top",
            },
            datalabels: {
              formatter: (value) => {
                var perc = value;
                return perc;
              },
            },
          },
        };
        this.failedJobs = this.allChartsData["failedJobCount"];
        this.cancelledJobs = this.allChartsData["canceledJobCount"];
        this.succeededJobs = this.allChartsData["succeedJobCount"];
        this.jobsSummaryData.datasets[0].data.push(
          this.failedJobs,
          this.cancelledJobs,
          this.succeededJobs
        );
        this.totalJobsCompleted =
          this.failedJobs + this.cancelledJobs + this.succeededJobs;
        this.jobsSummaryData.labels.push("Failed", "Cancelled", "Succeeded");
        this.jobsSummaryOptions = {
          responsive: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                boxWidth: 15,
              },
            },
            title: {
              display: true,
              text:
                "Jobs Completed : " +
                this.totalJobsCompleted +
                ` - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              position: "top",
            },
            datalabels: {
              formatter: (value) => {
                var perc = value;
                return perc;
              },
              display: (context) => {
                return +context.dataset.data[context.dataIndex] > this.getDataLabelUsableValue(this.coreUsageByNodeGroupsChartData.datasets[0].data, 0);
              },
            },
          },
        };
      });
    this.loadJobDataCount();
    this.loadJobByApplicationData();
  }

  calculateMedian(numbers: number[]): number {
    const sortedNumbers = numbers.slice().sort((a, b) => a - b);
    const mid = Math.floor(sortedNumbers.length / 2);

    if (sortedNumbers.length % 2 === 0) {
      // Array has even number of elements, so median is the average of the two middlemost numbers
      return (sortedNumbers[mid - 1] + sortedNumbers[mid]) / 2;
    } else {
      // Array has odd number of elements, so median is the middlemost number
      return sortedNumbers[mid];
    }
  }

  onToggleChange(event) {
    this.isChecked = event.checked;
    if (this.isChecked) {
      if (this.singleNodeSelectedMetric != "all") {
        this.getSingleNodeSpecificChart(
          this.nodeGraphType,
          this.dateFilterValue,
          this.granularityValue,
          false
        );
      } else {
        this.getAllSingleNodeSpecificChart(
          this.nodeGraphType,
          this.dateFilterValue,
          this.granularityValue,
          false
        );
      }
    }
    if (!event.checked) {
      this.isChecked = false;
      this.wsValue = "none";
      this.getSpecificGraphs(this.nodeGraphType, false);
    }
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  resetFilter() {
    this.selectedMetric = "all";
    this.selectedDepMetricFromDashboard = "all";
    this.granularityValue = "One Hour";
    this.wsValue = "none";
    this.dateFilterValue = "1 days";
    this.selectedUser = "none";
    this.depName = "all";
    this.selectedDepMetric = "all";
    this.myForm.value.nodeNames = [];
    this.myForm.value.nodeNames = this.wsNames;
    this.showError = false;
    this.isChecked = false;
    this.showCheck = false;
    this.disableButton();
    this.loadAllCharts();
  }

  resetAllData() {
    this.showError = false;
    this.selectedJobTag = null;
    this.storageChartData.datasets = [{ data: [], label: "Storage" }];
    this.storageChartData.labels = [];
    this.coresPerDayData.labels = [];
    this.coresPerDayData.datasets.forEach((d) => (d.data = []));

    this.jobsSummaryData.datasets = [
      {
        data: [],
      },
    ];
    this.jobsSummaryData.labels = [];
    this.failedJobs = 0;
    this.succeededJobs = 0;
    this.cancelledJobs = 0;

    this.allJobsData.datasets = [
      {
        data: [],
      },
    ];
    this.allJobsData.labels = [];
    this.queuedJobs = 0;
    this.runningJobs = 0;
    this.completedJobs = 0;

    this.graphStartEnd = [];
    this.graphOption = [];
    this.graphConnDiscon = [];

    this.nodeUtilizationDataTotal = {
      datasets: [
        {
          data: [],
          label: "CPU",
          backgroundColor: "rgba(255, 161, 181,0.3)",
          borderColor: "red",
          pointBackgroundColor: "rgba(255, 161, 181,0.3)",
          pointBorderColor: "red",
          pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
          pointHoverBorderColor: "red",
          fill: "origin",
        },
        {
          data: [],
          label: "RAM",
          backgroundColor: "rgba(152, 251, 152, 0.3)",
          borderColor: "#32CD32",
          pointBackgroundColor: "rgba(152, 251, 152, 0.3)",
          pointBorderColor: "#32CD32",
          pointHoverBackgroundColor: "rgba(152, 251, 152, 0.3)",
          pointHoverBorderColor: "#32CD32",
          fill: "origin",
        },
        {
          data: [],
          label: "GPU",
          backgroundColor: "rgba(255,225,153,0.3)",
          borderColor: "gold",
          pointBackgroundColor: "rgba(255,225,153,0.3)",
          pointBorderColor: "gold",
          pointHoverBackgroundColor: "rgba(255,225,153,0.3)",
          pointHoverBorderColor: "gold",
          fill: "origin",
        },
        {
          data: [],
          label: "GPU RAM",
          backgroundColor: "rgba(125, 249, 2553, 0.3)",
          borderColor: "cyan",
          pointBackgroundColor: "rgba(125, 249, 2553, 0.3)",
          pointBorderColor: "cyan",
          pointHoverBackgroundColor: "rgba(125, 249, 2553, 0.3)",
          pointHoverBorderColor: "cyan",
          fill: "origin",
        },
      ],
      labels: [],
    };
    this.nodeUtilizationDataOffice = {
      datasets: [
        {
          data: [],
          label: "CPU",
          backgroundColor: "rgba(255, 161, 181,0.3)",
          borderColor: "red",
          pointBackgroundColor: "rgba(255, 161, 181,0.3)",
          pointBorderColor: "red",
          pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
          pointHoverBorderColor: "red",
          fill: "origin",
        },
        {
          data: [],
          label: "RAM",
          backgroundColor: "rgba(152, 251, 152, 0.3)",
          borderColor: "#32CD32",
          pointBackgroundColor: "rgba(152, 251, 152, 0.3)",
          pointBorderColor: "#32CD32",
          pointHoverBackgroundColor: "rgba(152, 251, 152, 0.3)",
          pointHoverBorderColor: "#32CD32",
          fill: "origin",
        },
        {
          data: [],
          label: "GPU",
          backgroundColor: "rgba(255,225,153,0.3)",
          borderColor: "gold",
          pointBackgroundColor: "rgba(255,225,153,0.3)",
          pointBorderColor: "gold",
          pointHoverBackgroundColor: "rgba(255,225,153,0.3)",
          pointHoverBorderColor: "gold",
          fill: "origin",
        },
        {
          data: [],
          label: "GPU RAM",
          backgroundColor: "rgba(125, 249, 2553, 0.3)",
          borderColor: "cyan",
          pointBackgroundColor: "rgba(125, 249, 2553, 0.3)",
          pointBorderColor: "cyan",
          pointHoverBackgroundColor: "rgba(125, 249, 2553, 0.3)",
          pointHoverBorderColor: "cyan",
          fill: "origin",
        },
      ],
      labels: [],
    };
    this.nodeUtilizationDataNonOffice = {
      datasets: [
        {
          data: [],
          label: "CPU",
          backgroundColor: "rgba(255, 161, 181,0.3)",
          borderColor: "red",
          pointBackgroundColor: "rgba(255, 161, 181,0.3)",
          pointBorderColor: "red",
          pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
          pointHoverBorderColor: "red",
          fill: "origin",
        },
        {
          data: [],
          label: "RAM",
          backgroundColor: "rgba(152, 251, 152, 0.3)",
          borderColor: "#32CD32",
          pointBackgroundColor: "rgba(152, 251, 152, 0.3)",
          pointBorderColor: "#32CD32",
          pointHoverBackgroundColor: "rgba(152, 251, 152, 0.3)",
          pointHoverBorderColor: "#32CD32",
          fill: "origin",
        },
        {
          data: [],
          label: "GPU",
          backgroundColor: "rgba(255,225,153,0.3)",
          borderColor: "gold",
          pointBackgroundColor: "rgba(255,225,153,0.3)",
          pointBorderColor: "gold",
          pointHoverBackgroundColor: "rgba(255,225,153,0.3)",
          pointHoverBorderColor: "gold",
          fill: "origin",
        },
        {
          data: [],
          label: "GPU RAM",
          backgroundColor: "rgba(125, 249, 2553, 0.3)",
          borderColor: "cyan",
          pointBackgroundColor: "rgba(125, 249, 2553, 0.3)",
          pointBorderColor: "cyan",
          pointHoverBackgroundColor: "rgba(125, 249, 2553, 0.3)",
          pointHoverBorderColor: "cyan",
          fill: "origin",
        },
      ],
      labels: [],
    };
    this.specificUtilizationData = {
      datasets: [
        {
          data: [],
          label: "",
          backgroundColor: "rgba(255,225,153,0.3)",
          borderColor: "gold",
          pointBackgroundColor: "rgba(148,159,177,1)",
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
          pointHoverBorderColor: "rgba(148,159,177,0.8)",
          fill: "origin",
        },
      ],
      labels: [],
    };

    this.storageChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          grid: {
            color: 'rgba(255,0,0,0.1)',
            borderColor: 'black',
          },
          title: {
            display: true,
            text: "Date"
            }
        },
        'y-axis-0': {
          position: 'left',
          grid: {
            color: 'rgba(255,0,0,0.1)',
            borderColor: 'black',
          },
          min: 0,
          title: {
            display: true,
            text: 'Usage in GB'
          }
        },
      },
      plugins: {
        datalabels: {
          align: 'bottom',
          font: {
            weight: 'bold'
          },
          clamp: true, // Prevent labels from overflowing outside the chart area
          display: (context) => {
            if(this.selectedMetric == "Overview") return false;
            if(this.graphDataLabelsForm.get('storageUsage').value === false) {
              return false;
            }
            return true
          }
        },
      }
    };
    this.storageChartLegend = false;
    this.storageChartPlugins = [];
    this.storageChartData["data"] = {
      datasets: [
        {
          data: [],
          label: "Storage",
          backgroundColor: "rgba(255,0,0,0.3)",
          borderColor: "red",
          pointBackgroundColor: "rgba(148,159,177,1)",
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
          pointHoverBorderColor: "rgba(148,159,177,0.8)",
        },
      ],
    };
    this.jobCountByDayData = {
      datasets: [
        {
          data: [],
          label: "",
          backgroundColor: "rgba(255,225,153,0.3)",
          borderColor: "gold",
          pointBackgroundColor: "rgba(148,159,177,1)",
          pointBorderColor: "#fff",
          pointHoverBackgroundColor: "#fff",
          pointHoverBorderColor: "rgba(148,159,177,0.8)",
          fill: "origin",
        },
      ],
      labels: [],
    };

    this.nodeUtilizationOptionsTotal = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0.5,
        },
      },
      scales: {
        x: {
          grid: {
            color: "rgba(255,0,0,0.1)",
            borderColor: "black",
          },
        },
        "y-axis-0": {
          position: "left",
          grid: {
            color: "rgba(255,0,0,0.1)",
            borderColor: "black",
          },
          max: 100,
          min: 0,
          title: {
            display: true,
            text: "Usage (%)"
          }
        },
      },
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 20,
            font: {
              size: 12,
            },
          },
        },
        title: {
          display: true,
          text: "Node Utilization (24 Hours)",
          position: "top",
        },
        subtitle: {
          display: true,
          text: "",
          padding: 5,
        },
        datalabels: {
          display: false,
        },
      },
    };

    this.individualNodeNetworkUtilizationChartData.datasets[0].data = [];
    this.individualNodeNetworkUtilizationChartData.datasets[1].data = [];
    this.individualNodeNetworkUtilizationChartData.labels = [];

    this.timelineChartDataByHostToShow = [];
    this.timelineChartDataByHost = [];

    this.hpcUnitsConsumedDataTotal.datasets[0].data = [];
    this.hpcUnitsConsumedDataTotal.labels = [];

    this.jobByTagsData["datasets"]?.forEach((d) => (d.data = []));
    this.jobByTagsData["labels"] = [];

    this.jobByTagsPerDayChartData["datasets"] = [];
    this.jobByTagsPerDayChartData["labels"] = [];

    this.primeNonPrimeHoursJobsSubmissionData["datasets"]?.forEach((d) => (d.data = []));
    this.primeNonPrimeHoursJobsSubmissionData["labels"] = [];

    this.runningQueuedJobsPerNodeGroupChartData["datasets"]?.forEach((d) => (d.data = []))
    this.runningQueuedJobsPerNodeGroupChartData["labels"] = [];

    this.charts?.forEach((child) => {
      child.chart?.update();
    });
  }

  sortGranularityAsPerPeriod(period: string, activeChart = null) {
    let granularity = [];
    this.disableGranularity = true;
    if (period.toLocaleLowerCase().indexOf("hr") != -1) {
      granularity = [Granularity.OneHour];
      return granularity;
    } else if (period.toLowerCase().indexOf("days") != -1) {
      let days = period.trim().slice(0, -4);
      if (parseInt(days) <= 0 && parseInt(days) > 180) {
        //this.snackbar.open("Should be between 1 to 24", "Ok", { duration: 5000 });
      } else if (parseInt(days) == 1) {
        granularity = [Granularity.OneHour];
        return granularity;
      } 
      else{
        if(activeChart){
          if([
            Graphs.RunningQueuedJobsPerNodeGroup
          ].includes(activeChart))
          {
            granularity = [Granularity.OneDay];
            return granularity;
          }
        }
        else{
          if (parseInt(days) > 1 && parseInt(days) <= 30) {
            if (parseInt(days) == 30) {
              granularity = [Granularity.OneDay, Granularity.OneWeek];
            }
            granularity = [Granularity.OneDay];
            return granularity;
          } else if (parseInt(days) > 1 && parseInt(days) >= 180) {
            granularity = [Granularity.OneMonth];
            return granularity;
          } else {
            granularity = [Granularity.OneWeek, Granularity.OneMonth];
            return granularity;
          }
        }
      }
    }
    switch (period) {
      case "1":
        granularity = [Granularity.OneHour];
        break;

      case "2":
        this.disableGranularity = false;
        granularity = [Granularity.OneHour];
        break;

      case "7":
        granularity = [Granularity.OneDay];
        break;

      case "30":
        granularity = [Granularity.OneDay, Granularity.OneWeek];
        break;

      case "90":
        granularity = [Granularity.OneWeek, Granularity.OneMonth];
        break;

      case "180":
        granularity = [Granularity.OneWeek, Granularity.OneMonth];
        break;

      case "365":
        granularity = [Granularity.OneMonth];
        break;

      default:
        granularity = [Granularity.OneDay];
        break;
    }
    return granularity;
  }

  updateGraphs() {
    this.charts.forEach((child) => {
      child.chart?.update();
    });
  }

  getMixedDepGraphs() {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    this.chartService
      .getAllCharts(this.depName, this.dateFilterValue, this.granularityValue)
      .subscribe({
        next: (data) => {
          try {
            this.spinner.hide("loadingGraphs");
            let dateFilter = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }
            this.allChartsData = JSON.parse(JSON.stringify(data));
            this.queuedJobs = this.allChartsData["queuedJobCount"];
            this.runningJobs = this.allChartsData["runningJobCount"];
            this.completedJobs = this.allChartsData["completedJobCount"];

            if (this.queuedJobs != 0) {
              this.allJobsData.datasets[0].data.push(this.queuedJobs);
            } else {
              this.allJobsData.datasets[0].data.push(null);
            }
            if (this.runningJobs != 0) {
              this.allJobsData.datasets[0].data.push(this.runningJobs);
            } else {
              this.allJobsData.datasets[0].data.push(null);
            }
            if (this.completedJobs != 0) {
              this.allJobsData.datasets[0].data.push(this.completedJobs);
            } else {
              this.allJobsData.datasets[0].data.push(null);
            }

            this.allJobsData.labels.push("Queued", "Running", "Completed");
            this.allJobsOptions = {
              responsive: false,
              plugins: {
                legend: {
                  position: "bottom",
                  labels: {
                    boxWidth: 15,
                  },
                },
                title: {
                  display: true,
                  text: `Job Status Summary - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${
                    this.dateFilterValue.includes("to") ? "" : "Days"
                  }`,
                  position: "top",
                },
                datalabels: {
                  formatter: (value) => {
                    var perc = value;
                    return perc;
                  },
                },
              },
            };

            //---------------------------------------------------------------------------------

            this.failedJobs = this.allChartsData["failedJobCount"];
            this.cancelledJobs = this.allChartsData["canceledJobCount"];
            this.succeededJobs = this.allChartsData["succeedJobCount"];
            this.jobsSummaryData.datasets[0].data.push(
              this.failedJobs,
              this.cancelledJobs,
              this.succeededJobs
            );
            this.totalJobsCompleted =
              this.failedJobs + this.cancelledJobs + this.succeededJobs;
            this.jobsSummaryData.labels.push(
              "Failed",
              "Cancelled",
              "Succeeded"
            );

            this.jobsSummaryOptions = {
              responsive: false,
              plugins: {
                legend: {
                  position: "bottom",
                  labels: {
                    boxWidth: 15,
                  },
                },
                title: {
                  display: true,
                  text:
                    "Jobs Completed : " +
                    this.totalJobsCompleted +
                    ` Jobs - ${this.dateFilterValue
                      .replace("to", " to ")
                      .replace(" days", "")} ${
                      this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                  position: "top",
                },
                datalabels: {
                  formatter: (value) => {
                    var perc = value;
                    return perc;
                  },
                },
              },
            };

            //---------------------------------------------------------------------------------

            this.jobCountPerDay = this.allChartsData["jobCountPerDay"];
            if (this.jobCountPerDay && this.jobCountPerDay.length > 0) {
              this.jobCountPerDay.forEach((x) => {
                this.jobCountByDayData.datasets[0].data.push(x?.count);
                let date;
                if (
                  dateFilter != "1" &&
                  this.dateFilterValue.indexOf("days") != -1
                ) {
                  date = formatDate(
                    new Date(x?.time),
                    "mediumDate",
                    "en-US"
                  ).split(",")[0];
                } else {
                  date = formatDate(
                    new Date(x?.time),
                    "h:mm aa",
                    "en-US"
                  ).split(")")[0];
                }
                this.jobCountByDayData.labels.push(date);
                this.jobCountByDayOptions = {
                  ...this.jobCountByDayOptions,
                  plugins: {
                    ...this.jobCountByDayOptions.plugins,
                    title: {
                      display: true,
                      position: "top",
                      text: `Total Jobs - ${this.dateFilterValue
                        .replace("to", " to ")
                        .replace(" days", "")} ${
                        this.dateFilterValue.includes("to") ? "" : "Days"
                      }`,
                    },
                  },
                };
                this.jobCountByDayData.datasets[0].label = "Total Job Submit";
                this.charts.forEach((child) => {
                  child.update();
                });
              });
            }

            //---------------------------------------------------------------------------------

            this.nodeUtilization = this.allChartsData["workstationUsage"];
            if (this.nodeUtilization && this.nodeUtilization.length > 0) {
              let uniqueDates;
              if (
                dateFilter != "1" &&
                (this.dateFilterValue.indexOf("days") != -1 ||this.dateFilterValue.includes("to"))
              ) {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map(
                      (item) =>
                        formatDate(
                          new Date(item.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0]
                    )
                  ),
                ];
              } else {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map((item) => item.timeStamp)
                  ),
                ];
              }

              this.nodeUtilization.forEach((x) => {
                if (x.officeHours == 1) {
                  this.nodeUtilizationDataOffice.datasets[0].data.push(
                    x.cpuPercent
                  );
                  this.nodeUtilizationDataOffice.datasets[1].data.push(
                    x.ramPercent
                  );
                  this.nodeUtilizationDataOffice.datasets[2].data.push(
                    x.gpuPercent
                  );
                  this.nodeUtilizationDataOffice.datasets[3].data.push(
                    x.gpuMemoryUsage
                  );
                  let date;
                  if (
                    dateFilter != "1" &&
                    (this.dateFilterValue.indexOf("days") != -1 || this.dateFilterValue.includes("to"))
                  ) {
                    date = formatDate(
                      new Date(x.timeStamp),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0];
                  } else {
                    date = formatDate(
                      new Date(x.timeStamp),
                      "h:mm aa",
                      "en-US"
                    ).split(")")[0];
                  }
                  this.nodeUtilizationDataOffice.labels.push(date);
                } else if (x.officeHours == 0) {
                  this.nodeUtilizationDataNonOffice.datasets[0].data.push(
                    x.cpuPercent
                  );
                  this.nodeUtilizationDataNonOffice.datasets[1].data.push(
                    x.ramPercent
                  );
                  this.nodeUtilizationDataNonOffice.datasets[2].data.push(
                    x.gpuPercent
                  );
                  this.nodeUtilizationDataNonOffice.datasets[3].data.push(
                    x.gpuMemoryUsage
                  );
                  let date;
                  if (
                    dateFilter != "1" &&
                    (this.dateFilterValue.indexOf("days") != -1 || this.dateFilterValue.includes("to"))
                  ) {
                    date = formatDate(
                      new Date(x.timeStamp),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0];
                  } else {
                    date = formatDate(
                      new Date(x.timeStamp),
                      "h:mm aa",
                      "en-US"
                    ).split(")")[0];
                  }
                  this.nodeUtilizationDataNonOffice.labels.push(date);
                }
              });
              uniqueDates.forEach((unq) => {
                let count = 0;
                let ramUsage = 0;
                let cpuUsage = 0;
                let gpuUsage = 0;
                let gpuMemoryUsage = 0;
                this.nodeUtilization.forEach((n) => {
                  if (
                    dateFilter != "1" &&
                    this.dateFilterValue.indexOf("days") != -1
                  ) {
                    if (
                      formatDate(
                        new Date(n.timeStamp),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0] === unq
                    ) {
                      ramUsage = ramUsage + n.ramPercent;
                      cpuUsage = cpuUsage + n.cpuPercent;
                      gpuUsage = gpuUsage + n.gpuPercent;
                      gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                      count = count + 1;
                    }
                  } else {
                    if (n.timeStamp === unq) {
                      ramUsage = ramUsage + n.ramPercent;
                      cpuUsage = cpuUsage + n.cpuPercent;
                      gpuUsage = gpuUsage + n.gpuPercent;
                      gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                      count = count + 1;
                    }
                  }
                });
                this.nodeUtilizationDataTotal.datasets[0].data.push(
                  cpuUsage / count
                );
                this.nodeUtilizationDataTotal.datasets[1].data.push(
                  ramUsage / count
                );
                this.nodeUtilizationDataTotal.datasets[2].data.push(
                  gpuUsage / count
                );
                this.nodeUtilizationDataTotal.datasets[3].data.push(
                  gpuMemoryUsage / count
                );
                let date;
                if (
                  dateFilter != "1" &&
                  (this.dateFilterValue.indexOf("days") != -1 || this.dateFilterValue.includes("to"))
                ) {
                  date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                    ","
                  )[0];
                } else {
                  date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                    ")"
                  )[0];
                }
                this.nodeUtilizationDataTotal.labels.push(date);
              });
              //this.updateGraphs();
              this.charts.forEach((child) => {
                child.update();
              });
              this.spinner.hide("loadingGraphs");
            }
          } catch (error) {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
    this.charts.forEach((child) => {
      child.update();
    });
  }

  getHostMachines() {
    this.nodeService.getAllWSNames(this.depName, "host").subscribe({
      next: (data) => {
        if (data) {
          this.hostWsNames = JSON.parse(JSON.stringify(data));
        } else {
          this.hostWsNames = [];
        }
      },
      error: (err) => {
        this.hostWsNames = [];
        console.error(err);
      },
    });
  }

  //This will display cpu,ram,gpu,gpu memory of all nodes on single page
  getAllSingleNodeSpecificChart(
    type,
    duration,
    granularity,
    toDownload?: boolean
  ) {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    let nNames = this.wsNames;
    if (type.toLowerCase() == "network") {
      this.cpuUtilizationData = {
        datasets: [
          {
            data: [],
            label: "Send",
            backgroundColor: "rgba(183, 244, 216,0.3)",
            borderColor: "lightgreen",
            pointBackgroundColor: "#e9fce9",
            pointBorderColor: "lightgreen",
            pointHoverBackgroundColor: "rgba(255, 161, 181,0.3)",
            pointHoverBorderColor: "red",
            fill: "origin",
          },
          {
            data: [],
            label: "Receive",
            backgroundColor: "rgba(255,215,0,0.3)",
            borderColor: "gold",
            pointBackgroundColor: " #fffbe6",
            pointBorderColor: "gold",
            pointHoverBackgroundColor: "rgba(255,225,153,0.3)",
            pointHoverBorderColor: "red",
            fill: "origin",
          },
        ],
      };

      this.cpuUtilizationOptions = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.5,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            ticks: {
              font: {
                size: 10,
              },
            },
          },
          "y-axis-0": {
            position: "left",
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            min: 0,
            ticks: {
              font: {
                size: 10,
              },
            },
          },
        },
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 5,
              boxHeight: 5,
              font: {
                size: 10,
              },
            },
          },
          title: {
            display: true,
            text: `Network utilization - ${this.dateFilterValue
              .replace("to", " to ")
              .replace(" days", "")} ${
              this.dateFilterValue.includes("to") ? "" : "Days"
            }`,
            position: "bottom",
          },
          datalabels: {
            display: false,
          },
        },
      };
    } else {
      this.nodeUtilizationOptionsTotal = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.5,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            ticks: {
              font: {
                size: 10,
              },
            },
          },
          "y-axis-0": {
            position: "left",
            grid: {
              color: "rgba(255,0,0,0.1)",
              borderColor: "black",
            },
            max: 100,
            min: 0,
            ticks: {
              font: {
                size: 10,
              },
            },
            title: {
              display: true,
              text: "Usage (%)"
            }
          },
        },
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 5,
              boxHeight: 5,
              font: {
                size: 10,
              },
            },
          },
          title: {
            display: true,
            text: "Node Utilization (24 Hours)",
            position: "top",
          },
          subtitle: {
            display: true,
            text: "",
            padding: 5,
          },
          datalabels: {
            display: false,
          },
        },
      };
    }
    this.chartService
      .getNodeUsage(
        this.selectedDepMetric,
        Graphs.NodeUtilization,
        this.dateFilterValue,
        this.granularityValue,
        "",
        "",
        true,
        ""
      )
      .subscribe({
        next: (data) => {
          if (data) {
            if (toDownload) {
              this.spinner.hide("loadingGraphs");
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `${Graphs.SingleNodeUtilization}-${this.selectedDepMetric}.csv`
              );
            }

            this.nodeService.getNodeDescription("all").subscribe({
              next: (data) => {
                this.nodeDescription = <NodeDescription[]>(
                  JSON.parse(JSON.stringify(data))
                );
              },
              error: (err) => {},
            });

            this.chartData = [];
            this.nodeUtilization = [];
            this.nodeUtilizationDataTotal.datasets[0].data = [];
            this.nodeUtilizationDataTotal.datasets[1].data = [];
            this.nodeUtilizationDataTotal.datasets[2].data = [];
            this.nodeUtilizationDataTotal.datasets[3].data = [];
            this.nodeUtilizationDataTotal.labels = [];
            this.nodeUtilization = <NodeUsage[]>(
              JSON.parse(JSON.stringify(data))
            );

            let dateFilter = this.dateFilterValue;
            let localthisDateFilterValue = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            if (this.dateFilterValue.toLowerCase().indexOf("to") != -1) {
              if (this.differenceInDays == 0 || this.differenceInDays == 1) {
                dateFilter = "1";
              } else {
                dateFilter = "-1";
                localthisDateFilterValue = dateFilter + " days";
              }
            }

            if (this.getRealTimeGraph) {
              if (this.nodeUtilization) {
                let temp;
                switch (type) {
                  case "cpu":
                    temp = this.cpuUtilizationOptions;
                    break;

                  case "ram":
                    temp = this.ramUtilizationOptions;
                    break;

                  case "gpu":
                    temp = this.gpuUtilizationOptions;
                    break;

                  case "network":
                    temp = this.cpuUtilizationOptions;
                    break;
                }

                //const uniqueDates = [...new Set(this.nodeUtilization.map(item => item.timeStamp))];
                let uniqueDates;
                if (!["1", "2"].includes(this.dateFilterValue)) {
                  uniqueDates = [
                    ...new Set(
                      this.nodeUtilization.map(
                        (item) =>
                          formatDate(
                            new Date(item.timeStamp),
                            "mediumDate",
                            "en-US"
                          ).split(",")[0]
                      )
                    ),
                  ];
                } else {
                  uniqueDates = [
                    ...new Set(
                      this.nodeUtilization.map((item) => item.timeStamp)
                    ),
                  ];
                }

                var filteredData = this.groupByNodes(
                  this.nodeUtilization,
                  "nodeName"
                );

                Object.keys(filteredData).forEach((key, idx) => {
                  this.cpuUtilizationData.datasets[0].data = [];
                  this.cpuUtilizationData.labels = [];

                  uniqueDates.forEach((unq) => {
                    let count = 0;
                    let ramUsage = 0;
                    let cpuUsage = 0;
                    let gpuUsage = 0;
                    let gpuMemoryUsage = 0;
                    let bytesSent = 0;
                    let bytesReceived = 0;
                    filteredData[key].forEach((n) => {
                      if (!["1", "2"].includes(this.dateFilterValue)) {
                        if (
                          formatDate(
                            new Date(n.timeStamp),
                            "mediumDate",
                            "en-US"
                          ).split(",")[0] === unq
                        ) {
                          ramUsage = ramUsage + n.ramPercent;
                          cpuUsage = cpuUsage + n.cpuPercent;
                          gpuUsage = gpuUsage + n.gpuPercent;
                          gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                          bytesReceived = bytesReceived + n.bytesReceived;
                          bytesSent = bytesSent + n.bytesSent;
                          count = count + 1;
                        }
                      } else {
                        if (n.timeStamp === unq) {
                          ramUsage = ramUsage + n.ramPercent;
                          cpuUsage = cpuUsage + n.cpuPercent;
                          gpuUsage = gpuUsage + n.gpuPercent;
                          gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                          bytesReceived = bytesReceived + n.bytesReceived;
                          bytesSent = bytesSent + n.bytesSent;
                          count = count + 1;
                        }
                      }
                    });
                    switch (type) {
                      case "cpu":
                        this.cpuUtilizationData.datasets[0].data.push(
                          cpuUsage / count
                        );
                        break;

                      case "ram":
                        this.cpuUtilizationData.datasets[0].data.push(
                          ramUsage / count
                        );
                        break;

                      case "gpu":
                        this.cpuUtilizationData.datasets[0].data.push(
                          gpuMemoryUsage / count
                        );
                        break;

                      case "network":
                        this.cpuUtilizationData.datasets[0].data.push(
                          bytesSent
                        );
                        this.cpuUtilizationData.datasets[1].data.push(
                          bytesReceived
                        );
                        break;
                    }

                    let date;
                    if (["1", "2"].includes(this.dateFilterValue)) {
                      date = formatDate(
                        new Date(unq),
                        "h:mm aa",
                        "en-US"
                      ).split(")")[0];
                    } else {
                      date = formatDate(
                        new Date(unq),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0];
                    }

                    this.cpuUtilizationData.labels.push(date);
                  });
                  if (type.toLowerCase() != "network") {
                    this.cpuUtilizationData.datasets[0].label = key;
                  } else {
                    this.cpuUtilizationData.datasets[0].label = "";
                    this.cpuUtilizationData.datasets[0].label = key + " : Sent";
                  }
                  this.chartData.push({
                    dt: structuredClone(this.cpuUtilizationData),
                    ot: structuredClone(temp),
                  });
                });
                this.spinner.hide("loadingGraphs");
                this.charts.forEach((child) => {
                  child.chart.update();
                });
              } else {
                this.spinner.hide("loadingGraphs");
                this.snackbar.open("No node utilization report found.", "OK", {
                  duration: 5000,
                });
              }
            } else {
              if (type == "network") {
                this.nodeUtilization = this.nodeUtilization?.filter((item) =>
                  this.hostWsNames?.includes(item.nodeName)
                );
              }

              let uniqueDates;
              //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
              //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
              if (
                dateFilter != "1" &&
                (this.dateFilterValue.indexOf("days") != -1 ||
                  this.dateFilterValue.indexOf("to") != -1)
              ) {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map(
                      (item) =>
                        formatDate(
                          new Date(item.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0]
                    )
                  ),
                ];
              } else {
                uniqueDates = [
                  ...new Set(
                    this.nodeUtilization.map((item) => item.timeStamp)
                  ),
                ];
              }

              var filteredData = this.groupByNodes(
                this.nodeUtilization,
                "nodeName"
              );

              Object.keys(filteredData).forEach((key, idx) => {
                //if (nNames?.indexOf(key) != -1) {
                this.nodeUtilizationDataTotal.datasets[0].data = [];
                this.nodeUtilizationDataTotal.datasets[1].data = [];
                this.nodeUtilizationDataTotal.datasets[2].data = [];
                this.nodeUtilizationDataTotal.datasets[3].data = [];
                this.nodeUtilizationDataTotal.labels = [];

                uniqueDates.forEach((unq) => {
                  let count = 0;
                  let ramUsage = 0;
                  let cpuUsage = 0;
                  let gpuUsage = 0;
                  let gpuMemoryUsage = 0;
                  let bytesSent = 0;
                  let bytesReceived = 0;
                  filteredData[key].forEach((n) => {
                    //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
                    //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                    if (
                      dateFilter != "1" &&
                      (this.dateFilterValue.indexOf("days") != -1 ||
                        this.dateFilterValue.indexOf("to") != -1)
                    ) {
                      if (
                        formatDate(
                          new Date(n.timeStamp),
                          "mediumDate",
                          "en-US"
                        ).split(",")[0] === unq
                      ) {
                        ramUsage = ramUsage + n.ramPercent;
                        cpuUsage = cpuUsage + n.cpuPercent;
                        gpuUsage = gpuUsage + n.gpuPercent;
                        gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                        bytesReceived = bytesReceived + n.bytesReceived;
                        bytesSent = bytesSent + n.bytesSent;
                        count = count + 1;
                      }
                    } else {
                      if (n.timeStamp === unq) {
                        ramUsage = ramUsage + n.ramPercent;
                        cpuUsage = cpuUsage + n.cpuPercent;
                        gpuUsage = gpuUsage + n.gpuPercent;
                        gpuMemoryUsage = gpuMemoryUsage + n.gpuMemoryUsage;
                        bytesReceived = bytesReceived + n.bytesReceived;
                        bytesSent = bytesSent + n.bytesSent;
                        count = count + 1;
                      }
                    }
                  });
                  this.nodeUtilizationDataTotal.datasets[0].data.push(
                    cpuUsage / count
                  );
                  this.nodeUtilizationDataTotal.datasets[1].data.push(
                    ramUsage / count
                  );
                  this.nodeUtilizationDataTotal.datasets[2].data.push(
                    gpuUsage / count
                  );
                  this.nodeUtilizationDataTotal.datasets[3].data.push(
                    gpuMemoryUsage / count
                  );
                  let date;
                  //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
                  //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                  if (
                    dateFilter != "1" &&
                    (this.dateFilterValue.indexOf("days") != -1 ||
                      this.dateFilterValue.indexOf("to") != -1)
                  ) {
                    date = formatDate(
                      new Date(unq),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0];
                  } else {
                    date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                      ")"
                    )[0];
                  }
                  this.nodeUtilizationDataTotal.labels.push(date);
                });
                this.nodeUtilizationOptionsTotal.plugins.title.text = "";
                this.nodeUtilizationOptionsTotal.plugins.title.text = key;
                this.nodeUtilizationOptionsTotal.plugins.subtitle.text = "";
                if (this.nodeDescription.length > 0) {
                  this.nodeUtilizationOptionsTotal.plugins.subtitle.text =
                    this.nodeDescription?.find(
                      (nd) => nd.name === key
                    )?.description;
                }
                this.chartData.push({
                  dt: structuredClone(this.nodeUtilizationDataTotal),
                  ot: structuredClone(this.nodeUtilizationOptionsTotal),
                });
              });
              this.spinner.hide("loadingGraphs");
              this.charts.forEach((child) => {
                child.chart.update();
              });
            }
          } else {
            this.chartData = [];
            this.showError = true;
            this.errorMessage = "No data available to visualize.";
            this.charts?.forEach((child) => {
              child.chart.update();
            });
          }
          this.spinner.hide("loadingGraphs");
        },
        error: (err) => {
          this.chartData = [];
          this.showError = true;
          this.errorMessage = "No data available to visualize.";
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  //To get active sessions per deployment graph
  getActiveSessionsPerDeployment(depName, toDownload?: boolean) {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    this.activeSessionsByProfileOptions = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0.5,
        },
      },
      scales: {
        x: {
          grid: {
            color: "rgba(255,0,0,0.1)",
            borderColor: "black",
          },
        },
        "y-axis-0": {
          position: "left",
          grid: {
            color: "rgba(255,0,0,0.1)",
            borderColor: "black",
          },
          min: 0,
        },
      },
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 20,
            font: {
              size: 12,
            },
          },
        },
        title: {
          display: true,
          text: `Active Sessions By Deployments - ${this.dateFilterValue
            .replace("to", " to ")
            .replace(" days", "")} ${
            this.dateFilterValue.includes("to") ? "" : "Days"
          }`,
          position: "top",
        },
        datalabels: {
          display: false,
        },
      },
    };
    this.chartService
      .getActiveSessionsPerDep(
        depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.spinner.hide("loadingGraphs");
            this.resetAllData();
            this.activeSessionsByProfileData.datasets = [];
            this.predefinedDatasets.forEach((x) => {
              x.label = "";
              x.data = [];
            });
            let dateFilter = this.dateFilterValue;
            let localthisDateFilterValue = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            if (this.dateFilterValue.toLowerCase().indexOf("to") != -1) {
              if (this.differenceInDays == 0 || this.differenceInDays == 1) {
                dateFilter = "1";
              } else {
                dateFilter = "-1";
                localthisDateFilterValue = dateFilter + " days";
              }
            }

            this.activeSessionsPerDepData = JSON.parse(JSON.stringify(data));
            this.activeSessionsPerDepData = this.activeSessionsPerDepData?.sort(
              (a, b) =>
                0 -
                (b.deploymentName.toLowerCase() < a.deploymentName.toLowerCase()
                  ? 1
                  : -1)
            );
            let uniqueDates;
            //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
            //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
            if (
              dateFilter != "1" &&
              (this.dateFilterValue.indexOf("days") != -1 ||
                this.dateFilterValue.indexOf("to") != -1)
            ) {
              uniqueDates = [
                ...new Set(
                  this.activeSessionsPerDepData.map(
                    (item) =>
                      formatDate(
                        new Date(item.entryTime),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0]
                  )
                ),
              ];
            } else {
              uniqueDates = [
                ...new Set(
                  this.activeSessionsPerDepData.map((item) => item.entryTime)
                ),
              ].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
            }

            uniqueDates = uniqueDates?.sort(
              (a, b) => new Date(a).getTime() - new Date(b).getTime()
            );

            var filteredData = this.groupByNodes(
              this.activeSessionsPerDepData,
              "deploymentName"
            );
            uniqueDates.forEach((unq) => {
              let date;
              //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
              //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
              if (
                dateFilter != "1" &&
                (this.dateFilterValue.indexOf("days") != -1 ||
                  this.dateFilterValue.indexOf("to") != -1)
              ) {
                date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                  ","
                )[0];
              } else {
                date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                  ")"
                )[0];
              }
              this.activeSessionsByProfileData.labels.push(date);
            });
            Object.keys(filteredData).forEach((key, idx) => {
              if (this.activeSessionsByProfileData.datasets.length == 0) {
                this.predefinedDatasets[idx].label = key;
                this.activeSessionsByProfileData.datasets = [
                  this.predefinedDatasets[idx],
                ];
              } else {
                this.predefinedDatasets[idx].label = key;
                this.activeSessionsByProfileData.datasets.push(
                  this.predefinedDatasets[idx]
                );
              }
              uniqueDates.forEach((unq) => {
                //if (dateFilter != '1' && this.dateFilterValue.indexOf('days') != -1) {
                //if (dateFilter != '1' && localthisDateFilterValue.indexOf('days') != -1) {
                if (
                  dateFilter != "1" &&
                  (this.dateFilterValue.indexOf("days") != -1 ||
                    this.dateFilterValue.indexOf("to") != -1)
                ) {
                  //this.activeSessionsByProfileData.datasets[idx].data.push(filteredData[key].find(obj => obj.entryTime === unq) ?? 0)
                  const foundObject = filteredData[key].find(
                    (obj) =>
                      formatDate(
                        new Date(obj.entryTime),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0] === unq
                  );
                  const activeSessions = foundObject
                    ? foundObject.activeSessions
                    : 0;
                  this.activeSessionsByProfileData.datasets[idx].data.push(
                    activeSessions
                  );
                } else {
                  //this.activeSessionsByProfileData.datasets[idx].data.push(filteredData[key].find(obj => obj.entryTime === unq) ?? 0)
                  const foundObject = filteredData[key].find(
                    (obj) => obj.entryTime === unq
                  );
                  const activeSessions = foundObject
                    ? foundObject.activeSessions
                    : 0;
                  this.activeSessionsByProfileData.datasets[idx].data.push(
                    activeSessions
                  );
                }
              });
            });

            this.spinner.hide("loadingGraphs");
            this.charts.forEach((child) => {
              child.chart.update();
            });
          } else {
            this.spinner.hide("loadingGraphs");
            this.snackbar.open("No data found to visualize", "Ok", {
              duration: 3000,
            });
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          this.snackbar.open("No data found to visualize", "Ok", {
            duration: 3000,
          });
        },
      });
  }

  uploadFiles(file) {
    let myFile: File = file;
    let message;
    let type;
    message = `graph of ${this.selectedMetric} of ${this.depName}`;
    if (this.fromDashboard) {
      switch (this.nodeGraphType) {
        case "cpu":
          type = "CPU";
          if (this.isChecked) {
            if (this.singleNodeSelectedMetric == "all") {
              type = "CPU, RAM, GPU, GPU Memory";
            }
            message = `${type} utilization of individual workstations of ${this.selectedDepMetric} deployment`;
          } else {
            message = `average CPU Utilization of all workstations of ${this.selectedDepMetric} deployment`;
          }
          break;

        case "ram":
          type = "RAM";
          if (this.isChecked) {
            if (this.singleNodeSelectedMetric == "all") {
              type = "CPU, RAM, GPU, GPU Memory";
            }
            message = `${type} utilization of individual workstations of ${this.selectedDepMetric} deployment`;
          } else {
            message = `average RAM Utilization of all workstations of ${this.selectedDepMetric} deployment`;
          }
          break;

        case "gpu":
          type = "GPU";
          if (this.isChecked) {
            if (this.singleNodeSelectedMetric == "all") {
              type = "CPU, RAM, GPU, GPU Memory";
            }
            message = `${type} utilization of individual workstations of ${this.selectedDepMetric} deployment`;
          } else {
            message = `average GPU Memory Utilization of all workstations of ${this.selectedDepMetric} deployment`;
          }
          break;

        case "activeSessionsByProfile":
          message = `active sessions of ${this.selectedDepMetric} deployment`;
          break;
      }
    } else {
      if (this.selectedDepMetric == "all") {
        message = `overview report of all deployments`;
      } else {
        if (this.selectedMetric == Graphs.SingleNodeUtilization) {
          message = `node utilization of workstation ${this.wsValue}`;
        } else if (this.selectedMetric == Graphs.NodeUtilization) {
          message = `average node utilization of all workstations of ${this.selectedDepMetric}`;
        } else if (this.selectedMetric == Graphs.SessionGraph) {
          message = `session activity graph of user ${this.userFilterValue}`;
        } else {
          message = `graph of ${this.selectedMetric} of ${this.depName}`;
        }
      }
    }

    this.chartService
      .uploadReportsFile("pdf", myFile, this.dateFilterValue, message)
      .subscribe({
        next: (event: any) => {
          this.snackbar.open("Email sent successfully.", "Ok", {
            duration: 3000,
          });
        },
        error: (err: any) => {
          this.snackbar.open("Error occurred try again.", "Ok", {
            duration: 3000,
          });
        },
      });
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${hours}-${minutes}-${seconds}`;
  }

  captureDivsAsImages(): Promise<HTMLImageElement[]> {
    const divIds = ["html2Pdf"]; // Add more div IDs if needed
    const promises: Promise<HTMLImageElement>[] = [];

    divIds.forEach((divId) => {
      const div = document.getElementById(divId);
      if (div) {
        const promise = html2canvas(div).then((canvas) => {
          const image = new Image();
          image.src = canvas.toDataURL("image/png");
          return image;
        });
        promises.push(promise);
      }
    });

    return Promise.all(promises);
  }

  capturePageAsImage(): Promise<HTMLImageElement> {
    const html = document.documentElement;
    const promises: Promise<HTMLImageElement>[] = [];

    // Calculate the total height of the page
    const totalHeight = Math.max(
      html.scrollHeight,
      html.offsetHeight,
      html.clientHeight
    );

    // Split the page into sections based on viewport height
    const sectionHeight = window.innerHeight;
    const numSections = Math.ceil(totalHeight / sectionHeight);

    // Capture each section as an image
    for (let i = 0; i < numSections; i++) {
      const promise = html2canvas(html, {
        scrollY: i * sectionHeight, // Scroll to the section
        windowWidth: window.innerWidth,
        windowHeight: sectionHeight,
        useCORS: true, // Enable CORS to capture images from external domains
      }).then((canvas) => {
        const image = new Image();
        image.src = canvas.toDataURL("image/png");
        return image;
      });

      promises.push(promise);
    }

    return Promise.all(promises).then((images) => {
      // Combine the captured images into a single canvas
      const canvas = document.createElement("canvas");
      canvas.width = window.innerWidth;
      canvas.height = totalHeight;
      const context = canvas.getContext("2d");

      let offsetY = 0;
      images.forEach((image) => {
        context.drawImage(image, 0, offsetY);
        offsetY += sectionHeight;
      });

      // Create a final image element from the combined canvas
      const finalImage = new Image();
      finalImage.src = canvas.toDataURL("image/png");
      return finalImage;
    });
  }

  getDivs(): HTMLElement[] {
    const divs = this.elementRef.nativeElement.querySelectorAll("pdfChart");
    return Array.from(divs);
  }

  async generatePdf(sendEmail) {
    this.snackbar.open(
      "Please wait while PDF is generating. It may take few minutes."
    );

    if (this.selectedMetric == Graphs.SessionGraph) {
      // Create a new jsPDF instance
      const pdf = new jsPDF("p", "mm", "a4");

      for (let i = 1; i < 3; i++) {
        let content;
        if (i == 1) {
          content = this.pdfContentSessionEndStart.nativeElement;
        } else if (i == 2) {
          content = this.pdfContentSessionConDisConnect.nativeElement;
        }

        // Get the full height of the scrollable content
        const contentHeight = content.scrollHeight;

        // Calculate the number of pages based on the content height and the PDF page height
        const pageHeight = content.clientHeight;
        const totalPages = Math.ceil(contentHeight / pageHeight);

        // Set the initial y position
        let currentPosition = 0;

        // Loop through each page and capture the content using html2canvas
        for (let i = 0; i < totalPages; i++) {
          // Scroll to the current position
          content.scrollTo(0, currentPosition);

          // Wait for a short delay to allow content to render properly
          await new Promise((resolve) => setTimeout(resolve, 500));

          // Capture the current page as an image using html2canvas
          const canvas = await html2canvas(content);
          const imgData = canvas.toDataURL("image/png");

          // Add the image to the PDF
          if (i > 0) {
            pdf.addPage();
          }
          pdf.addImage(imgData, "PNG", 10, 10, 190, 0);

          // Update the current position for the next page
          currentPosition += pageHeight;
        }
      }

      let fileName =
        this.depName +
        "_Report_" +
        this.headerService.getUserNewDate().toISOString().slice(0, 10) +
        "-" +
        this.formatTime(this.headerService.getUserNewDate()) +
        ".pdf";

      if (sendEmail) {
        const file = new File([pdf.output("blob")], fileName);
        this.uploadFiles(file);
      } else {
        // Save the PDF
        pdf.save(fileName);
      }

      this.snackbar.open(
        "Screen is captured, pdf will be downloaded soon.",
        "Ok",
        { duration: 2000 }
      );

      return;
    }

    /*
    const content = this.pdfContent.nativeElement;

    // Get the full height of the scrollable content
    const contentHeight = content.scrollHeight;

    // Calculate the number of pages based on the content height and the PDF page height
    const pageHeight = content.clientHeight;
    const totalPages = Math.ceil(contentHeight / pageHeight);

    // Create a new jsPDF instance
    const pdf = new jsPDF('p', 'mm', 'a4');

    // Set the initial y position
    let currentPosition = 0;

    // Loop through each page and capture the content using html2canvas
    for (let i = 0; i < totalPages; i++) {
      // Scroll to the current position
      content.scrollTo(0, currentPosition);

      // Wait for a short delay to allow content to render properly
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Capture the current page as an image using html2canvas
      const canvas = await html2canvas(content);
      const imgData = canvas.toDataURL('image/png');

      // Add the image to the PDF
      if (i > 0) {
        pdf.addPage();
      }
      pdf.addImage(imgData, 'PNG', 10, 10, 190, 0);

      // Update the current position for the next page
      currentPosition += pageHeight;
    }
    */
    const content = this.pdfContent.nativeElement;

    const canvas = await html2canvas(content, {
      windowWidth: content.scrollWidth,
      windowHeight: content.scrollHeight,
    });

    // Access the canvas element toDataURL or perform other actions
    const imageData = canvas.toDataURL("image/png");

    const doc = new jsPDF("p", "mm", "a2");

    doc.addImage(imageData, "PNG", 60, 20, 190, 0);

    let fileName =
      this.depName +
      "_Report_" +
      this.headerService.getUserNewDate().toISOString().slice(0, 10) +
      "-" +
      this.formatTime(this.headerService.getUserNewDate()) +
      ".pdf";

    if (sendEmail) {
      const file = new File([doc.output("blob")], fileName);
      this.uploadFiles(file);
    } else {
      // Save the PDF
      doc.save(fileName);
    }

    this.snackbar.open(
      "Screen is captured, pdf will be downloaded soon.",
      "Ok",
      { duration: 2000 }
    );
  }

  optionClicked() {
    this.disableApplyFilter = false;
    if (
      ![
        Graphs.RAMUtilization.valueOf(),
        Graphs.CPUUtilization.valueOf(),
        Graphs.GpuMemoryUtilization.valueOf(),
        Graphs.NetworkUtilization.valueOf(),
      ].includes(this.selectedMetric)
    ) {
      this.isChecked = false;
      this.showCheck = false;
    } else {
      this.showCheck = true;
      switch (this.selectedMetric) {
        case Graphs.RAMUtilization.valueOf():
          this.nodeGraphType = "ram";
          //this.singleNodeSelectedMetric = "ram";
          break;

        case Graphs.CPUUtilization.valueOf():
          this.nodeGraphType = "cpu";
          //this.singleNodeSelectedMetric = "cpu";
          break;
      }
    }

    if (Graphs.ActiveSessions.valueOf() != this.selectedMetric) {
      this.activeSessionsPerDep = false;
    } else if (Graphs.ActiveSessions.valueOf() == this.selectedMetric) {
      this.activeSessionsPerDep = true;
    }

    if (this.selectedMetric == Graphs.JobByTagsPerDay) {
      if (this.jobTags) {
        this.jobTags.forEach(() => this.tagsArray.push(new FormControl(false)));
      }
    } else if (this.selectedMetric == Graphs.JobByApplication) {
      if (this.applicationNames) {
        this.applicationNames.forEach(() =>
          this.appsArray.push(new FormControl(false))
        );
      }
    }

    if (this.selectedMetric == "SessionGraph") {
      this.userFilterFlag = false;
    } else if (this.selectedMetric === "SingleNodeUtilization") {
      if (this.wsNames.length == 0) {
        this.snackbar.open(
          "No Workstation Attached To This Deployment...",
          "Ok",
          {
            duration: 5000,
          }
        );
        return;
      } else {
        this.SingleNodeUtilizationValue = true;
      }
    } else {
      this.SingleNodeUtilizationValue = false;
    }
  }

  checkAlldDeploymentTypes() {}

  public timelineChartData: any = {
    chartType: "Timeline",
    dataTable: [[]],
    options: {
      timeline: {
        singleColor: "#818db5", // Specify the default color for all rows
        colors: ["#818db5", "#00FF00"], // Specify individual colors for each row
      },
    },
  };

  getSessionDataPerUser() {
    this.resetAllData();
    this.chartService
      .getSessionDataPerUser(
        this.selectedUser,
        "Connect-Disconnect",
        this.dateFilterValue,
        this.depName
      )
      .subscribe({
        next: (data: any) => {
          this.sessinfoPerUser = <SessionLogPerUser[]>(
            JSON.parse(JSON.stringify(data))
          );
          this.spinner.hide("loadingGraphs");
          if (!this.sessinfoPerUser) {
            this.snackbar.open("No Data Available", "Ok", { duration: 5000 });
            return;
          }

          let dateFilter = this.dateFilterValue;
          let localthisDateFilterValue = this.dateFilterValue;
          if (
            this.dateFilterValue.indexOf("hr") != -1 ||
            this.dateFilterValue.indexOf("days") != -1
          ) {
            dateFilter =
              this.dateFilterValue.indexOf("hr") != -1
                ? this.dateFilterValue.trim().slice(0, -2).trim()
                : this.dateFilterValue.trim().slice(0, -4).trim();
          }

          this.timelineChartData.dataTable = [];
          let format = "d MMM";

          if (this.dateFilterValue?.toLowerCase()?.indexOf("to") != -1) {
            dateFilter = this.differenceInDays;
          }

          let filteredData;
          const userTotalDuration: { [key: string]: string } = {};

          if (this.showUserNameAndTotalHours) {
            filteredData = this.groupByNodes(this.sessinfoPerUser, "userName");

            if (filteredData) {
              Object.keys(filteredData).forEach((key, idx) => {
                let allSumTotalSessionTime = filteredData[key].reduce(
                  (acc, obj) => acc + obj.totalTime,
                  0
                );
                if (allSumTotalSessionTime > 0) {
                  let hours = Math.floor(allSumTotalSessionTime / 60);
                  let minutes = allSumTotalSessionTime % 60;
                  userTotalDuration[key] = `${hours}:${minutes}`;
                }
              });
            }
          }

          if (Number.parseInt(dateFilter) != 1) {
            format = "d MMM";
          } else {
            format = "h:mm aa";
          }
          this.sessinfoPerUser.forEach((s) => {
            if (s.node.toLowerCase() != "na") {
              let date;
              if (s.sessionEnd == null) {
                date = this.currentDate;
              } else {
                date = s.sessionEnd;
              }
              let option = {
                hAxis: {
                  minValue: new Date(s.sessionStart).setHours(0, 0, 0, 0),
                  maxValue: new Date(s.sessionEnd).setHours(23, 59, 59, 999),
                  format: format,
                },
                timeline: {
                  singleColor: "#818db5", // Specify the default color for all rows
                  colors: ["#818db5", "#00FF00"], // Specify individual colors for each row
                },
                is3D: true,
                //height: 400,
                //width: 800,
              };

              let duration = "0";
              if (s.totalTime > 0) {
                let hours = Math.floor(s.totalTime / 60);
                let minutes = s.totalTime % 60;
                duration = `${hours}:${minutes}`;
              }

              let node = "";
              if (this.showOnlyMachineName) {
                node = s.node;
              } else if (this.showOnlyDuration) {
                node = duration;
              } else if (this.showBothMachineAndTime) {
                node = s.node + " (" + duration + " hrs)";
              }

              let userName = s.firstName + " " + s.lastName;

              if (this.showUserNameAndTotalHours) {
                let individualTotalDuration = "0";
                if (userTotalDuration[s.userName]) {
                  individualTotalDuration = userTotalDuration[s.userName];
                }
                userName =
                  s.firstName +
                  " " +
                  s.lastName +
                  " (" +
                  individualTotalDuration +
                  " hrs)";
              }

              if (
                new Date(s.sessionStart) < new Date(s.sessionEnd) ||
                s.sessionEnd == null
              ) {
                this.timelineChartData.dataTable.push([
                  userName,
                  node,
                  new Date(s.sessionStart),
                  new Date(date),
                ]);
                this.timelineChartData.options = option;
              }
            }
          });

          this.chartHeight = String(window.innerHeight * 0.6);
          this.chartWidth = String(window.innerWidth * 0.8);

          if (this.chart && this.chart.wrapper) {
            this.chart.wrapper.draw();
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          this.snackbar.open("No Data Available", "Ok", { duration: 5000 });
        },
      });
  }

  public timelineChartDataByHost: any[] = [];
  public timelineChartDataByHostToShow: any[] = [];

  getSessionDataPerUserByHost() {
    this.resetAllData();
    this.chartService
      .getSessionDataPerHost(
        "none",
        "Connect-Disconnect",
        this.dateFilterValue,
        this.depName
      )
      .subscribe({
        next: (data: any) => {
          this.timelineChartDataByHost = <SessionLogPerUser[][]>(
            JSON.parse(JSON.stringify(data))
          );
          //this.sessinfoPerUser = <SessionLogPerUser[][]>JSON.parse(JSON.stringify(data));
          this.spinner.hide("loadingGraphs");
          if (!this.timelineChartDataByHost) {
            this.snackbar.open("No Data Available", "Ok", { duration: 5000 });
            return;
          }

          this.timelineChartDataByHostToShow = [];

          this.timelineChartDataByHost.forEach((x) => {
            this.sessinfoPerUser = [];
            this.sessinfoPerUser = x?.sessionLogPerUser;
            let dateFilter = this.dateFilterValue;
            let localthisDateFilterValue = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            this.timelineChartData.dataTable = [];
            let format = "d MMM";

            if (this.dateFilterValue?.toLowerCase()?.indexOf("to") != -1) {
              dateFilter = this.differenceInDays;
            }

            let filteredData;
            const userTotalDuration: { [key: string]: string } = {};

            if (this.showUserNameAndTotalHours) {
              filteredData = this.groupByNodes(
                this.sessinfoPerUser,
                "userName"
              );

              if (filteredData) {
                Object.keys(filteredData).forEach((key, idx) => {
                  let allSumTotalSessionTime = filteredData[key].reduce(
                    (acc, obj) => acc + obj.totalTime,
                    0
                  );
                  if (allSumTotalSessionTime > 0) {
                    let hours = Math.floor(allSumTotalSessionTime / 60);
                    let minutes = allSumTotalSessionTime % 60;
                    userTotalDuration[key] = `${hours}:${minutes}`;
                  }
                });
              }
            }

            if (Number.parseInt(dateFilter) != 1) {
              format = "d MMM";
            } else {
              format = "h:mm aa";
            }
            this.sessinfoPerUser.forEach((s) => {
              if (s.node.toLowerCase() != "na") {
                let date;
                if (s.sessionEnd == null) {
                  date = this.currentDate;
                } else {
                  date = s.sessionEnd;
                }
                let option = {
                  hAxis: {
                    minValue: new Date(s.sessionStart).setHours(0, 0, 0, 0),
                    maxValue: new Date(s.sessionEnd).setHours(23, 59, 59, 999),
                    format: format,
                  },
                  timeline: {
                    singleColor: "#818db5", // Specify the default color for all rows
                    colors: ["#818db5", "#00FF00"], // Specify individual colors for each row
                  },
                  is3D: true,
                  //height: 400,
                  //width: 800,
                };

                let duration = "0";
                if (s.totalTime > 0) {
                  let hours = Math.floor(s.totalTime / 60);
                  let minutes = s.totalTime % 60;
                  duration = `${hours}:${minutes}`;
                }

                let node = "";
                if (this.showOnlyMachineName) {
                  node = s.node;
                } else if (this.showOnlyDuration) {
                  node = duration;
                } else if (this.showBothMachineAndTime) {
                  node = s.node + " (" + duration + " hrs)";
                }

                let userName = s.firstName + " " + s.lastName;

                if (this.showUserNameAndTotalHours) {
                  let individualTotalDuration = "0";
                  if (userTotalDuration[s.userName]) {
                    individualTotalDuration = userTotalDuration[s.userName];
                  }
                  userName =
                    s.firstName +
                    " " +
                    s.lastName +
                    " (" +
                    individualTotalDuration +
                    " hrs)";
                }

                if (
                  new Date(s.sessionStart) < new Date(s.sessionEnd) ||
                  s.sessionEnd == null
                ) {
                  this.timelineChartData.dataTable.push([
                    userName,
                    node,
                    new Date(s.sessionStart),
                    new Date(date),
                  ]);
                  this.timelineChartData.options = option;
                }
              }
            });
            this.timelineChartDataByHostToShow.push({
              title: structuredClone(x.hostName),
              data: structuredClone(this.timelineChartData),
            });
            //this.timelineChartDataByHostToShow.push(structuredClone(this.timelineChartData))
          });

          this.chartHeight = String(window.innerHeight * 0.3);
          this.chartWidth = String(window.innerWidth * 0.8);

          if (this.chart && this.chart.wrapper) {
            this.chart.wrapper.draw();
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          this.snackbar.open("No Data Available", "Ok", { duration: 5000 });
        },
      });
  }

  public nodeStatusTimelineChartData: any = {
    chartType: "Timeline",
    dataTable: [[]],
    options: {
      timeline: {},
    },
  };

  getNodeStatusGraph() {
    this.resetAllData();
    this.chartService
      .getNodeStatusGraphService(
        this.selectedUser,
        "Connect-Disconnect",
        this.dateFilterValue,
        this.depName
      )
      .subscribe({
        next: (data: any) => {
          this.nodeStatusList = <NodeStartStopStatus[]>(
            JSON.parse(JSON.stringify(data))
          );
          this.spinner.hide("loadingGraphs");
          if (!this.nodeStatusList) {
            this.snackbar.open("No Data Available", "Ok", { duration: 5000 });
            return;
          }

          let dateFilter = this.dateFilterValue;
          let localthisDateFilterValue = this.dateFilterValue;
          if (
            this.dateFilterValue.indexOf("hr") != -1 ||
            this.dateFilterValue.indexOf("days") != -1
          ) {
            dateFilter =
              this.dateFilterValue.indexOf("hr") != -1
                ? this.dateFilterValue.trim().slice(0, -2).trim()
                : this.dateFilterValue.trim().slice(0, -4).trim();
          }

          this.nodeStatusTimelineChartData.dataTable = [];
          let format = "d MMM";

          if (this.dateFilterValue?.toLowerCase()?.indexOf("to") != -1) {
            dateFilter = this.differenceInDays;
          }

          if (Number.parseInt(dateFilter) != 1) {
            format = "d MMM";
          } else {
            format = "h:mm aa";
          }
          this.nodeStatusList.forEach((s) => {
            if (s.vmName.toLowerCase() != "na") {
              let date;
              if (s.updateTime == null) {
                date = new Date(this.currentDate).setSeconds(
                  new Date(this.currentDate).getSeconds() + 60
                );
              } else {
                date = s.updateTime;
              }
              let option = {
                hAxis: {
                  minValue: new Date(s.entryTime).setHours(0, 0, 0, 0),
                  maxValue: new Date(s.updateTime).setHours(23, 59, 59, 999),
                  format: format,
                },
                timeline: {
                  //singleColor: '#818db5', // Specify the default color for all rows
                  colors: ["#818db5", "#00FF00"], // Specify individual colors for each row
                },
                is3D: true,
                //height: 400,
                //width: 800,
              };

              let node = "";
              node = s.vmName;
              let status;
              status = s.status;
              if (
                new Date(s.entryTime) < new Date(s.updateTime) ||
                s.updateTime == null
              ) {
                this.nodeStatusTimelineChartData.dataTable.push([
                  node,
                  status,
                  new Date(s.entryTime),
                  new Date(date),
                ]);
                this.nodeStatusTimelineChartData.options = option;
              }
            }
          });

          this.chartHeight = String(window.innerHeight * 0.6);
          this.chartWidth = String(window.innerWidth * 0.8);

          if (this.chart && this.chart.wrapper) {
            this.chart.wrapper.draw();
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          this.snackbar.open("No Data Available", "Ok", { duration: 5000 });
        },
      });
  }

  manageActiveChartType() {
    let avlChartTypes = [];
    switch (this.selectedMetric) {
      case Graphs.CoreUsage:
      case Graphs.StorageUsage:
      case Graphs.JobDataCount:
      case Graphs.NodeAvailability:
        avlChartTypes.unshift("Line");
        break;

      case Graphs.JobByApplication:
      case Graphs.JobByNodes:
      case Graphs.JobByUser:
      case Graphs.JobByTags:
      case Graphs.CoresByApplication:
        avlChartTypes = ["Bar"];
        break;

      case Graphs.CoreHoursByUsers:
      case Graphs.CoreHoursByGroups:
        avlChartTypes.unshift("Bar", "Pie");
        avlChartTypes.pop();
        break;

      case Graphs.JobCompleted:
      case Graphs.JobSummary:
        avlChartTypes = ["Pie"];
        break;

      case Graphs.JobWaitTime:
      case Graphs.JobByGroup:
        avlChartTypes = ["Doughnut"];
        break;

      default:
        avlChartTypes = ["Bar"];
        break;
    }

    this.activeChartType = avlChartTypes![0]?.toLowerCase();
    this.availableChartTypes = avlChartTypes;
  }

  minThreshold: number = 10;
  getDataLabelUsableValue(data: any, minThreshold: number = 10): number {
    if (!data || data.length == 0) {
      return minThreshold;
    }
    let maxNum = Math.max(
      data.reduce((acc, val) => {
        return acc + val;
      }, 0)
    );
    let usableNum = maxNum / 35;
    return usableNum > minThreshold ? usableNum : minThreshold;
  }

  loadCoreHoursByGroups(toDownload?: boolean) {
    let gNames = this.myForm.value?.userGroupNames?.map((un) => un.item_text);
    if (gNames.length == 0) {
      this.snackbar.open("Please select minimum 1 user to proceed.", "Ok", {
        duration: 4000,
      });
      this.spinner.hide("loadingGraphs");
    }
    this.chartService
      .getCoreHoursByGroupsData(
        this.depName,
        this.dateFilterValue,
        gNames.join(",")
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          //this.loadTabularData(JSON.parse(JSON.stringify(data)));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.CoreHoursByGroups}-${this.depName}.csv`
            );
          }
          this.coreHoursByGroupsPieData.datasets[0].data = [];
          this.coreHoursByGroupsPieData.labels = [];
          this.coreHoursByGroupsChartData.datasets[0].data = [];
          this.coreHoursByGroupsChartData.labels = [];
          this.coreHoursByGroupsChartData.datasets[0].backgroundColor = [];
          let coreHourByGroups = <CoreHoursByGroups[]>(
            JSON.parse(JSON.stringify(data))
          );
          coreHourByGroups = coreHourByGroups.sort(
            (a, b) => b.totalCores - a.totalCores
          );
          let limit = 15;
          let Groups = coreHourByGroups.map((x, i) => {
            if (i < limit) return x.groupName;
          });
          let colors = [];
          coreHourByGroups.forEach((job, i) => {
            if (i < limit) {
              this.coreHoursByGroupsChartData.datasets[0].data.push(
                job.totalCores
              );
              this.coreHoursByGroupsPieData.datasets[0].data.push(
                job.totalCores
              );
              this.coreHoursByGroupsChartData.labels.push(job.groupName);
              this.coreHoursByGroupsPieData.labels.push(job.groupName);
              colors.push(this.getDynamicColor());
            }
          });
          if (coreHourByGroups.length > limit) {
            this.coreHoursByGroupsChartData.datasets[0].data.push(
              coreHourByGroups
                .slice(limit)
                .reduce((acc, curr) => acc + curr.totalCores, 0)
            );
            this.coreHoursByGroupsPieData.datasets[0].data.push(
              coreHourByGroups
                .slice(limit)
                .reduce((acc, curr) => acc + curr.totalCores, 0)
            );
            this.coreHoursByGroupsChartData.labels.push("Others");
            this.coreHoursByGroupsPieData.labels.push("Others");
            colors.push(this.getDynamicColor());
          }
          this.coreHoursByGroupsChartData.datasets[0].backgroundColor =
            "#0072c6";
          this.coreHoursByGroupsChartData.datasets[0].hoverBackgroundColor =
            "#0072c6";

          this.coreHoursByGroupsPieColors = [
            {
              backgroundColor: colors,
            },
          ];

          this.coreHoursByGroupsChartOptions = {
            ...this.coreHoursByGroupsChartOptions,
            plugins: {
              ...this.coreHoursByGroupsChartOptions,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Groups - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${
                  this.dateFilterValue.includes("to") ? "" : "Days"
                }`,
              },
            },
          };
          this.coreHoursByGroupsPieOptions = {
            ...this.coreHoursByGroupsPieOptions,
            plugins: {
              ...this.coreHoursByGroupsPieOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Core Hours By Groups - ${this.dateFilterValue.replace("to", " to ").replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"}`,
              },
            }
          };

          this.updateGraphs();
        },
        error: (err) => {},
      });
  }

  getHpcUnitsConsumedGraph(toDownload?: boolean) {
    this.resetAllData();
    this.spinner.show("loadingGraphs");
    this.chartService
      .getHpcUnitsConsumed(
        this.depName,
        "HpcUnitsConsumed",
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.spinner.hide("loadingGraphs");
            this.hpcUnitsConsumedDataTotal.datasets[0].data = [];
            this.hpcUnitsConsumedDataTotal.labels = [];

            let hpcUnitsConsumedData: any;

            hpcUnitsConsumedData = JSON.parse(JSON.stringify(data));
            hpcUnitsConsumedData = hpcUnitsConsumedData?.sort(
              (a, b) =>
                0 -
                (b.deploymentName.toLowerCase() < a.deploymentName.toLowerCase()
                  ? 1
                  : -1)
            );
            hpcUnitsConsumedData = hpcUnitsConsumedData?.sort(
              (a, b) =>
                new Date(a?.entryTime)?.getTime() -
                new Date(b?.entryTime)?.getTime()
            );

            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                hpcUnitsConsumedData,
                headers,
                `${Graphs.HpcUnitsConsumed}-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
            }

            let dateFilter = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
              dateFilter =
                this.dateFilterValue.indexOf("hr") != -1
                  ? this.dateFilterValue.trim().slice(0, -2).trim()
                  : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            let uniqueDates;
            if (
              dateFilter != "1" &&
              (this.dateFilterValue.indexOf("days") != -1 ||
                this.dateFilterValue.indexOf("to") != -1)
            ) {
              uniqueDates = [
                ...new Set(
                  hpcUnitsConsumedData?.map(
                    (item) =>
                      formatDate(
                        new Date(item.entryTime),
                        "mediumDate",
                        "en-US"
                      ).split(",")[0]
                  )
                ),
              ];
            } 
            else {
              uniqueDates = [
                ...new Set(hpcUnitsConsumedData.map((item) => item.entryTime)),
              ];
            }

            //if (uniqueDates) {
            //  uniqueDates = uniqueDates?.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
            //}

            var filteredData = this.groupByNodes(
              hpcUnitsConsumedData,
              "entryTime"
            );
            uniqueDates.forEach((unq) => {
              let date;
              if (
                dateFilter != "1" &&
                this.dateFilterValue.indexOf("days") != -1
              ) {
                date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                  ","
                )[0];
              }
              else if(this.dateFilterValue.indexOf("to") != -1){
                date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                  ","
                )[0];
              } 
              else {
                date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                  ")"
                )[0];
              }
              this.hpcUnitsConsumedDataTotal.labels.push(date);
            });

            const sortedKeys = Object.keys(filteredData)?.sort();

            sortedKeys?.forEach((key, idx) => {
              let units: any = 0;
              units = filteredData[key].reduce(
                (accumulator, currentValue) =>
                  accumulator + currentValue.hpcUnitsUsed,
                0
              );

              this.hpcUnitsConsumedDataTotal.datasets[0].data.push(units);
            });

            this.hpcUnitsConsumedOptions = {
              ...this.hpcUnitsConsumedOptions,
              plugins: {
                ...this.hpcUnitsConsumedOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `HPC Units Consumed - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                    }`,
                  },
                datalabels: {
                  display: true,
                  anchor: "end",
                  align: "top",
                }
              },
            };

            this.spinner.hide("loadingGraphs");
            this.updateGraphs();
          } else {
            this.spinner.hide("loadingGraphs");
            this.snackbar.open("No data found to visualize", "Ok", {
              duration: 3000,
            });
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
          this.snackbar.open("No data found to visualize", "Ok", {
            duration: 3000,
          });
        },
      });
  }

  cpuUsageByNodes(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.CpuUsageByNodes,
        this.dateFilterValue,
        this.granularityValue,
        "",
        "",
        true,
        ""
      )
      .subscribe({
        next: (data) => {
          try {
          this.nodeUtilization = [];

          this.cpuUsageByNodesChartData.datasets.forEach((d) => (d.data = []));
          this.cpuUsageByNodesChartData.labels = [];

          let cpuUsageByNodesData = JSON.parse(JSON.stringify(data));

          this.spinner.hide("loadingGraphs");

          var filteredData = this.groupByNodes(cpuUsageByNodesData, "nodeName");

          let totalCpuUsagePer: any = 0;
          let denomenator = 1;

          if (this.dateFilterValue == "1") {
            denomenator = 24;
          } else {
          }

          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobsPerApp = filteredData[key].reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.cpuPercent,
              0
            );

            if (filteredData[key]?.length) {
              denomenator = filteredData[key]?.length;
            }

            this.cpuUsageByNodesChartData.datasets[0].data[idx] = 0;

            let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
            totalCpuUsagePer += averageCpuPer;

            this.cpuUsageByNodesChartData.datasets[0].data[idx] = averageCpuPer;

            this.cpuUsageByNodesChartData.labels.push(
              key + " : " + averageCpuPer + " %"
            );
          });

          totalCpuUsagePer =
            totalCpuUsagePer / Object.keys(filteredData).length;
          totalCpuUsagePer = Number.isInteger(totalCpuUsagePer)
            ? totalCpuUsagePer
            : totalCpuUsagePer.toFixed(2);

          if (toDownload) {
            let headers = ["Node", "CPUPercent", "Total"];
            let downloadData = this.createObjectArray(
              Object.keys(filteredData),
              this.cpuUsageByNodesChartData.datasets[0].data,
              totalCpuUsagePer
            );
            this.downloadCsv(
              downloadData,
              headers,
              `${Graphs.CpuUsageByNodes}-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }

          this.cpuUsageByNodesChartData.datasets[0].data.push(totalCpuUsagePer);
          this.cpuUsageByNodesChartData.labels.push(
            "Total " + totalCpuUsagePer + " %"
          );

          this.cpuUsageByNodesChartOptions = {
            ...this.cpuUsageByNodesChartOptions,
            plugins: {
              title: {
                display: true,
                position: "top",
                text: `CPU Usage By Nodes - ${this.dateFilterValue.replace(
                  "to",
                  " to "
                )}`,
              },
            },
          };
          this.spinner.hide("loadingGraphs");
          this.chart?.update();
          }
          catch (error) {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  createObjectArray(
    keys: any[],
    values: any[],
    total
  ): { name: string; percent: any; total: any }[] {
    if (keys.length !== values.length) {
      console.error("Arrays must have the same length");
      return [];
    }

    return keys.map((key, index) => ({
      name: key,
      percent: values[index],
      total: total,
    }));
  }

  cpuUsageByNodeGroups(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.CpuUsageByNodeGroups,
        this.dateFilterValue,
        this.granularityValue,
        "",
        "",
        true,
        ""
      )
      .subscribe({
        next: (data) => {
          try {
          this.nodeUtilization = [];
          this.cpuUsageByNodeGroupsChartData.datasets.forEach(
            (d) => (d.data = [])
          );
          this.cpuUsageByNodeGroupsChartData.labels = [];

          let cpuUsageByNodesData = JSON.parse(JSON.stringify(data));

          var filteredData = this.groupByNodes(
            cpuUsageByNodesData,
            "nodeGroup"
          );

          let totalCpuUsagePer: any = 0;

          let denomenator = 1;

          if (this.dateFilterValue == "1") {
            denomenator = 24;
          } else if (this.dateFilterValue?.toString()?.indexOf("to") != -1) {
            denomenator = 7;
          } else {
            denomenator = +this.dateFilterValue;
          }

          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobsPerApp = filteredData[key].reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.cpuPercent,
              0
            );

            if (filteredData[key]?.length) {
              denomenator = filteredData[key]?.length;
            }

            let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
            totalCpuUsagePer += averageCpuPer;

            this.cpuUsageByNodeGroupsChartData.datasets[0].data[idx] =
              averageCpuPer;

            this.cpuUsageByNodeGroupsChartData.labels.push(
              key + " : " + averageCpuPer + " %"
            );
          });

          totalCpuUsagePer =
            totalCpuUsagePer / Object.keys(filteredData).length;
          totalCpuUsagePer = Number.isInteger(totalCpuUsagePer)
            ? totalCpuUsagePer
            : totalCpuUsagePer.toFixed(2);

          if (toDownload) {
            let headers = ["Node Group", "Cpu Percent", "Total"];
            let downloadData = this.createObjectArray(
              Object.keys(filteredData),
              this.cpuUsageByNodeGroupsChartData.datasets[0].data,
              totalCpuUsagePer
            );
            this.downloadCsv(
              downloadData,
              headers,
              `${Graphs.CpuUsageByNodeGroups}-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }

          this.cpuUsageByNodeGroupsChartData.datasets[0].data.push(
            totalCpuUsagePer
          );
          this.cpuUsageByNodeGroupsChartData.labels.push(
            "Total " + totalCpuUsagePer + " %"
          );

          this.cpuUsageByNodeGroupsChartOptions = {
            ...this.cpuUsageByNodeGroupsChartOptions,
            plugins: {
              title: {
                display: true,
                position: "top",
                text: `CPU Usage By Node Groups - ${this.dateFilterValue.replace(
                  "to",
                  " to "
                )}`,
              },
            },
          };
          this.spinner.hide("loadingGraphs");
          this.chart?.update();
          }
          catch (error) {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  coreUsageByNodes(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.CoreUsageByNodes,
        this.dateFilterValue,
        this.granularityValue,
        "",
        "",
        true,
        ""
      )
      .subscribe({
        next: (data) => {
          try {
          this.nodeUtilization = [];

          this.coreUsageByNodesChartData.datasets.forEach((d) => (d.data = []));
          this.coreUsageByNodesChartData.labels = [];

          let coreUsageByNodesData = JSON.parse(JSON.stringify(data));
          var filteredData = this.groupByNodes(
            coreUsageByNodesData,
            "nodeName"
          );

          let totalCoreUsagePer: any = 0;
          let denomenator = 1;

          if (this.dateFilterValue == "1") {
            denomenator = 24;
          } else if (this.dateFilterValue?.toString()?.indexOf("to") != -1) {
            //denomenator = 7
            denomenator = this.calculateDaysDifference(this.dateFilterValue);
            if (denomenator == null) {
              denomenator = 7;
            } else if (denomenator == 1 || denomenator == 0) {
              denomenator = 24;
            }
          } else {
            if (this.dateFilterValue?.toLowerCase().indexOf("days") != -1) {
              denomenator = +this.dateFilterValue?.replace("days", "");
            } else if (
              this.dateFilterValue?.toLowerCase().indexOf("hr") != -1
            ) {
              denomenator = +this.dateFilterValue?.replace("hr", "");
            }

            if (denomenator == 1 || denomenator == 0) {
              denomenator = 24;
            }
          }

          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobsPerApp = filteredData[key].reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.coreUsagePercentage,
              0
            );

            if (filteredData[key]?.length) {
              denomenator = filteredData[key]?.length;
            }

            this.coreUsageByNodesChartData.datasets[0].data[idx] = 0;

            let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
            totalCoreUsagePer += averageCpuPer;

            this.coreUsageByNodesChartData.datasets[0].data[idx] =
              averageCpuPer;

            this.coreUsageByNodesChartData.labels.push(
              key + " : " + averageCpuPer + " %"
            );
          });

          totalCoreUsagePer =
            totalCoreUsagePer / Object.keys(filteredData).length;
          totalCoreUsagePer = Number.isInteger(totalCoreUsagePer)
            ? totalCoreUsagePer
            : totalCoreUsagePer.toFixed(2);

          if (toDownload) {
            let headers = ["Node", "Core Usage", "Total"];
            let downloadData = this.createObjectArray(
              Object.keys(filteredData),
              this.coreUsageByNodesChartData.datasets[0].data,
              totalCoreUsagePer
            );
            this.downloadCsv(
              downloadData,
              headers,
              `${Graphs.CoreUsageByNodes}-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }

          this.coreUsageByNodesChartData.datasets[0].data.push(
            totalCoreUsagePer
          );
          this.coreUsageByNodesChartData.labels.push(
            "Total " + totalCoreUsagePer + " %"
          );

          this.coreUsageByNodesChartOptions = {
            ...this.coreUsageByNodesChartOptions,
            plugins: {
              title: {
                display: true,
                position: "top",
                text: `Core Usage By Nodes - ${this.dateFilterValue.replace(
                  "to",
                  " to "
                )}`,
              },
            },
          };
            this.spinner.hide("loadingGraphs");
          this.chart?.update();
          }
          catch (error) {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  coreUsageByNodeGroups(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getNodeUsage(
        this.depName,
        Graphs.CoreUsageByNodeGroups,
        this.dateFilterValue,
        this.granularityValue,
        "",
        "",
        true,
        ""
      )
      .subscribe({
        next: (data) => {
          try {
          this.nodeUtilization = [];

          this.coreUsageByNodeGroupsChartData.datasets.forEach(
            (d) => (d.data = [])
          );
          this.coreUsageByNodeGroupsChartData.labels = [];

          let coreUsageByNodesData = JSON.parse(JSON.stringify(data));

          this.spinner.hide("loadingGraphs");

          var filteredData = this.groupByNodes(
            coreUsageByNodesData,
            "nodeGroup"
          );

          let totalCoreUsagePer: any = 0;

          let denomenator = 1;

          if (this.dateFilterValue == "1") {
            denomenator = 24;
          } else if (this.dateFilterValue?.toString()?.indexOf("to") != -1) {
            //denomenator = 7
            denomenator = this.calculateDaysDifference(this.dateFilterValue);
            if (denomenator == null) {
              denomenator = 7;
            } else if (denomenator == 1 || denomenator == 0) {
              denomenator = 24;
            }
          } else {
            if (this.dateFilterValue?.toLowerCase().indexOf("days") != -1) {
              denomenator = +this.dateFilterValue?.replace("days", "");
            } else if (
              this.dateFilterValue?.toLowerCase().indexOf("hr") != -1
            ) {
              denomenator = +this.dateFilterValue?.replace("hr", "");
            }

            if (denomenator == 1 || denomenator == 0) {
              denomenator = 24;
            }
          }

          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobsPerApp = filteredData[key].reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.coreUsagePercentage,
              0
            );

            if (filteredData[key]?.length) {
              denomenator = filteredData[key]?.length;
            }

            let averageCpuPer = Math.round(totalJobsPerApp / +denomenator);
            totalCoreUsagePer += averageCpuPer;

            this.coreUsageByNodeGroupsChartData.datasets[0].data[idx] =
              averageCpuPer;

            this.coreUsageByNodeGroupsChartData.labels.push(
              key + " : " + averageCpuPer + " %"
            );
          });

          totalCoreUsagePer =
            totalCoreUsagePer / Object.keys(filteredData).length;
          totalCoreUsagePer = Number.isInteger(totalCoreUsagePer)
            ? totalCoreUsagePer
            : totalCoreUsagePer.toFixed(2);

          if (toDownload) {
            let headers = ["Node Group", "Cpu Percent", "Total"];
            let downloadData = this.createObjectArray(
              Object.keys(filteredData),
              this.coreUsageByNodeGroupsChartData.datasets[0].data,
              totalCoreUsagePer
            );
            this.downloadCsv(
              downloadData,
              headers,
              `${Graphs.CoreUsageByNodeGroups}-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }

          this.coreUsageByNodeGroupsChartData.datasets[0].data.push(
            totalCoreUsagePer
          );
          this.coreUsageByNodeGroupsChartData.labels.push(
            "Total " + totalCoreUsagePer + " %"
          );

          this.coreUsageByNodeGroupsChartOptions = {
            ...this.coreUsageByNodeGroupsChartOptions,
            plugins: {
              title: {
                display: true,
                position: "top",
                text: `Core Usage By Node Groups - ${this.dateFilterValue.replace(
                  "to",
                  " to "
                )}`,
              },
            },
          };
          this.spinner.hide("loadingGraphs");
          this.chart?.update();
          }
          catch (error) {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  parseDate(dateStr: string): Date | null {
    const [day, month, year] = dateStr.split("-").map(Number);
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return null;
    }
    return new Date(Date.UTC(2000 + year, month - 1, day)); // Months are zero-based
  }

  calculateDaysDifference(dateRange: string): number | null {
    const dateRegex = /^(\d{2}-\d{2}-\d{2})to(\d{2}-\d{2}-\d{2})$/;

    // Check if the input string matches the expected format
    const match = dateRange?.trim().match(dateRegex);
    if (!match) {
      console.error("Invalid date range format");
      return null;
    }

    const startDate = this.parseDate(match[1]);
    const endDate = this.parseDate(match[2]);

    if (!startDate || !endDate) {
      console.error("Invalid date format in date range");
      return null;
    }

    // Calculate the difference in milliseconds
    const timeDifference = endDate.getTime() - startDate.getTime();

    // Convert the difference to days
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    return Math.abs(daysDifference); // Taking absolute value to handle negative differences
  }

  loadJobByNodeGroup(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.chartService
      .getJobByNodeGroupData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide("loadingGraphs");
          this.jobByNodesData["datasets"].forEach((d) => (d.data = []));
          let jobByNodesData: JobByNodesI[] = JSON.parse(JSON.stringify(data));
          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `${Graphs.JobByNodeGroup}-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }
          let soloNodes: JobByNodesI[] = jobByNodesData.filter(
            (n) => !n.jobAllocatedNodes.includes(",")
          );
          let multiNodes: JobByNodesI[] = jobByNodesData.filter((n) =>
            n.jobAllocatedNodes.includes(",")
          );
          multiNodes.forEach((element) => {
            element.jobAllocatedNodes.split(",").forEach((node) => {
              soloNodes.push({ ...element, jobAllocatedNodes: node });
            });
          });
          jobByNodesData = soloNodes;

          var filteredData = this.groupByNodes(
            jobByNodesData,
            "jobAllocatedNodes"
          );
          this.jobByNodesData["labels"] = [];
          Object.keys(filteredData).forEach((key, idx) => {
            let totalJobs = 0;
            this.jobByNodesData["datasets"][0].data[idx] = 0;
            this.jobByNodesData["datasets"][1].data[idx] = 0;
            this.jobByNodesData["datasets"][2].data[idx] = 0;
            filteredData[key].forEach((e) => {
              if (e.jobStageStatus == 1) {
                this.jobByNodesData["datasets"][1].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 5) {
                this.jobByNodesData["datasets"][2].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              } else if (e.jobStageStatus == 11) {
                this.jobByNodesData["datasets"][0].data[idx] += e.totalCount;
                totalJobs = totalJobs + e.totalCount;
              }
            });
            this.jobByNodesData["labels"].push(key + " : " + totalJobs);
          });
          this.jobByNodesOptions = {
            ...this.jobByNodesOptions,
            scales: {
              x: {
                title:{
                  display: true,
                  text: "Node Groups"
                }
              },
              y: {
                beginAtZero: true,
                title:{
                  display: true,
                  text: "Number of Jobs"
                }
              },
            },
            plugins: {
              ...this.jobByNodesOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job By Node Groups - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                  }`,
              },
            },
          };
          this.updateGraphs();
          this.spinner.hide("loadingGraphs");
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  loadAvgJobDurationsByDayData(toDownload?: boolean) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getAvgJobDurationsByDayService(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          try {
            this.jobDurationsByDayData["datasets"].forEach(
              (d) => (d.data = [])
            );
            this.jobDurationsByDayData["datasets"].length = 4;
            let jobData = JSON.parse(JSON.stringify(data));
            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `${Graphs.JobDurationsByDay}-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
              return;
            }

            this.jobDurationsByDayData["labels"] = [];

            if (jobData) {
              jobData.forEach((x) => {
                this.jobDurationsByDayData["datasets"][0].data.push(
                  x?.totalRunTime
                );
                this.jobDurationsByDayData["datasets"][1].data.push(
                  x?.totalWaitTime
                );
                this.jobDurationsByDayData["datasets"][2].data.push(
                  x?.avgRunTime
                );
                this.jobDurationsByDayData["datasets"][3].data.push(
                  x?.avgWaitTime
                );

                let date;
                date = formatDate(
                  new Date(x?.timeStamp),
                  "mediumDate",
                  "en-US"
                ).split(",")[0];
                this.jobDurationsByDayData["labels"].push(date);
              });

              this.jobDurationsByDayData["datasets"][2].hidden = true;
              this.jobDurationsByDayData["datasets"][3].hidden = true;
            }

            if (this.jobDurationsByDayData["datasets"]) {
              this.jobDurationsByDayData["datasets"].forEach(
                (dataset, index) => {
                  const avgData = new Array(
                    this.jobDurationsByDayData["labels"]?.length
                  ).fill(
                    dataset.data
                      ?.map((d) => d)
                      ?.reduce((sum: any, current: any) => sum + current, 0) /
                      dataset.data.length
                  );

                  this.jobDurationsByDayData["datasets"].push({
                    data: avgData,
                    type: "line",
                    label: `${dataset.label} Mean`,
                    borderColor: this.jobDurationsByDayBarColors![index],
                    borderDash: [8, 10],
                    fill: false,
                    hidden: dataset.hidden,
                  });
                }
              );
            }

            if (this.jobDurationsByDayOptions) {
              // Add plugin to update averages on visibility change
              this.jobDurationsByDayOptions!.plugins!.legend = {
                ...this.jobDurationsByDayOptions!.plugins!.legend,
                onClick: (event: ChartEvent, legendItem: any, legend: any) => {
                  const index = legendItem.datasetIndex;
                  const ci = legend.chart;
                  const meta = ci.getDatasetMeta(index);

                  // Toggle the visibility
                  meta.hidden =
                    meta.hidden === null
                      ? !ci.data.datasets[index].hidden
                      : null;

                  // If this is a main dataset, also toggle its average
                  const avgIndex = this.jobDurationsByDayData[
                    "datasets"
                  ]?.findIndex((ds) => ds.label == `${legendItem.text} Mean`);
                  if (avgIndex !== -1) {
                    const avgMeta = ci.getDatasetMeta(avgIndex);
                    avgMeta.hidden = meta.hidden;
                  }

                  // Update the chart
                  ci.update();
                },
              };
            }

            let showLabels = false;
            try {
              showLabels = this.dateFilterValue
                ? parseInt(this.dateFilterValue.split(" ")[0].trim()) <= 15
                : false;
            } catch (ex) {
              showLabels = false;
            }

            this.jobDurationsByDayOptions = {
              ...this.jobDurationsByDayOptions,
              plugins: {
                ...this.jobDurationsByDayOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job Duration by day - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${
                    this.dateFilterValue.includes("to") ? "" : "Days"
                  }`,
                },
                datalabels: {
                  formatter: Math.round,
                  display: (context) => {
                    if (showLabels) {
                      return (
                        +context.dataset.data[context.dataIndex] >
                          this.getDataLabelUsableValue(
                            this.jobDurationsByDayData.datasets[0].data
                          ) &&
                        +context.dataset.data[context.dataIndex] >
                          this.getDataLabelUsableValue(
                            this.jobDurationsByDayData.datasets[1].data
                          )
                      );
                    } else {
                      return false;
                    }
                  },
                },
              },
            };
            this.updateGraphs();
            this.spinner.hide("loadingGraphs");
          } catch (ex) {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  createGraphDataLabelForm() {
    this.graphDataLabelsForm = new FormGroup({
      jobCountSubmitted: new FormControl(false),
      jobCountSucceeded: new FormControl(false),
      jobCountCancelled: new FormControl(false),
      jobCountFailed: new FormControl(false),
      storageUsage: new FormControl(false),
      coresByApplication: new FormControl(false),
      jobByTagsPerDayForm: this.fb.array([]),
      jobByApplicationPerDayForm: this.fb.array([]),
      allNodeGroupsForm: this.fb.array([])
    });
    this.graphDataLabelsForm.valueChanges.subscribe((val) => {
      this.charts.forEach((child) => {
        child?.chart ? child?.chart?.update() : child?.update();
      });
    });
  }

  showDataLabelOptions() {
    if (
      [
        "StorageUsage",
        "JobDataCount",
        "CoresByApplication",
        "JobByTagsPerDay",
        "JobByApplication",
        "RunningQueuedJobsPerNodeGroup"
      ].includes(this.selectedMetric)
    ) {
      return true;
    }
    return false;
  }

  get tagsArray() {
    return this.graphDataLabelsForm.controls[
      "jobByTagsPerDayForm"
    ] as FormArray;
  }

  get appsArray() {
    return this.graphDataLabelsForm.controls[
      "jobByApplicationPerDayForm"
    ] as FormArray;
  }

  get getNodeGroupsArray() {
    return this.graphDataLabelsForm.controls['allNodeGroupsForm'] as FormArray;
  }

  loadJobByTagsPerDayData(toDownload?: boolean, index: number = -1) {
    this.resetAllData();
    let allTagNames = this.myForm.value?.jobTags?.map((gn) => gn.item_text);
    if (allTagNames?.length == 0) {
      this.snackbar.open("Please select minimum 1 tag to proceed.", "Ok", {
        duration: 4000,
      });
      this.spinner.hide("loadingGraphs");
      return;
    }
    this.selectedJobTags = this.myForm.value?.jobTags?.filter(
      (gn) => gn.item_text
    );
    this.spinner.show("loadingGraphs");
    this.chartService
      .getJobByTagsPerDayData(
        this.depName,
        this.dateFilterValue,
        this.granularityValue,
        allTagNames?.toString()
      )
      .subscribe({
        next: (data) => {
          try {
            this.jobByTagsPerDayChartData["datasets"] = [];
            this.jobByTagsPerDayChartData["labels"] = [];
            let jobByTagsData: JobByTagsPerDayI[] = JSON.parse(
              JSON.stringify(data)
            );
            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `JobByNodeGroupByInterval-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
            }
            var filteredData = this.groupByNodes(jobByTagsData, "timeStamp");

            allTagNames.forEach((name, index) => {
              if (index != allTagNames.length) {
                this.jobByTagsPerDayChartData["datasets"].push({
                  data: [],
                  label: name,
                  order: 1,
                  fill: false,
                  radius: 3,
                  hoverBackgroundColor: "#0072c6",
                });
              }
            });
            Object.keys(filteredData).forEach((key, idx) => {
              if (filteredData[key]) {
                allTagNames.forEach((name, index) => {
                  const count = filteredData[key]
                    .filter(
                      (tag) => tag.tag.toLowerCase() == name.toLowerCase()
                    )
                    .map((x) => x.totalCount)[0];
                  if (count) {
                    this.jobByTagsPerDayChartData["datasets"][index].data[idx] =
                      count;
                  } else {
                    this.jobByTagsPerDayChartData["datasets"][index].data[
                      idx
                    ] = 0;
                  }
                });
              }

              if (key) {
                let date;
                let dateFilter = this.dateFilterValue;
                if (
                  dateFilter != "1" &&
                  (this.dateFilterValue.indexOf("days") != -1 ||
                    this.dateFilterValue.indexOf("to") != -1)
                ) {
                  date = formatDate(new Date(key), "mediumDate", "en-US").split(
                    ","
                  )[0];
                } else {
                  date = formatDate(new Date(key), "h:mm aa", "en-US").split(
                    ")"
                  )[0];
                }
                if (date) {
                  this.jobByTagsPerDayChartData["labels"].push(date);
                } else {
                  this.jobByTagsPerDayChartData["labels"].push(key);
                }
              }
            });

            let showLabels = true;
            if (allTagNames.length > 3) {
              showLabels = false;
            }

            this.jobByTagsPerDayChartOptions = {
              ...this.jobByTagsPerDayChartOptions,
              plugins: {
                ...this.jobByTagsPerDayChartOptions.plugins,
                title: {
                  display: true,
                  position: "top",
                  text: `Job By Tags By Interval - ${this.dateFilterValue
                    .replace("to", " to ")
                    .replace(" days", "")} ${
                    this.dateFilterValue.includes("to") ? "" : "Days"
                  }`,
                },
                datalabels: {
                  display: showLabels,
                  anchor: "end",
                  align: "end", 
                },
              },
            };
            this.jobByTagsPerDayChartDataTemp = JSON.parse(
              JSON.stringify(this.jobByTagsPerDayChartData)
            );
            this.updateGraphs();
            this.spinner.hide("loadingGraphs");
          } catch (ex) {
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  tagChanged(value: boolean, index: number) {
    if (value) {
      // this will disable all values except checked one
      this.tagsArray.controls.forEach((control, i) => {
        if (i !== index) {
          control.disable();
        }
      });
      this.selectedJobTag = this.selectedJobTags[index].item_text;
      this.jobByTagsPerDayChartData["datasets"] =
        this.jobByTagsPerDayChartDataTemp["datasets"].filter(
          (x) => x.label == this.selectedJobTag
        );
      this.jobByTagsPerDayChartOptions = {
        ...this.jobByTagsPerDayChartOptions,
        plugins: {
          ...this.jobByTagsPerDayChartOptions.plugins,
          datalabels: {
            display: true,
            anchor: "end",
            align: "end",
          },
        },
      };
      this.updateGraphs();
    } else {
      // This will enable all values
      this.tagsArray.controls.forEach((control) => {
        control.enable();
      });
      this.jobByTagsPerDayChartData["datasets"] =
        this.jobByTagsPerDayChartDataTemp["datasets"];
      let showLabels = true;
      if (this.jobByTagsPerDayChartData["datasets"].length > 3) {
        showLabels = false;
      }

      this.jobByTagsPerDayChartOptions = {
        ...this.jobByTagsPerDayChartOptions,
        plugins: {
          ...this.jobByTagsPerDayChartOptions.plugins,
          datalabels: {
            display: showLabels,
            anchor: "end",
            align: "end",
          },
        },
      };
      this.updateGraphs();
    }
  }

  appsChanged(value: boolean, index: number) {
    if (value) {
      // this will disable all values except checked one
      this.appsArray.controls.forEach((control, i) => {
        if (i !== index) {
          control.disable();
        }
      });
      let appNameSelected = this.applicationNames[index];
      this.jobByApplicationData["datasets"] =
        this.jobByApplicationsPerDayChartData["datasets"].filter(
          (x) => x.label == appNameSelected
        );
      this.jobByApplicationData["labels"] =
        this.jobByApplicationsPerDayChartData["labels"];
      this.jobByApplicationOptions = {
        ...this.jobByApplicationOptions,
        scales:{
          ...this.jobByApplicationOptions.scales,
          x: {
            title:{
              display: true,
              text: "Date"
            }
          },
        },
        plugins: {
          ...this.jobByApplicationOptions.plugins,
          datalabels: {
            display: true,
          },
        },
      };
      this.updateGraphs();
    } else {
      // This will enable all values
      this.appsArray.controls.forEach((control) => {
        control.enable();
      });
      this.jobByApplicationData["datasets"] =
        this.jobByApplicationDataTemp["datasets"];
      this.jobByApplicationData["labels"] =
        this.jobByApplicationDataTemp["labels"];

      this.jobByApplicationOptions = {
        ...this.jobByApplicationOptions,
        scales:{
          ...this.jobByApplicationOptions.scales,
          x: {
            title:{
              display: true,
              text: "Applications"
            }
          },
        },
        plugins: {
          ...this.jobByApplicationOptions.plugins,
          datalabels: {
            display: true,
          },
        },
      };
      this.updateGraphs();
    }
  }
  
  getDateRangeString(): string {
    if (this.dateTimePeriod.value[0] && this.dateTimePeriod.value[1]) {
      const start = new Date(this.dateTimePeriod.value[0]);
      const end = new Date(this.dateTimePeriod.value[1]);
      return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
    }
    return 'Custom';
  }

  onDateRangeChange(): void {
    this.dateFilterValue = this.getDateRangeString();
  }

  onOptionClick(event: any) {
    if (event !== 'custom') {
      this.dateFilterValue = event;
      this.showDateRangePicker = false;
    }
  }
  
  updateChartDataLabel() {
    this.charts.forEach((child) => {
      child.chart.update();
    });
    // this.chart?.update();
  }

  loadRunningQueuedJobsPerNodeGroupsData(toDownload?: boolean, index: number = -1) {
    this.spinner.show("loadingGraphs");
    this.resetAllData();
    this.chartService
      .getRunningAndQueuedJobs(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          try {
            this.runningQueuedJobsPerNodeGroupChartData["datasets"] = [];
            this.runningQueuedJobsPerNodeGroupChartData["labels"] = [];
            let jobData: RunningQueuedJobsPerNodeGroup[] = JSON.parse(JSON.stringify(data));

            if (toDownload) {
              let headers = Object.keys(data[0]);
              this.downloadCsv(
                data,
                headers,
                `JobByNodeGroupByInterval-${this.depName}.csv`
              );
              this.spinner.hide("loadingGraphs");
            }

            let allTags = [];
            if(jobData){
              const uniqueNamesSet = new Set(jobData.map(job => job.partitionName));
              allTags = Array.from(uniqueNamesSet);
            }

            var filteredData = this.groupByNodes(jobData, "entryTime");

            let dateFilter = this.dateFilterValue;
            if (
              this.dateFilterValue.indexOf("hr") != -1 ||
              this.dateFilterValue.indexOf("days") != -1
            ) {
            dateFilter =
              this.dateFilterValue.indexOf("hr") != -1
                ? this.dateFilterValue.trim().slice(0, -2).trim()
                : this.dateFilterValue.trim().slice(0, -4).trim();
            }

            if(allTags) {
              allTags.forEach((name, index) => {
                if(index != allTags.length){

                  const customColor = this.getColorForPartition(name);
                  const lightenColor = this.lightenRGBString(customColor, 50);

                  this.runningQueuedJobsPerNodeGroupChartData["datasets"].push({
                    data: [],
                    label: name + " - Running",
                    order: 1,
                    fill: false,
                    radius: 3,
                    borderColor: customColor,
                    pointBackgroundColor: customColor
                  })
                  this.runningQueuedJobsPerNodeGroupChartData["datasets"].push({
                    data: [],
                    label: name + " - Queued",
                    order: 1,
                    fill: false,
                    radius: 3,
                    borderColor: lightenColor,
                    borderDash: [10, 5],
                    pointBackgroundColor: lightenColor,
                  })
                }
              })

              this.selectedNodeGroups = allTags;
              this.selectedNodeGroups?.forEach(() => this.getNodeGroupsArray.push(this.fb.control(false)));

              Object.keys(filteredData).forEach((key, idx) => {
                if(filteredData[key]){
                  allTags.forEach((name, index) => {
                    const runCount = filteredData[key].filter(job => job.partitionName.toLowerCase() == name.toLowerCase()).map(x => x?.runningJobs)[0]
                    if(runCount){
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][2 * index].data[idx] = runCount;
                    }
                    else{
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][2 * index].data[idx] = 0;
                    }

                    const queueCount = filteredData[key].filter(job => job.partitionName.toLowerCase() == name.toLowerCase()).map(x => x?.queuedJobs)[0]
                    if(queueCount){
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][(2 * index) + 1]!.data[idx] = queueCount;
                    }
                    else{
                      this.runningQueuedJobsPerNodeGroupChartData["datasets"][(2 * index) + 1]!.data[idx] = 0;
                    }
                  })
                }
  
                if (key) {
                  let date;

                  if (
                    dateFilter != "1" &&
                    this.dateFilterValue.indexOf("days") != -1
                  ) {
                    date = formatDate(new Date(key), "mediumDate", "en-US").split(
                      ","
                    )[0];
                  }
                  else if(this.dateFilterValue.indexOf("to") != -1){
                    date = formatDate(new Date(key), "mediumDate", "en-US").split(
                      ","
                    )[0];
                  }  
                  else {
                    date = formatDate(new Date(key), "h:mm aa", "en-US").split(
                      ")"
                    )[0];
                  }

                  if (date) {
                    this.runningQueuedJobsPerNodeGroupChartData["labels"].push(date);
                  }
                  else {
                    this.runningQueuedJobsPerNodeGroupChartData["labels"].push(key);
                  }
                }
              });

              this.runningQueuedJobsPerNodeGroupChartOptions = {
                ...this.runningQueuedJobsPerNodeGroupChartOptions,
                plugins: {
                  ...this.runningQueuedJobsPerNodeGroupChartOptions.plugins,
                  title: {
                    display: true,
                    position: "top",
                    text: `Job By Node Group By Interval - ${this.dateFilterValue
                      .replace("to", " to ")
                      .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                      }`,
                    },
                    datalabels: {
                      display: false
                    }
                },
              };
              this.runningQueuedJobsPerNodeGroupDataTemp = JSON.parse(JSON.stringify(this.runningQueuedJobsPerNodeGroupChartData));
              this.updateGraphs();
              this.spinner.hide("loadingGraphs");
            }
  
          }
          catch (ex) {
            this.snackbar.open("Some error occurred !","Ok", { duration: 3000 })
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.snackbar.open("Some error occurred !","Ok", { duration: 3000 })
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  getColorForPartition(partitionName) {
    const hash = partitionName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const r = (hash * 97) % 255;
    const g = (hash * 43) % 255;
    const b = (hash * 67) % 255;
    return `rgb(${r}, ${g}, ${b})`;
  }

  lightenRGBString(rgbString: string, percent: number): string {
    // Extract the RGB values from the string using a regular expression
    const regex = /rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)/;
    const result = regex.exec(rgbString);

    if (!result) {
        return rgbString;
    }

    // Convert extracted strings to numbers
    const r = parseInt(result[1], 10);
    const g = parseInt(result[2], 10);
    const b = parseInt(result[3], 10);

    // Ensure percent is within valid range
    const p = Math.min(100, Math.max(0, percent)) / 100;

    // Calculate the lighter RGB values
    const newR = Math.round(r + (255 - r) * p);
    const newG = Math.round(g + (255 - g) * p);
    const newB = Math.round(b + (255 - b) * p);

    // Return the lighter RGB color as a string
    return `rgb(${newR}, ${newG}, ${newB})`;
  } 

  getPrimeNonPrimeHoursJobSubmissions(toDownload?: boolean) {
    this.resetAllData();
    this.chartService
      .getPrimeNonPrimeJobCount(
        this.depName,
        this.dateFilterValue,
        this.granularityValue
      )
      .subscribe({
        next: (data) => {
          try{
            let jobsData = <PrimeNonPrimeHoursJobs[]>JSON.parse(JSON.stringify(data));
          this.spinner.hide("loadingGraphs");

          if (toDownload) {
            let headers = Object.keys(data[0]);
            this.downloadCsv(
              data,
              headers,
              `JobByWorkingHours-${this.depName}.csv`
            );
            this.spinner.hide("loadingGraphs");
          }

          let dateFilter = this.dateFilterValue;
          if (
            this.dateFilterValue.indexOf("hr") != -1 ||
            this.dateFilterValue.indexOf("days") != -1
          ) {
            dateFilter =
              this.dateFilterValue.indexOf("hr") != -1
                ? this.dateFilterValue.trim().slice(0, -2).trim()
                : this.dateFilterValue.trim().slice(0, -4).trim();
          }

          let uniqueDates;
          if (
            dateFilter != "1" &&
            (this.dateFilterValue.indexOf("days") != -1 ||
              this.dateFilterValue.indexOf("to") != -1)
          ) {
            uniqueDates = [
              ...new Set(
                jobsData?.map(
                  (item) =>
                    formatDate(
                      new Date(item.timeStamp),
                      "mediumDate",
                      "en-US"
                    ).split(",")[0]
                )
              ),
            ];
          } 
          else {
            uniqueDates = [
              ...new Set(jobsData.map((item) => item.timeStamp)),
            ];
          }

          uniqueDates.forEach((unq) => {
            let date;
            if (
              dateFilter != "1" &&
              this.dateFilterValue.indexOf("days") != -1
            ) {
              date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                ","
              )[0];
            }
            else if(this.dateFilterValue.indexOf("to") != -1){
              date = formatDate(new Date(unq), "mediumDate", "en-US").split(
                ","
              )[0];
            } 
            else {
              date = formatDate(new Date(unq), "h:mm aa", "en-US").split(
                ")"
              )[0];
            }
            this.primeNonPrimeHoursJobsSubmissionData.labels.push(date);
          });

          jobsData.forEach((x) => {
            this.primeNonPrimeHoursJobsSubmissionData.datasets[0].data.push(x.officeHoursJobSubmits);
            this.primeNonPrimeHoursJobsSubmissionData.datasets[1].data.push(x.nonOfficeHoursJobSubmits);
          });

          this.primeNonPrimeHoursJobsSubmissionOptions = {
            ...this.primeNonPrimeHoursJobsSubmissionOptions,
            plugins: {
              ...this.primeNonPrimeHoursJobsSubmissionOptions.plugins,
              title: {
                display: true,
                position: "top",
                text: `Job Submit Count By Working Hours - ${this.dateFilterValue
                  .replace("to", " to ")
                  .replace(" days", "")} ${this.dateFilterValue.includes("to") ? "" : "Days"
                  }`,
                },
              datalabels: {
                display: true,
                anchor: "end",
                align: "top",
              }
            },
          };

          this.updateGraphs();
          }
          catch(ex){
            this.snackbar.open("Some error occurred !","Ok", { duration: 3000 })
            this.spinner.hide("loadingGraphs");
          }
        },
        error: (err) => {
          this.snackbar.open("Some error occurred !","Ok", { duration: 3000 })
          this.spinner.hide("loadingGraphs");
        },
      });
  }

  nodeGroupChanged(value: boolean, index: number, nodeGroup: string){
    if (value) {
      // this will disable all values except checked one
      this.getNodeGroupsArray.controls.forEach((control, i) => {
        if (i !== index) {
          control.disable();
        }
      });
      this.runningQueuedJobsPerNodeGroupChartData["datasets"] = this.runningQueuedJobsPerNodeGroupDataTemp["datasets"].filter((x) => x.label == nodeGroup + " - Running" || x.label == nodeGroup + " - Queued");
      this.runningQueuedJobsPerNodeGroupChartOptions = {
        ...this.runningQueuedJobsPerNodeGroupChartOptions,
        plugins: {
          ...this.runningQueuedJobsPerNodeGroupChartOptions.plugins,
          datalabels: {
            display: true,
            anchor: "end",
            align: "end",
  }
        },
      };
      this.updateGraphs()
    } else {
      // This will enable all values
      this.getNodeGroupsArray.controls.forEach((control) => {
        control.enable();
      });
      this.runningQueuedJobsPerNodeGroupChartData["datasets"] = this.runningQueuedJobsPerNodeGroupDataTemp["datasets"];
      let showLabels = true;

      this.runningQueuedJobsPerNodeGroupChartOptions = {
        ...this.runningQueuedJobsPerNodeGroupChartOptions,
        plugins: {
          ...this.runningQueuedJobsPerNodeGroupChartOptions.plugins,
          datalabels: {
            display: false,
          }
        },
      };
      this.updateGraphs()
    }
  }
}
